'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var material = require('@mui/material');
var styles = require('@mui/material/styles');
var Tick24 = require('@evocolabs/icons/lib/Tick24');
var ArrowRight24 = require('@evocolabs/icons/lib/ArrowRight24');
var ArrowRightSmall24 = require('@evocolabs/icons/lib/ArrowRightSmall24');
var Edit24 = require('@evocolabs/icons/lib/Edit24');
var WarningCircle24 = require('@evocolabs/icons/lib/WarningCircle24');
var InputAdornment = require('@mui/material/InputAdornment');
var ChevronDownSmall24 = require('@evocolabs/icons/lib/ChevronDownSmall24');
var Markdown = require('markdown-to-jsx');
var ArrowLeft24 = require('@evocolabs/icons/lib/ArrowLeft24');
var ChevronLeft24 = require('@evocolabs/icons/lib/ChevronLeft24');
var ChevronRightSmall24 = require('@evocolabs/icons/lib/ChevronRightSmall24');
var Tooltip = require('@mui/material/Tooltip');
var Close24 = require('@evocolabs/icons/lib/Close24');
var Coupon24 = require('@evocolabs/icons/lib/Coupon24');
var Letter64 = require('@evocolabs/icons/lib/Letter64');
var MUIDrawer = require('@mui/material/Drawer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Tick24__default = /*#__PURE__*/_interopDefaultLegacy(Tick24);
var ArrowRight24__default = /*#__PURE__*/_interopDefaultLegacy(ArrowRight24);
var ArrowRightSmall24__default = /*#__PURE__*/_interopDefaultLegacy(ArrowRightSmall24);
var Edit24__default = /*#__PURE__*/_interopDefaultLegacy(Edit24);
var WarningCircle24__default = /*#__PURE__*/_interopDefaultLegacy(WarningCircle24);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var ChevronDownSmall24__default = /*#__PURE__*/_interopDefaultLegacy(ChevronDownSmall24);
var Markdown__default = /*#__PURE__*/_interopDefaultLegacy(Markdown);
var ArrowLeft24__default = /*#__PURE__*/_interopDefaultLegacy(ArrowLeft24);
var ChevronLeft24__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeft24);
var ChevronRightSmall24__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRightSmall24);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var Close24__default = /*#__PURE__*/_interopDefaultLegacy(Close24);
var Coupon24__default = /*#__PURE__*/_interopDefaultLegacy(Coupon24);
var Letter64__default = /*#__PURE__*/_interopDefaultLegacy(Letter64);
var MUIDrawer__default = /*#__PURE__*/_interopDefaultLegacy(MUIDrawer);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var palette = {
  primary: {
    main: '#415670',
    800: '#1E2E45',
    700: '#30445E',
    600: '#415670',
    500: '#506A8A',
    400: '#849CB8',
    300: '#B5C3D4',
    200: '#DAE1EA',
    100: '#EFF1F5'
  },
  secondary: {
    main: '#8A755B',
    800: '#5E4C38',
    700: '#73604A',
    600: '#8A755B',
    500: '#9E8B70',
    400: '#BDA98C',
    300: '#E0D4BF',
    200: '#EBE2D3',
    100: '#FAF7F3'
  },
  grey: {
    main: '#26201F',
    800: '#26201F',
    700: '#393432',
    600: '#4E4947',
    500: '#756F6E',
    400: '#918D8C',
    300: '#B8B6B5',
    200: '#E5E4E3',
    100: '#F3F3F3'
  },
  error: {
    main: '#B8554D',
    500: '#7A2F29',
    400: '#A33F37',
    300: '#CC4F45',
    200: '#F0BAB6',
    100: '#FAE7E6'
  },
  white: {
    main: '#FFFFFF',
    warm: '#FCFAF7',
    cold: '#FAFCFC',
    white: '#FFFFFF'
  },
  illustration: {
    main: '#415066',
    auxiliary: '#DFE5F0',
    dotted: '#F2B844'
  },
  textPrimary: {
    main: '#272727',
    white: '#FFFFFF',
    black: '#000000'
  },
  textSecondary: {
    main: 'grey',
    white: 'rgba(255, 255, 255, 0.7)',
    black: 'rgba(0, 0, 0, 0.5)'
  },
  textDisabled: {
    main: 'grey',
    white: 'rgba(255, 255, 255, 0.7)',
    black: 'rgba(0, 0, 0, 0.25)'
  },
  multicolor: {
    300: '#C79F50',
    200: '#FAE1AF',
    100: '#F7F3EB',
    yellow: {
      300: '#906716',
      200: '#CC9A39',
      100: '#CC9A39'
    },
    green: {
      300: '#008A5E',
      200: '#12B883',
      100: '#E6F3EF'
    }
  },
  opacityLayer: {
    dark: {
      400: '#FFFFFF80',
      300: '#FFFFFF59',
      200: '#FFFFFF33',
      100: '#00000026'
    },
    light: {
      400: '#00000080',
      300: '#0000004D',
      200: '#00000033',
      100: '#0000001A'
    }
  },
  shadow: '#E8E8E8'
};
palette.gray = palette.grey;
var fontFamily = 'Open Sans';
var theme = styles.createTheme({
  palette: palette,
  fontFamily: fontFamily,
  spacing: function spacing(value) {
    return value * 8;
  },
  breakpoints: {
    // which is also defined in orkaui.scss
    values: {
      xs: 0,
      sm: 600,
      // Phone-Max
      md: 905,
      // Tablet-Max
      dl: 1024,
      // Desktop-Max
      lg: 1538,
      // PC-Max
      xl: 1920
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans',
          color: palette.textPrimary.main,
          fontSize: '12px'
        },
        colorError: {
          color: palette.error.main
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
          '&:hover': {
            color: palette.primary.main
          }
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.2)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        },
        elevation1: {
          boxShadow: 'none',
          '&:before': {
            display: 'none'
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: 'FFFFFF',
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '18px',
          letterSpacing: '-0.15px',
          borderRadius: '10px'
        }
      }
    },
    MuiExpansionPanel: {
      styleOverrides: {
        root: {
          marginBottom: 16
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          marginBottom: 16
        }
      }
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: '24px 0'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem'
        }
      }
    }
  }
});
theme.components.MuiTypography.styleOverrides = {
  root: {
    fontFamily: 'Open Sans',
    padding: 0,
    paddingTop: 0,
    paddingBottom: 0,
    WebkitFontSmoothing: 'antialiased',
    textAlign: 'left'
  },
  h1: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '48px',
    lineHeight: '64px',
    letterSpacing: '0.2px'
  }, theme.breakpoints.down('sm'), {
    fontSize: '40px',
    lineHeight: '52px'
  }),
  h2: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '40px',
    lineHeight: '52px',
    letterSpacing: '0'
  }, theme.breakpoints.down('sm'), {
    fontSize: '32px',
    lineHeight: '42px'
  }),
  h3: _defineProperty({
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '32px',
    lineHeight: '44px',
    letterSpacing: '0'
  }, theme.breakpoints.down('sm'), {
    fontSize: '24px',
    lineHeight: '32px'
  }),
  h4: {
    fontFamily: 'Merriweather',
    fontWeight: 900,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0'
  },
  T1: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.4px'
  },
  T2: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  t1: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '-0.4px'
  },
  t2: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  Body1: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  body1: {
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.2px'
  },
  Body2: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px'
  },
  body2: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px'
  },
  Body3: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px'
  },
  body3: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px'
  },
  Body4: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  body4: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  },
  Body5: {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0'
  },
  body5: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0'
  },
  BUTTON: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '-0.6px'
  },
  Button: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px'
  },
  LINK: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  Link: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  link: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px',
    textDecorationLine: 'underline',
    cursor: 'pointer'
  },
  info: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.2px'
  }
}; // Typography alias

var styleOverrides = theme.components.MuiTypography.styleOverrides; // for deprecated

styleOverrides['subh1'] = styleOverrides['Body2'];
styleOverrides['subh2'] = styleOverrides['Body3'];
styleOverrides['link1'] = styleOverrides['Link'];
styleOverrides['link2'] = styleOverrides['link'];
styleOverrides['caption'] = styleOverrides['body4']; // for convinence

styleOverrides['title1'] = styleOverrides['T1'];
styleOverrides['title2'] = styleOverrides['T2'];
styleOverrides['subtitle1'] = styleOverrides['t1'];
styleOverrides['subtitle2'] = styleOverrides['t2'];
styleOverrides['botton-l'] = styleOverrides['BUTTON'];
styleOverrides['botton-m'] = styleOverrides['Button'];
styleOverrides['botton-s'] = styleOverrides['Button'];
styleOverrides['button'] = styleOverrides['Button'];
styleOverrides['link-l'] = styleOverrides['LINK'];
styleOverrides['link-m'] = styleOverrides['Link'];
styleOverrides['link-s'] = styleOverrides['link'];

var _excluded$h = ["textAlign", "sx"];

function OUITypography(_ref) {
  var textAlign = _ref.textAlign,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$h);

  var useMobile = material.useMediaQuery(theme.breakpoints.down('sm'));

  if (!textAlign) {
    textAlign = 'left';
  } else if (textAlign === 'auto') {
    if (!useMobile) textAlign = 'left';else textAlign = 'center';
  }

  return /*#__PURE__*/React__default["default"].createElement(styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default["default"].createElement(material.Typography, _extends({
    sx: _objectSpread2({
      textAlign: textAlign
    }, sx)
  }, props)));
}

var _excluded$g = ["svg", "width", "height", "forceFill", "forceStroke", "replaceColor", "replaceFillColor", "replaceStrokeColor"];
var widthRegExp = /svg width="[0-9]+(?=")/;
var heightRegExp = /height="[0-9]+(?=" viewBox)/;
var widthRegExpPrefix = "svg width=\"";
var heightRegExpPrefix = "height=\"";

var SvgParser = function SvgParser(_ref) {
  var svg = _ref.svg,
      width = _ref.width,
      height = _ref.height,
      forceFill = _ref.forceFill,
      forceStroke = _ref.forceStroke,
      replaceColor = _ref.replaceColor,
      replaceFillColor = _ref.replaceFillColor,
      replaceStrokeColor = _ref.replaceStrokeColor,
      props = _objectWithoutProperties(_ref, _excluded$g);

  /**
   * Get an svg in html string format, return an div with svg inside.
   * @param {String} svg: the svg file in string format
   * @param {String | Number} width: width with no unit
   * @param {String | Number} height: height with no unit
   * @return {node}
   */
  if (width && height) {
    // both width and height are provided
    svg = svg.replace(widthRegExp, widthRegExpPrefix + width);
    svg = svg.replace(heightRegExp, heightRegExpPrefix + height);
  } else if (width && !height) {
    // only width is provided, height is scaled proportionally
    var scale = width / svg.match(widthRegExp)[0];
    height = svg.match(heightRegExp)[0] * scale;
    svg = svg.replace(widthRegExp, widthRegExpPrefix + width);
    svg = svg.replace(heightRegExp, heightRegExpPrefix + height);
  } else if (!width && height) {
    // only height is provided, width is scaled proportionally
    var _scale = height / svg.match(heightRegExp)[0].substring(heightRegExpPrefix.length);

    width = svg.match(widthRegExp)[0].substring(widthRegExpPrefix.length) * _scale;
    svg = svg.replace(widthRegExp, widthRegExpPrefix + width);
    svg = svg.replace(heightRegExp, heightRegExpPrefix + height);
  } // else do nothing


  svg = svg.replace('xmlns="http://www.w3.org/2000/svg"', 'xmlns="http://www.w3.org/2000/svg" style="display: block"');

  if (forceFill) {
    svg = svg.replace(/fill=".*?"/g, "fill=\"".concat(forceFill, "\""));
  }

  if (forceStroke) {
    svg = svg.replace(/stroke=".*?"/g, "stroke=\"".concat(forceStroke, "\""));
  }

  if (replaceColor) {
    replaceColor.forEach(function (item) {
      var _item = _slicedToArray(item, 2),
          fromColor = _item[0],
          toColor = _item[1];

      svg = svg.replaceAll("fill=\"".concat(fromColor, "\""), "fill=\"".concat(toColor, "\""));
      svg = svg.replaceAll("stroke=\"".concat(fromColor, "\""), "stroke=\"".concat(toColor, "\""));
    });
  }

  if (replaceFillColor) {
    replaceFillColor.forEach(function (item) {
      var _item2 = _slicedToArray(item, 2),
          fromColor = _item2[0],
          toColor = _item2[1];

      svg = svg.replaceAll("fill=\"".concat(fromColor, "\""), "fill=\"".concat(toColor, "\""));
    });
  }

  if (replaceStrokeColor) {
    replaceStrokeColor.forEach(function (item) {
      var _item3 = _slicedToArray(item, 2),
          fromColor = _item3[0],
          toColor = _item3[1];

      svg = svg.replaceAll("stroke=\"".concat(fromColor, "\""), "stroke=\"".concat(toColor, "\""));
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: _objectSpread2({
      display: 'inline-block'
    }, props.style),
    dangerouslySetInnerHTML: {
      __html: svg
    },
    sx: props.sx
  });
};

var svg_enlarge = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M22.8977 33.121L26.6019 29.7626L31.0798 34.7015L33.5492 32.4625L29.0713 27.5236L32.7755 24.1652L21.1197 21.2348L22.8977 33.121ZM17.1028 6.87905L13.3986 10.2375L8.92069 5.2986L6.45124 7.53756L10.9292 12.4765L7.22499 15.8349L18.321 18.148L17.1028 6.87905Z\" fill=\"white\" fill-opacity=\"0.6\"/>\n</svg>";

var svg_enlarge_active = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M18.8216 30.6066L15.286 27.0711L20.0001 22.357L17.643 20L12.929 24.7141L9.39346 21.1785L7.03644 32.9636L18.8216 30.6066ZM21.7678 8.80415L25.3034 12.3397L20.5893 17.0537L22.9463 19.4108L27.6604 14.6967L31.1959 18.2322L32.9637 7.03638L21.7678 8.80415Z\" fill=\"white\" fill-opacity=\"0.6\"/>\n</svg>";

var svg_enlarge_s = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.0576 24.4853L12.2292 21.6568L16.0004 17.8856L14.1148 16L10.3436 19.7712L7.51516 16.9428L5.62954 26.3709L15.0576 24.4853ZM17.4147 7.04331L20.2431 9.87173L16.4718 13.643L18.3575 15.5286L22.1287 11.7574L24.9571 14.5858L26.3713 5.62909L17.4147 7.04331Z\" fill=\"white\" fill-opacity=\"0.6\"/>\n</svg>";

var svg_enlarge_active_s = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M18.3178 26.4968L21.2811 23.8101L24.8634 27.7612L26.839 25.97L23.2567 22.0189L26.22 19.3321L16.8954 16.9878L18.3178 26.4968ZM13.6818 5.50324L10.7185 8.18999L7.13616 4.23888L5.1606 6.03005L8.74294 9.98116L5.7796 12.6679L14.6564 14.5184L13.6818 5.50324Z\" fill=\"white\" fill-opacity=\"0.6\"/>\n</svg>";

var svg_expand = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"16\" cy=\"16\" r=\"12.25\" stroke=\"#393432\" stroke-width=\"1.5\"/>\n<path d=\"M10 16H22\" stroke=\"#393432\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n</svg>";

var svg_expand_active = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"16\" cy=\"16\" r=\"12.25\" stroke=\"#393432\" stroke-width=\"1.5\"/>\n<path d=\"M10 16H22\" stroke=\"#393432\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n<path d=\"M16 10L16 22\" stroke=\"#393432\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n</svg>";

var svg_like = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M25.8272 17.0217L16 27L6.17285 17.0217C4.32916 15.1496 4.06709 12.2349 5.54726 10.064L6.01498 9.37803C7.68125 6.93417 10.982 6.2458 13.4862 7.81988L16 9.4L18.5138 7.81988C21.018 6.2458 24.3188 6.93417 25.985 9.37803L26.4527 10.064C27.9329 12.2349 27.6708 15.1496 25.8272 17.0217Z\" stroke=\"#756F6E\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_like_active = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M25.8272 17.0217L16 27L6.17285 17.0217C4.32916 15.1496 4.06709 12.2349 5.54726 10.064L6.01498 9.37803C7.68125 6.93417 10.982 6.2458 13.4862 7.81988L16 9.4L18.5138 7.81988C21.018 6.2458 24.3188 6.93417 25.985 9.37803L26.4527 10.064C27.9329 12.2349 27.6708 15.1496 25.8272 17.0217Z\" fill=\"#B8554D\" stroke=\"#B8554D\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_show = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.20302 4.81651C9.34592 4.31356 10.6142 4 12 4C19 4 23 12 23 12C23 12 21.826 14.3481 19.6369 16.5M17.8601 18C16.2494 19.148 14.2845 20 12 20C5 20 1 12 1 12C1 12 2.76431 8.47138 6 6.10111\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M13.5 14.598C13.0267 14.8713 12.5099 15.0009 12 15.0005C10.9642 14.9995 9.95705 14.4616 9.40188 13.5C9.12861 13.0267 8.99898 12.5098 8.99945 12C9.00013 11.2696 9.26783 10.5534 9.76279 9.99997M12 8.99947C13.0358 9.00046 14.0429 9.53842 14.598 10.5C14.8713 10.9733 15.0009 11.4901 15.0005 12\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M3 3L21 21\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_show_active = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_thumb_down = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10.5887 17.1441L15.0596 28C15.9489 28 17.3193 27.1301 17.8333 26.16C18.236 25.4002 18.4128 24.6464 18.4128 23.768V19.352H24.7392C25.0633 19.3557 25.3842 19.2897 25.6799 19.1586C25.9755 19.0276 26.2388 18.8346 26.4514 18.593C26.6641 18.3515 26.821 18.0672 26.9114 17.7598C27.0017 17.4524 27.0233 17.1293 26.9747 16.8129L25.4322 6.87693C25.3514 6.35043 25.0806 5.87052 24.6698 5.52563C24.259 5.18075 23.7359 4.99412 23.1967 5.00014H10.5887M10.5887 17.1441V5.00014M10.5887 17.1441H6C5.44772 17.1441 5 16.6963 5 16.1441V6.00014C5 5.44786 5.44771 5.00014 6 5.00014H10.5887\" stroke=\"#918D8C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_thumb_down_active = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M18.6322 24.4V19.6001H25.5337C25.8872 19.604 26.2373 19.5323 26.5599 19.3898C26.8824 19.2473 27.1696 19.0376 27.4016 18.775C27.6335 18.5125 27.8047 18.2035 27.9033 17.8694C28.0019 17.5353 28.0254 17.184 27.9724 16.8401L26.2897 6.04014C26.2015 5.46786 25.9061 4.94622 25.458 4.57134C25.0098 4.19647 24.4391 3.99361 23.851 4.00016H10.0967H4V16.2001C4 16.7524 4.44772 17.2001 5 17.2001H10.0967L14.9741 29C15.9443 29 17.4392 28.0544 18 27C18.4392 26.1741 18.6322 25.3548 18.6322 24.4Z\" fill=\"#C79F50\"/>\n<path d=\"M10.0967 17.2001L14.9741 29C15.9443 29 17.4392 28.0544 18 27C18.4392 26.1741 18.6322 25.3548 18.6322 24.4V19.6001H25.5337C25.8872 19.604 26.2373 19.5323 26.5599 19.3898C26.8824 19.2473 27.1696 19.0376 27.4016 18.775C27.6335 18.5125 27.8047 18.2035 27.9033 17.8694C28.0019 17.5353 28.0254 17.184 27.9724 16.8401L26.2897 6.04014C26.2015 5.46786 25.9061 4.94622 25.458 4.57134C25.0098 4.19647 24.4391 3.99361 23.851 4.00016H10.0967M10.0967 17.2001H5C4.44772 17.2001 4 16.7524 4 16.2001V4.00016H10.0967M10.0967 17.2001V4.00016\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_thumb_up = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10.5887 14.8559L15.0596 4C15.9489 4 17.3193 4.86994 17.8333 5.84C18.236 6.59983 18.4128 7.35359 18.4128 8.23198V12.648H24.7392C25.0633 12.6443 25.3842 12.7103 25.6799 12.8414C25.9755 12.9724 26.2388 13.1654 26.4514 13.407C26.6641 13.6485 26.821 13.9328 26.9114 14.2402C27.0017 14.5476 27.0233 14.8707 26.9747 15.1871L25.4322 25.1231C25.3514 25.6496 25.0806 26.1295 24.6698 26.4744C24.259 26.8193 23.7359 27.0059 23.1967 26.9999H10.5887M10.5887 14.8559V26.9999M10.5887 14.8559H6C5.44772 14.8559 5 15.3037 5 15.8559V25.9999C5 26.5521 5.44771 26.9999 6 26.9999H10.5887\" stroke=\"#918D8C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_thumb_up_active = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M18.6322 7.59998V12.3999H25.5337C25.8872 12.396 26.2373 12.4677 26.5599 12.6102C26.8824 12.7527 27.1696 12.9624 27.4016 13.225C27.6335 13.4875 27.8047 13.7965 27.9033 14.1306C28.0019 14.4647 28.0254 14.816 27.9724 15.1599L26.2897 25.9599C26.2015 26.5321 25.9061 27.0538 25.458 27.4287C25.0098 27.8035 24.4391 28.0064 23.851 27.9998H10.0967H4V15.7999C4 15.2476 4.44772 14.7999 5 14.7999H10.0967L14.9741 3C15.9443 3 17.4392 3.94559 18 5C18.4392 5.8259 18.6322 6.6452 18.6322 7.59998Z\" fill=\"#C79F50\"/>\n<path d=\"M10.0967 14.7999L14.9741 3C15.9443 3 17.4392 3.94559 18 5C18.4392 5.8259 18.6322 6.6452 18.6322 7.59998V12.3999H25.5337C25.8872 12.396 26.2373 12.4677 26.5599 12.6102C26.8824 12.7527 27.1696 12.9624 27.4016 13.225C27.6335 13.4875 27.8047 13.7965 27.9033 14.1306C28.0019 14.4647 28.0254 14.816 27.9724 15.1599L26.2897 25.9599C26.2015 26.5321 25.9061 27.0538 25.458 27.4287C25.0098 27.8035 24.4391 28.0064 23.851 27.9998H10.0967M10.0967 14.7999H5C4.44772 14.7999 4 15.2476 4 15.7999V27.9998H10.0967M10.0967 14.7999V27.9998\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var svg_emoji = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_13254_17176)\">\n<path d=\"M19.9998 36.9412C23.3504 36.9412 26.6258 35.9476 29.4118 34.0861C32.1977 32.2246 34.3691 29.5787 35.6514 26.4831C36.9336 23.3875 37.2691 19.9812 36.6154 16.695C35.9618 13.4087 34.3483 10.3901 31.979 8.0208C29.6097 5.65154 26.5911 4.03804 23.3048 3.38437C20.0186 2.73069 16.6123 3.06618 13.5167 4.34842C10.4211 5.63065 7.77522 7.80205 5.9137 10.588C4.05218 13.374 3.05859 16.6494 3.05859 20C3.05859 24.4931 4.84346 28.8022 8.02055 31.9792C11.1976 35.1563 15.5067 36.9412 19.9998 36.9412Z\" stroke=\"#918D8C\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n<path d=\"M13.2236 22.7064H26.7766C26.7766 22.7064 26.3409 29.1434 20.0001 29.1434C13.6593 29.1434 13.2236 22.7064 13.2236 22.7064Z\" stroke=\"#918D8C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M15.9448 16.9294C16.6875 16.9294 17.2895 16.3274 17.2895 15.5847C17.2895 14.842 16.6875 14.24 15.9448 14.24C15.2021 14.24 14.6001 14.842 14.6001 15.5847C14.6001 16.3274 15.2021 16.9294 15.9448 16.9294Z\" fill=\"#918D8C\"/>\n<path d=\"M24.0552 16.9294C24.7978 16.9294 25.3999 16.3274 25.3999 15.5847C25.3999 14.842 24.7978 14.24 24.0552 14.24C23.3125 14.24 22.7104 14.842 22.7104 15.5847C22.7104 16.3274 23.3125 16.9294 24.0552 16.9294Z\" fill=\"#918D8C\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_13254_17176\">\n<rect width=\"36\" height=\"36\" fill=\"white\" transform=\"translate(2 2)\"/>\n</clipPath>\n</defs>\n</svg>";

var svg_emoji_active = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_13254_17177)\">\n<path d=\"M19.9998 36.9412C23.3504 36.9412 26.6258 35.9476 29.4118 34.0861C32.1977 32.2246 34.3691 29.5787 35.6514 26.4831C36.9336 23.3875 37.2691 19.9812 36.6154 16.695C35.9618 13.4087 34.3483 10.3901 31.979 8.0208C29.6097 5.65154 26.5911 4.03804 23.3048 3.38437C20.0186 2.73069 16.6123 3.06618 13.5167 4.34842C10.4211 5.63065 7.77522 7.80205 5.9137 10.588C4.05218 13.374 3.05859 16.6494 3.05859 20C3.05859 24.4931 4.84346 28.8022 8.02055 31.9792C11.1976 35.1563 15.5067 36.9412 19.9998 36.9412Z\" fill=\"#FAE1AF\" stroke=\"#C79F50\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n<path d=\"M13.2236 22.7064H26.7766C26.7766 22.7064 26.3409 29.1434 20.0001 29.1434C13.6593 29.1434 13.2236 22.7064 13.2236 22.7064Z\" stroke=\"#C79F50\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M15.9448 16.9294C16.6875 16.9294 17.2895 16.3274 17.2895 15.5847C17.2895 14.842 16.6875 14.24 15.9448 14.24C15.2021 14.24 14.6001 14.842 14.6001 15.5847C14.6001 16.3274 15.2021 16.9294 15.9448 16.9294Z\" fill=\"#C79F50\"/>\n<path d=\"M24.0552 16.9294C24.7978 16.9294 25.3999 16.3274 25.3999 15.5847C25.3999 14.842 24.7978 14.24 24.0552 14.24C23.3125 14.24 22.7104 14.842 22.7104 15.5847C22.7104 16.3274 23.3125 16.9294 24.0552 16.9294Z\" fill=\"#C79F50\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_13254_17177\">\n<rect width=\"36\" height=\"36\" fill=\"white\" transform=\"translate(2 2)\"/>\n</clipPath>\n</defs>\n</svg>";

var _excluded$f = ["children", "handleClick", "variant", "priority", "icon", "block"],
    _excluded2$2 = ["variant", "dark", "children", "invertOnHover", "forceStroke", "forceFill", "replaceColor", "replaceFillColor", "replaceStrokeColor"],
    _excluded3$1 = ["type", "isActive", "withBackground", "icon_default", "icon_active", "forceStroke", "forceFill", "replaceColor", "replaceFillColor", "replaceStrokeColor"];

var _templateObject$d, _templateObject2$b, _templateObject3$8, _templateObject4$7, _templateObject5$6, _templateObject6$5, _templateObject7$4, _templateObject8$4, _templateObject9$4, _templateObject10$2;
var ButtonBase = material.styled(material.Button, {
  shouldForwardProp: function shouldForwardProp(propName) {
    return !['icon', 'leftIcon', 'block', 'loadable', 'loading', 'success'].includes(propName);
  }
})(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  font-family: 'Open Sans';\n  & .MuiTouchRipple-child {\n    opacity: 0.2;\n  }\n"])));
var PrimaryBase = material.styled(ButtonBase)(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  @keyframes on-success {\n    0% {\n      stroke-dasharray: 0px 50px;\n    }\n    100% {\n      stroke-dasharray: 50px 0px;\n    }\n  }\n  .success-button svg path {\n    stroke-width: 2px;\n    fill: transparent;\n    stroke: ", ";\n    animation: on-success 1s ease;\n    animation-fill-mode: both;\n    position: absolute;\n  }\n  width: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 700;da\n  font-family: 'Open Sans';\n  -webkit-font-smoothing: antialiased;\n  text-transform: none;\n  font-size: 16px;\n  font-style: normal;\n  & svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n      fill: ", ";\n    }\n  }\n\n  &.MuiButton-sizeSmall {\n    font-size: 14px;\n    line-height: 24px;\n    padding: 8px 16px;\n    letter-spacing: -0.4px;\n  }\n\n  &.MuiButton-sizeMedium {\n    padding: 12px 24px;\n    line-height: 24px;\n    letter-spacing: -0.4px;\n  }\n\n  &.MuiButton-sizeLarge {\n    padding: 14px 24px;\n    line-height: 24px;\n    font-size: 18px;\n    letter-spacing: -0.6px;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"])), theme.palette.white.main, function (props) {
  return props.width ? props.width : props.block ? '100%' : 'fit-content';
}, theme.palette.primary[600], theme.palette.white.main, theme.palette.white.main, theme.palette.white.main, theme.palette.white.main, theme.palette.primary[500], theme.palette.primary[700]);
var SecondaryBase = material.styled(PrimaryBase)(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  .success-button svg path {\n    stroke-width: 2px;\n    fill: transparent !important;\n    stroke: ", ";\n  }\n  background-color: #ffffff;\n  box-shadow: 0px 0px 0px 2px ", " inset;\n  color: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n\n  &:hover {\n    background-color: #ffffff;\n    box-shadow: 0px 0px 0px 2px ", " inset;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n\n  &:active {\n    background-color: #ffffff;\n    box-shadow: 0px 0px 0px 2px ", " inset;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n"])), theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[500], theme.palette.primary[500], theme.palette.primary[500], theme.palette.primary[500], theme.palette.primary[700], theme.palette.primary[700], theme.palette.primary[700], theme.palette.primary[700]);
var SecondaryDisabledBase = material.styled(PrimaryBase)(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  box-shadow: 0 0 0 2px ", " inset;\n  background: ", ";\n  color: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n"])), theme.palette.grey[300], theme.palette.white.main, theme.palette.grey[300], theme.palette.grey[300], theme.palette.grey[300]);
var PrimaryDisabledBase = material.styled(PrimaryBase)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n  & #span {\n    color: ", ";\n  "])), theme.palette.grey[200], theme.palette.grey[300], theme.palette.grey[300], theme.palette.grey[300]);
var TextPrimaryBase = material.styled(ButtonBase)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n  width: ", ";\n  background: none;\n  border-radius: 30px;\n  color: ", ";\n  text-transform: none;\n  padding: 4px;\n  ", ";\n  ", ";\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  -webkit-font-smoothing: antialiased;\n  & svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n\n  #children {\n    border-bottom: 0.5px solid ", ";\n  }\n\n  &.MuiButton-sizeSmall {\n    font-size: 14px;\n    line-height: 22px;\n    padding: 3px 4px;\n    ", ";\n    ", "\n  }\n\n  &:hover {\n    & svg {\n      path {\n        ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n    #icon {\n      ", ";\n    }\n    background: ", ";\n  }\n"])), function (props) {
  return props.block ? '100%' : 'fit-content';
}, theme.palette.primary[500], function (props) {
  return props.icon && 'padding: 4px 2px 4px 4px';
}, function (props) {
  return props.leftIcon && 'padding: 4px 4px 4px 2px';
}, theme.palette.primary[500], theme.palette.primary[500], theme.palette.primary[500], function (props) {
  return props.icon && 'padding: 2px 2px 2px 4px';
}, function (props) {
  return props.leftIcon && 'padding: 2px 4px 2px 2px';
}, function (props) {
  return props.leftIcon && "stroke: ".concat(theme.palette.primary[500]);
}, theme.palette.primary[500], function (props) {
  return !props.leftIcon && 'margin-left: 4px';
}, theme.palette.primary[100]);
var TextSecondaryBase = material.styled(TextPrimaryBase)(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  color: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n  #children {\n    border-bottom: 0.5px solid ", ";\n  }\n\n  &:hover {\n    svg {\n      path {\n        ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n    #children {\n      border-bottom: 0.5px solid ", ";\n    }\n    color: ", ";\n    background-color: ", ";\n  }\n"])), theme.palette.grey[600], theme.palette.grey[600], theme.palette.grey[600], theme.palette.grey[600], function (props) {
  return props.leftIcon && "stroke: ".concat(theme.palette.grey[600]);
}, theme.palette.grey[600], theme.palette.grey[600], theme.palette.grey[600], theme.palette.grey[200]);
var TextDisabledBase = material.styled(TextPrimaryBase)(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n  color: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n    line {\n      stroke: ", ";\n    }\n  }\n  #children {\n    border-bottom: 0.5px solid ", ";\n    color: ", ";\n  }\n"])), theme.palette.grey[400], theme.palette.grey[400], theme.palette.grey[400], theme.palette.grey[400], theme.palette.grey[400]);
var DestructiveBase = material.styled(SecondaryBase)(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n  box-shadow: none;\n  &:hover {\n    background-color: ", ";\n    box-shadow: none;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n  &:active {\n    background-color: ", ";\n    box-shadow: none;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n"])), theme.palette.grey[200], theme.palette.primary[700], theme.palette.primary[700], theme.palette.primary[700], theme.palette.grey[300], theme.palette.primary[800], theme.palette.primary[800], theme.palette.primary[800]);
var DarkBase = material.styled(PrimaryBase)(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n  box-shadow: none;\n  &:hover {\n    background-color: ", ";\n    box-shadow: none;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n  &:active {\n    background-color: ", ";\n    box-shadow: none;\n    color: ", ";\n    svg {\n      path {\n        stroke: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n"])), theme.palette.white.main, theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[600], theme.palette.grey[300], theme.palette.primary[800], theme.palette.primary[800], theme.palette.primary[800]);

var OUIButton = function OUIButton(_ref) {
  var children = _ref.children,
      handleClick = _ref.handleClick,
      variant = _ref.variant;
      _ref.priority;
      var icon = _ref.icon,
      block = _ref.block,
      props = _objectWithoutProperties(_ref, _excluded$f);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      success = _useState4[0],
      setSuccess = _useState4[1];

  var ref = React.useRef(null);
  React.useEffect(function () {
    if (props.id) {
      var _ref$current$children;

      (_ref$current$children = ref.current.children[0]) === null || _ref$current$children === void 0 ? void 0 : _ref$current$children.setAttribute('id', props.id); // add id in default span in Button
    } else {
      var _ref$current$children2;

      (_ref$current$children2 = ref.current.children[0]) === null || _ref$current$children2 === void 0 ? void 0 : _ref$current$children2.setAttribute('id', 'span');
    }
  }, [props === null || props === void 0 ? void 0 : props.id]);

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var res, handlePromise;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!props.disabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(props.loadable && handleClick)) {
                _context.next = 24;
                break;
              }

              if (!loading) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              setLoading(true);
              _context.prev = 6;

              if (!(handleClick.constructor.name === 'AsyncFunction')) {
                _context.next = 14;
                break;
              }

              _context.next = 10;
              return handleClick();

            case 10:
              res = _context.sent;

              if (res !== null && res !== void 0 && res.status) {
                if (res.status < 300) {
                  setSuccess(true);
                } else {
                  setLoading(false);
                }
              } else {
                if (res) {
                  setSuccess(true);
                } else {
                  setLoading(false);
                }
              }

              _context.next = 16;
              break;

            case 14:
              // sync function
              handlePromise = new Promise(function (resolve, reject) {
                handleClick(event, resolve, reject);
              });
              handlePromise.then(function () {
                return setSuccess(true);
              }, function () {
                return setLoading(false);
              });

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              setLoading(false);
              throw _context.t0;

            case 22:
              _context.next = 25;
              break;

            case 24:
              handleClick && handleClick(event);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    }));

    return function handleButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var Base;

  if (props.disabled) {
    if (variant === 'secondary') {
      Base = SecondaryDisabledBase;
    } else if (variant === 'textprimary' || variant === 'textsecondary') {
      Base = TextDisabledBase;
    } else {
      Base = PrimaryDisabledBase;
    }
  } else {
    if (variant === 'secondary') {
      Base = SecondaryBase;
    } else if (variant === 'textprimary') {
      Base = TextPrimaryBase;
    } else if (variant === 'textsecondary') {
      Base = TextSecondaryBase;
    } else if (variant === 'destructive') {
      Base = DestructiveBase;
    } else if (variant === 'dark') {
      Base = DarkBase;
    } else {
      Base = PrimaryBase;
    }
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, _extends({
    onClick: handleButtonClick,
    className: props.className,
    sx: props.sx,
    ref: ref,
    loading: loading,
    block: block,
    icon: icon,
    leftIcon: props.leftIcon,
    size: props.size,
    success: success // disableRipple

  }, props), props.leftIcon && (variant === 'textprimary' || variant === 'textsecondary') && props.size !== 'small' && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginRight: '4px',
      display: 'flex'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Edit24__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      opacity: props.loadable && (loading || success) ? '0' : '1'
    }
  }, variant !== 'textprimary' && variant !== 'textsecondary' ? children : /*#__PURE__*/React__default["default"].createElement("span", {
    id: "children"
  }, children)), props.loadable && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'absolute',
      opacity: loading || success ? '1' : '0',
      display: 'flex',
      width: '24px',
      height: '24px'
    }
  }, loading && /*#__PURE__*/React__default["default"].createElement(material.CircularProgress, {
    style: props.iconStyle,
    size: props.iconSize ? props.iconSize : 24,
    sx: {
      height: 'inherit',
      color: variant === 'secondary' ? theme.palette.primary[600] : theme.palette.white.main,
      opacity: success ? '0' : '1',
      position: 'absolute'
    }
  }), success && /*#__PURE__*/React__default["default"].createElement(Tick24__default["default"], {
    className: "success-button"
  })), icon && !loading ? /*#__PURE__*/React__default["default"].createElement("div", {
    id: "icon",
    style: {
      marginLeft: props.size === 'small' ? '2px' : '4px',
      display: 'flex'
    }
  }, props.size === 'small' ? /*#__PURE__*/React__default["default"].createElement(ArrowRightSmall24__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(ArrowRight24__default["default"], null)) : null);
};

var OUIIconButton = function OUIIconButton(_ref3) {
  var variant = _ref3.variant,
      dark = _ref3.dark,
      children = _ref3.children;
      _ref3.invertOnHover;
      _ref3.forceStroke;
      _ref3.forceFill;
      _ref3.replaceColor;
      _ref3.replaceFillColor;
      _ref3.replaceStrokeColor;
      var props = _objectWithoutProperties(_ref3, _excluded2$2);

  if (dark) {
    variant = 'dark'; // for orkaui 1.0
  }

  return /*#__PURE__*/React__default["default"].createElement(material.IconButton, _extends({
    sx: variant ? {
      backgroundColor: variant === 'dark' ? theme.palette.primary[600] : '#FFFFFF',
      transform: 'backgroundcolor 100ms',
      ':hover': {
        backgroundColor: variant === 'dark' ? theme.palette.primary[500] : '#FFFFFF'
      },
      filter: variant === 'dark' ? 'drop-shadow(0px 8px 16px rgba(18, 46, 83, 0.25))' : 'filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.08));'
    } : {}
  }, props), children);
};

var InteractiveButton = function InteractiveButton(_ref4) {
  var type = _ref4.type,
      isActive = _ref4.isActive,
      withBackground = _ref4.withBackground,
      icon_default = _ref4.icon_default,
      icon_active = _ref4.icon_active,
      forceStroke = _ref4.forceStroke,
      forceFill = _ref4.forceFill,
      replaceColor = _ref4.replaceColor,
      replaceFillColor = _ref4.replaceFillColor,
      replaceStrokeColor = _ref4.replaceStrokeColor,
      props = _objectWithoutProperties(_ref4, _excluded3$1);

  var supported_types = ['enlarge', 'enlarge_s', 'expand', 'like', 'show', 'thumb_up', 'thumb_down', 'emoji']; // validity check

  if (type) {
    if (supported_types.indexOf(type) === -1) {
      console.error("Type \"".concat(type, "\" invalid as a prop for InteractiveButton. Return empty element. Supported type: "), supported_types);
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
    }
  } else {
    if (!icon_default) {
      console.error('Missing type or icon_default prop for InteractiveButton. Return empty element.');
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
    }

    if (!icon_active) {
      console.error('Missing type or icon_active prop for InteractiveButton. Return empty element.');
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
    }
  } // main logic


  if (type) {
    switch (type) {
      case 'enlarge':
        icon_default = svg_enlarge;
        icon_active = svg_enlarge_active;
        break;

      case 'enlarge_s':
        icon_default = svg_enlarge_s;
        icon_active = svg_enlarge_active_s;
        break;

      case 'expand':
        icon_default = svg_expand;
        icon_active = svg_expand_active;
        break;

      case 'like':
        icon_default = svg_like;
        icon_active = svg_like_active;
        break;

      case 'show':
        icon_default = svg_show;
        icon_active = svg_show_active;
        break;

      case 'thumb_down':
        icon_default = svg_thumb_down;
        icon_active = svg_thumb_down_active;
        break;

      case 'thumb_up':
        icon_default = svg_thumb_up;
        icon_active = svg_thumb_up_active;
        break;

      case 'emoji':
        icon_default = svg_emoji;
        icon_active = svg_emoji_active;
        break;
    }

    icon_default = /*#__PURE__*/React__default["default"].createElement(SvgParser, {
      svg: icon_default,
      forceStroke: forceStroke,
      forceFill: forceFill,
      replaceColor: replaceColor,
      replaceFillColor: replaceFillColor,
      replaceStrokeColor: replaceStrokeColor
    });
    icon_active = /*#__PURE__*/React__default["default"].createElement(SvgParser, {
      svg: icon_active,
      forceStroke: forceStroke,
      forceFill: forceFill,
      replaceColor: replaceColor,
      replaceFillColor: replaceFillColor,
      replaceStrokeColor: replaceStrokeColor
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(OUIIconButton, _extends({
    disableRipple: !withBackground
  }, props), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "interactive_icons_container"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "interactive_icon_placeholder"
  }, icon_active), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "interactive_icon ".concat(isActive ? 'interactive_icon_active' : 'interactive_icon_inactive', " ").concat(type === 'expand' ? 'interactive_icon_expand' : '')
  }, icon_active), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "interactive_icon ".concat(!isActive ? 'interactive_icon_active' : 'interactive_icon_inactive', " ").concat(type === 'expand' ? 'interactive_icon_expand' : '')
  }, icon_default)));
};

var _excluded$e = ["size", "label", "indeterminate", "controlSx", "error", "errormsg", "errorMsg"];

var _templateObject$c, _templateObject2$a, _templateObject3$7, _templateObject4$6, _templateObject5$5, _templateObject6$4, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14;
var CheckboxBase$1 = styles.styled(material.Checkbox)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  padding: 0;\n  &:hover {\n    // background-color: transparent;\n    & > span {\n      'transparent';\n    }\n  }\n"])));

var Icon = function Icon(_ref) {
  var size = _ref.size,
      disabled = _ref.disabled;
  var Large = /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      display: 'flex',
      backgroundColor: disabled ? theme.palette.grey[400] : theme.palette.primary[600],
      padding: '4px',
      borderRadius: '4px'
    }
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91006 10.4959L3.7071 8.29291C3.31658 7.90239 2.68342 7.90239 2.29289 8.29291C1.90237 8.68343 1.90237 9.3166 2.29289 9.70712L5.29288 12.7071C5.7168 13.131 6.4159 13.0892 6.7863 12.6178L13.7863 4.61786C14.1275 4.18359 14.0521 3.55494 13.6178 3.21372C13.1835 2.87251 12.5549 2.94795 12.2136 3.38222L5.91006 10.4959Z",
    fill: "white"
  })));
  var Medium = /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      display: 'flex',
      backgroundColor: disabled ? theme.palette.grey[400] : theme.palette.primary[600],
      borderRadius: '4px',
      padding: '2px'
    }
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00025 10.0006C4.73625 10.0006 4.48125 9.89657 4.29325 9.70757L2.29325 7.70757C1.90225 7.31657 1.90225 6.68457 2.29325 6.29357C2.68425 5.90257 3.31625 5.90257 3.70725 6.29357L4.84525 7.43157L8.16825 2.44557C8.47425 1.98557 9.09425 1.86157 9.55525 2.16857C10.0142 2.47557 10.1383 3.09557 9.83225 3.55557L5.83225 9.55557C5.66625 9.80457 5.39625 9.96657 5.09925 9.99557C5.06525 9.99857 5.03325 10.0006 5.00025 10.0006Z",
    fill: "white"
  })));
  var Small = /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      display: 'flex',
      backgroundColor: disabled ? theme.palette.grey[400] : theme.palette.primary[600],
      padding: '0',
      borderRadius: '4px'
    }
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00025 10.0006C4.73625 10.0006 4.48125 9.89657 4.29325 9.70757L2.29325 7.70757C1.90225 7.31657 1.90225 6.68457 2.29325 6.29357C2.68425 5.90257 3.31625 5.90257 3.70725 6.29357L4.84525 7.43157L8.16825 2.44557C8.47425 1.98557 9.09425 1.86157 9.55525 2.16857C10.0142 2.47557 10.1383 3.09557 9.83225 3.55557L5.83225 9.55557C5.66625 9.80457 5.39625 9.96657 5.09925 9.99557C5.06525 9.99857 5.03325 10.0006 5.00025 10.0006Z",
    fill: "white"
  })));
  var icon;
  if (size === 'large') icon = Large;else if (size === 'small') icon = Small;else icon = Medium;
  return icon;
};

var CheckIcon$2 = function CheckIcon(_ref2) {
  var size = _ref2.size,
      disabled = _ref2.disabled;
      _ref2.error;
  var LargeOuterBase = styles.styled('span')(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 22px;\n    height: 22px;\n    box-shadow: ", ";\n    margin: auto;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 2px ".concat(theme.palette.grey[400], " inset") : "0 0 0 2px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[400] : theme.palette.primary[600]);
  var MediumOuterBase = styles.styled('span')(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 18px;\n    height: 18px;\n    box-shadow: ", ";\n    margin: auto;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 1px ".concat(theme.palette.grey[400], " inset") : "0 0 0 1px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[400] : theme.palette.primary[600]);
  var SmallOuterBase = styles.styled('span')(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 12px;\n    height: 12px;\n    box-shadow: ", ";\n    margin: auto;\n    padding: 0;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 1px ".concat(theme.palette.grey[400], " inset") : "0 0 0 1px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[400] : theme.palette.primary[600]);
  var OuterBase;

  if (size === 'small') {
    OuterBase = SmallOuterBase;
  } else if (size === 'large') {
    OuterBase = LargeOuterBase;
  } else {
    OuterBase = MediumOuterBase;
  }

  return /*#__PURE__*/React__default["default"].createElement(OuterBase, null, /*#__PURE__*/React__default["default"].createElement(Icon, {
    size: size,
    disabled: disabled
  }));
};

var UncheckIcon$1 = function UncheckIcon(_ref3) {
  var size = _ref3.size,
      disabled = _ref3.disabled,
      error = _ref3.error;
  var LargeBase = styles.styled('span')(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: 0 0 0 1.5px\n      ", " inset;\n    width: 22px;\n    height: 22px;\n    background-color: ", ";\n  "])), error ? theme.palette.error[300] : theme.palette.grey[400], disabled ? theme.palette.grey[200] : 'transparent');
  var MediumBase = styles.styled('span')(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: 0 0 0 1.5px\n      ", " inset;\n    width: 18px;\n    height: 18px;\n    background-color: ", ";\n  "])), error ? theme.palette.error[300] : theme.palette.grey[400], disabled ? theme.palette.grey[200] : 'transparent');
  var SmallBase = styles.styled('span')(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: 0 0 0 1px\n      ", " inset;\n    width: 12px;\n    height: 12px;\n    background-color: ", ";\n  "])), error ? theme.palette.error[300] : theme.palette.grey[400], disabled ? theme.palette.grey[200] : 'transparent');
  var Base;

  if (size === 'small') {
    Base = SmallBase;
  } else if (size === 'large') {
    Base = LargeBase;
  } else {
    Base = MediumBase;
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, null);
};

var IndeterminateIcon = function IndeterminateIcon(_ref4) {
  var size = _ref4.size;
  var LargeBase = styles.styled('span')(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 22px;\n    height: 22px;\n    padding: 10px 4px;\n    background-color: ", ";\n    box-sizing: border-box;\n  "])), theme.palette.primary[600]);
  var MediumBase = styles.styled('span')(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 18px;\n    height: 18px;\n    padding: 8px 4px;\n    background-color: ", ";\n    box-sizing: border-box;\n  "])), theme.palette.primary[600]);
  var SmallBase = styles.styled('span')(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 4px;\n    width: 12px;\n    height: 12px;\n    padding: 5px 3px;\n    background-color: ", ";\n    box-sizing: border-box;\n  "])), theme.palette.primary[600]);
  var Large = /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "14",
    height: "2",
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "12",
    height: "2",
    rx: "1",
    fill: "white"
  }));
  var Medium = /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "10",
    height: "2",
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "8",
    height: "2",
    rx: "1",
    fill: "white"
  }));
  var Small = /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "6",
    height: "2",
    viewBox: "0 0 6 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "6",
    height: "2",
    rx: "1",
    fill: "white"
  }));
  var icon, Base;

  if (size === 'large') {
    Base = LargeBase;
    icon = Large;
  } else if (size === 'small') {
    Base = SmallBase;
    icon = Small;
  } else {
    Base = MediumBase;
    icon = Medium;
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, null, icon);
};

var ControlLabel = styles.styled(material.FormControlLabel)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  margin: 0;\n  align-items: flex-start;\n  gap: ", ";\n"])), function (props) {
  return props.size === 'large' ? '9px' : '7px';
});

var OUICheckbox = function OUICheckbox(_ref5) {
  var size = _ref5.size,
      label = _ref5.label,
      indeterminate = _ref5.indeterminate,
      controlSx = _ref5.controlSx,
      error = _ref5.error,
      errormsg = _ref5.errormsg,
      errorMsg = _ref5.errorMsg,
      props = _objectWithoutProperties(_ref5, _excluded$e);

  error = errormsg ? true : error;
  if (errorMsg) errormsg = errorMsg;
  var LargeBase = styles.styled(CheckboxBase$1)(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n    margin-top: 2px;\n    &:hover {\n      & > span {\n        box-shadow: 0 0 0 1.5px ", " inset;\n      }\n    }\n  "])), theme.palette.primary[600]);
  var MediumBase = styles.styled(CheckboxBase$1)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    margin-top: 4px;\n    &:hover {\n      & > span {\n        box-shadow: 0 0 0 1.5px ", " inset;\n      }\n    }\n  "])), theme.palette.primary[600]);
  var SmallBase = styles.styled(CheckboxBase$1)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    margin-top: 8px;\n    &:hover {\n      & > span {\n        box-shadow: 0 0 0 1px ", " inset;\n      }\n    }\n  "])), theme.palette.primary[600]);
  var Base, variant;

  if (size === 'small') {
    Base = SmallBase;
    variant = 'body4';
  } else if (size === 'large') {
    Base = LargeBase;
    variant = 'body2';
  } else {
    Base = MediumBase;
    variant = 'body3';
  }

  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ControlLabel, {
    control: /*#__PURE__*/React__default["default"].createElement(Base, _extends({
      checked: props.checked,
      onChange: props.onChange,
      name: "checkbox",
      checkedIcon: /*#__PURE__*/React__default["default"].createElement(CheckIcon$2, {
        size: size,
        disabled: props.disabled,
        error: error
      }),
      icon: /*#__PURE__*/React__default["default"].createElement(UncheckIcon$1, {
        size: size,
        disabled: props.disabled,
        error: error
      }),
      indeterminateIcon: /*#__PURE__*/React__default["default"].createElement(IndeterminateIcon, {
        size: size
      }),
      indeterminate: indeterminate,
      disableRipple: true
    }, props)),
    label: /*#__PURE__*/React__default["default"].createElement(OUITypography, {
      variant: variant,
      style: {
        display: 'inline',
        verticalAlign: 'middle',
        color: props.disabled ? theme.palette.grey[400] : theme.palette.grey[700]
      }
    }, label),
    sx: controlSx
  }), errormsg && /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: {
      display: 'flex',
      margin: '4px 0 0 0',
      width: '100%',
      textAlign: 'left',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    sx: {
      mr: '3px',
      mt: '3.15px',
      display: 'flex'
    }
  }, /*#__PURE__*/React__default["default"].createElement(WarningCircle24__default["default"], {
    size: '16px'
  })), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    style: {
      color: theme.palette.error[300]
    }
  }, errormsg)));
};

var _excluded$d = ["controlSx", "optionProps", "errorMsg"];

var _templateObject$b, _templateObject2$9;
var StyledLabel$1 = material.styled(material.InputLabel)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  text-align: left;\n  max-width: 100%;\n  font-family: 'Open Sans';\n  &.MuiInputLabel-shrink {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: -0.2px;\n    transform: translate(16px, 8px) scale(0.95);\n    color: ", ";\n    white-space: nowrap;\n  }\n  &.Mui-focused {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: -0.2px;\n    transform: translate(16px, 8px) scale(0.95);\n    color: ", ";\n    white-space: nowrap;\n  }\n  &.Mui-error {\n    color: ", ";\n    z-index: 1;\n    &.Mui-focused {\n      color: ", ";\n      //transform: translate(16px, 18px) scale(0.95);\n    }\n  }\n"])), theme.palette.grey[500], theme.palette.grey[500], theme.palette.grey[500], theme.palette.error[300], theme.palette.error[300]);
var StyledInput = material.styled(material.Input)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  min-height: 56px;\n  font-size: 16px;\n  color: ", ";\n  width: ", ";\n  font-family: 'Open Sans';\n  max-width: 100%;\n  .startSvg svg {\n    width: 24px;\n    height: 24px;\n    margin-left: 16px;\n    margin-right: -14px; // 16 - 6 - (margin right of adormentDiv) = 10px\n  }\n  .endSvg svg {\n    width: 24px;\n    height: 24px;\n    margin-right: 16px;\n  }\n  & textarea.MuiInput-input {\n    padding: 20px 16px 0 16px;\n    min-height: 198px;\n  }\n  & .MuiInput-input {\n    padding: ", ";\n    width: ", ";\n  }\n  //&.MuiInput-multiline {\n  //  min-height: 198px;\n  //}\n  &::before {\n    border-bottom: none;\n    transform: unset;\n  }\n  &:hover {\n    border: 1px solid ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n  &.Mui-disabled {\n    color: ", ";\n    background-color: ", ";\n    &:hover {\n      border: 1px solid ", ";\n      box-shadow: none;\n    }\n  }\n  &.Mui-error {\n    border: 1px solid ", ";\n    box-shadow: none;\n    //background-color: #FDEBEB;\n  }\n  &.Mui-focused {\n    border: 1px solid ", ";\n    box-shadow: 0 0 0 3px ", ";\n    &.Mui-error {\n      border: 1px solid ", ";\n      box-shadow: none;\n    }\n  }\n  input:-webkit-autofill {\n    transition-delay: 9999s;\n    transition-property: background-color, color;\n  }\n"])), theme.palette.grey[400], theme.palette.grey[800], function (props) {
  return props.fullWidth ? '100%' : '300px';
}, function (props) {
  return props._placeholder && !props.startAdornment ? "16px ".concat(props.endAdornment ? '8px' : '16px', " 0 16px") : "0 ".concat(props.endAdornment ? '8px' : '16px', " 0 16px");
}, function (props) {
  return props.fullWidth ? '100%' : '300px';
}, theme.palette.primary[600], theme.palette.primary[200], theme.palette.grey[500], theme.palette.grey[100], theme.palette.grey[400], theme.palette.error[300], theme.palette.primary[600], theme.palette.primary[200], theme.palette.error[300]);

function OUIInput(_ref) {
  var _errormsg, _errormsg2;

  var controlSx = _ref.controlSx,
      optionProps = _ref.optionProps,
      errorMsg = _ref.errorMsg,
      props = _objectWithoutProperties(_ref, _excluded$d);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var errormsg = props.errormsg,
      name = props.name,
      placeholder = props.placeholder,
      autoComplete = props.autoComplete,
      onChange = props.onChange,
      onClick = props.onClick,
      label = props.label,
      onKeyUp = props.onKeyUp,
      onKeyDown = props.onKeyDown,
      type = props.type,
      onBlur = props.onBlur,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      required = props.required,
      rows = props.rows,
      id = props.id,
      inputLabelSx = props.inputLabelSx,
      inputSx = props.inputSx,
      endAdornment = props.endAdornment,
      text = props.text,
      option = props.option,
      datatestid = props.datatestid,
      fullWidth = props.fullWidth,
      value = props.value,
      icon = props.icon;
  if (errorMsg) errormsg = errorMsg;

  var handleClickAway = function handleClickAway() {
    setFocused(false);
  };

  var handleClick = function handleClick() {
    setFocused(true);
    onClick && onClick();
  };

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPwd = _useState4[0],
      setShowPwd = _useState4[1];

  React.useEffect(function () {
    return function () {
      return setShowPwd(false);
    };
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: fullWidth ? '100%' : undefined
    }
  }, label && /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "button",
    style: {
      fontSize: '12px',
      color: theme.palette.grey[600],
      lineHeight: '16.8px',
      marginBottom: '4px',
      display: 'flex'
    }
  }, label), /*#__PURE__*/React__default["default"].createElement(material.ClickAwayListener, {
    onClickAway: handleClickAway
  }, /*#__PURE__*/React__default["default"].createElement(material.FormControl, {
    sx: _objectSpread2({
      width: fullWidth ? '100%' : undefined
    }, controlSx) // error={error && error.length !== 0}

  }, /*#__PURE__*/React__default["default"].createElement(StyledInput, _extends({}, props, {
    id: id,
    "aria-describedby": "input-base",
    value: value,
    name: name,
    type: showPwd ? 'text' : type,
    error: ((_errormsg = errormsg) === null || _errormsg === void 0 ? void 0 : _errormsg.length) > 0,
    onClick: handleClick,
    onChange: onChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onBlur: onBlur,
    required: required,
    autoComplete: autoComplete,
    defaultValue: defaultValue,
    rows: rows,
    sx: inputSx,
    disabled: disabled,
    disableUnderline: true,
    endAdornment: /*#__PURE__*/React__default["default"].createElement(InputAdornment__default["default"], {
      position: "end",
      className: "endSvg"
    }, endAdornment ? endAdornment : type === 'password' && /*#__PURE__*/React__default["default"].createElement(InteractiveButton, {
      type: "show",
      isActive: showPwd,
      onClick: function onClick() {
        setShowPwd(!showPwd);
      },
      forceStroke: theme.palette.grey[600]
    })),
    "data-testid": datatestid,
    _placeholder: placeholder,
    placeholder: icon && placeholder,
    startAdornment: icon && /*#__PURE__*/React__default["default"].createElement(InputAdornment__default["default"], {
      position: "start",
      className: "startSvg"
    }, icon)
  })), placeholder && !icon && /*#__PURE__*/React__default["default"].createElement(StyledLabel$1, {
    htmlFor: id,
    focused: (!!focused || !!(props.value && props.value.length !== 0)) && !disabled,
    disabled: disabled,
    error: ((_errormsg2 = errormsg) === null || _errormsg2 === void 0 ? void 0 : _errormsg2.length) > 0,
    sx: inputLabelSx
  }, placeholder), errormsg && /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: {
      display: 'flex',
      margin: '4px 0 0 0',
      width: '100%',
      textAlign: 'left',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    sx: {
      mr: '3px',
      mt: '3.15px',
      display: 'flex'
    }
  }, /*#__PURE__*/React__default["default"].createElement(WarningCircle24__default["default"], {
    size: '16px'
  })), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    id: "".concat(id, "-error"),
    "data-testid": datatestid + '-error',
    style: {
      color: theme.palette.error[300]
    }
  }, errormsg)), text && /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: {
      display: 'flex',
      margin: '4px 0 0 0',
      width: '100%',
      textAlign: 'left',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    id: "".concat(id, "-resText"),
    "data-testid": datatestid + '-resText',
    style: {
      color: theme.palette.grey[500]
    }
  }, text)), option && /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: {
      display: 'flex',
      margin: '8px 0 0 0',
      width: '100%',
      textAlign: 'left',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUICheckbox, _extends({
    disabled: disabled
  }, optionProps, {
    label: option
  }))))));
}

var _excluded$c = ["selectSx", "controlSx", "labelSx", "errorMsg", "fullwidth"];

var _templateObject$a, _templateObject2$8, _templateObject3$6;
var StyledLabel = material.styled(material.InputLabel)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  transform: translate(14px, 16px) scale(1);\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  font-weight: 400;\n  color: ", ";\n  font-family: 'Open Sans';\n  -webkit-font-smoothing: antialiased;\n  &.MuiInputLabel-shrink {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: -0.2px;\n    transform: translate(14px, 8px) scale(0.95);\n    color: ", ";\n    white-space: nowrap;\n  }\n  &.Mui-focused {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: -0.2px;\n    transform: translate(14px, 8px) scale(0.95);\n    color: ", ";\n  }\n  &.Mui-error {\n    color: ", ";\n    z-index: 1;\n    &.Mui-focused {\n      color: ", ";\n      transform: translate(14px, 8px) scale(0.95);\n    }\n  }\n"])), theme.palette.grey[400], theme.palette.grey[400], theme.palette.grey[400], theme.palette.error[300], theme.palette.error[300]);
var StyledSelect = material.styled(material.Select)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  border-radius: 6px;\n  font-family: 'Open Sans';\n  min-width: 200px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  height: 56px;\n  &:hover {\n    box-shadow: 0 0 0 3px ", ";\n    border: 1px solid ", ";\n    background-color: ", ";\n  }\n  &:focused {\n    background-color: ", ";\n  }\n  &.Mui-focused {\n    background-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n    border: 1px solid ", ";\n  }\n  &.Mui-error {\n    box-shadow: none;\n    border: 1px solid ", ";\n    &.Mui-focused {\n      box-shadow: none;\n      border: 1px solid ", ";\n    }\n  }\n  &.Mui-disabled {\n    color: ", ";\n    //background-color: ", ";\n    &:hover {\n      border: 1px solid ", ";\n      box-shadow: none;\n    }\n  }\n  & .MuiSelect-filled {\n    background-color: ", ";\n    :hover {\n      background-color: ", ";\n    }\n    :focus {\n      background-color: ", ";\n    }\n    &.Mui-disabled {\n      background-color: ", ";\n    }\n    &.MuiFilledInput-input {\n      border-radius: 8px;\n      background-color: ", ";\n      padding: ", ";\n      .Tick24 {\n        display: none !important;\n      }\n      :hover {\n        background-color: ", ";\n      }\n      :focus {\n        background-color: ", ";\n      }\n      &.Mui-disabled {\n        background-color: ", ";\n      }\n    }\n  }\n  .ChevronDownSmall24 {\n    svg {\n      transform: translateY(-4px);\n    }\n  }\n  .ChevronDownSmall24.MuiSelect-iconOpen {\n    svg {\n      transform: translateY(4px);\n    }\n  }\n"])), theme.palette.white.main, theme.palette.grey[400], theme.palette.primary[200], theme.palette.primary[500], theme.palette.white.main, theme.palette.white.main, theme.palette.white.main, theme.palette.primary[200], theme.palette.primary[500], theme.palette.error[300], theme.palette.error[300], theme.palette.grey[500], theme.palette.grey[100], theme.palette.grey[400], theme.palette.white.main, theme.palette.white.main, theme.palette.white.main, theme.palette.grey[100], theme.palette.white.main, function (props) {
  return props._placeholder ? '22px 0 8px 14px' : '15px 0 15px 14px';
}, theme.palette.white.main, theme.palette.white.main, theme.palette.grey[100]);
var Item$1 = material.styled(material.MenuItem)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  display: flex;\n  justify-content: space-between;\n  .Tick24 {\n    opacity: 0;\n  }\n  &.MuifocusVisible,\n  &.MuifocusVisible .MuiTouchRipple-root {\n    color: ", " !important;\n    background-color: ", " !important;\n  }\n  &.Mui-selected {\n    color: ", " !important;\n    background-color: ", " !important;\n    .Tick24 {\n      opacity: 1;\n    }\n  }\n"])), theme.palette.primary[600], theme.palette.primary[100], theme.palette.primary[600], theme.palette.primary[100]);

var OUIDropdown = function OUIDropdown(_ref) {
  var selectSx = _ref.selectSx,
      controlSx = _ref.controlSx,
      labelSx = _ref.labelSx,
      errorMsg = _ref.errorMsg,
      fullwidth = _ref.fullwidth,
      props = _objectWithoutProperties(_ref, _excluded$c);

  var _React$useState = React__default["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focus = _React$useState2[0],
      setFocus = _React$useState2[1];

  var value = props.value,
      error = props.error,
      errormsg = props.errormsg,
      required = props.required,
      disabled = props.disabled,
      onClick = props.onClick,
      onChange = props.onChange,
      placeholder = props.placeholder,
      choice = props.choice;
  if (errorMsg) errormsg = errorMsg;
  if (errormsg) error = true;

  if (!controlSx) {
    controlSx = {};
  }

  if (fullwidth) {
    controlSx['width'] = '100%';
  }

  React.useEffect(function () {
    if (value) {
      setFocus(true);
    }
  }, []);

  var handleClickAway = function handleClickAway() {
    if (value) {
      setFocus(true);
      return;
    }

    setFocus(false);
  };

  var handleClick = function handleClick() {
    setFocus(true);
    onClick && onClick();
  };

  return /*#__PURE__*/React__default["default"].createElement(material.ClickAwayListener, {
    onClickAway: handleClickAway
  }, /*#__PURE__*/React__default["default"].createElement(material.FormControl, {
    required: required,
    error: error,
    disabled: disabled,
    sx: controlSx
  }, /*#__PURE__*/React__default["default"].createElement(StyledLabel, {
    id: "demo-simple-select-required-label",
    focused: focus || disabled,
    sx: labelSx
  }, placeholder), /*#__PURE__*/React__default["default"].createElement(StyledSelect, _extends({
    labelId: "demo-simple-select-required-label",
    id: "demo-simple-select-required",
    value: value,
    onChange: onChange,
    onClick: handleClick,
    variant: "filled",
    disableUnderline: true,
    IconComponent: ChevronDownSmall24__default["default"],
    sx: selectSx,
    _placeholder: placeholder,
    MenuProps: {
      sx: {
        '.MuiMenu-paper': {
          mt: 1,
          borderRadius: '8px'
        }
      }
    }
  }, props), choice && choice.map(function (item) {
    return /*#__PURE__*/React__default["default"].createElement(Item$1, {
      key: item,
      value: item
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "orkaui-select-text"
    }, item), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "orkaui-select-selectedicon"
    }, /*#__PURE__*/React__default["default"].createElement(Tick24__default["default"], {
      forceStroke: theme.palette.primary[600]
    })));
  })), error && errormsg && /*#__PURE__*/React__default["default"].createElement(material.Box // data-display={disableErrorDisplay || !error ? 'no' : 'yes'}
  , {
    style: {
      // display: disableErrorDisplay || !error ? 'none' : 'flex',
      display: 'flex',
      margin: error ? '8px 0 -8px 0' : '0',
      width: '100%',
      textAlign: 'left',
      alignItems: 'center'
    }
  }, error && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginRight: '3px',
      display: 'flex'
    }
  }, /*#__PURE__*/React__default["default"].createElement(WarningCircle24__default["default"], {
    size: '16px'
  })), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body4",
    style: {
      color: error ? theme.palette.error[300] : theme.palette.grey[400],
      lineHeight: '140%',
      letterSpacing: '-0.4px'
    }
  }, errormsg))));
};

var _excluded$b = ["size", "label", "controlSx"];

var _templateObject$9, _templateObject2$7, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10, _templateObject11, _templateObject12;
var CheckboxBase = styles.styled(material.Checkbox)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  &:hover {\n    background-color: transparent;\n    & > span {\n      background-color: ", ";\n    }\n  }\n"])), theme.palette.white.cold);

var CheckIcon$1 = function CheckIcon(_ref) {
  var size = _ref.size,
      disabled = _ref.disabled;
  var LargeOuterBase = styles.styled('span')(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 100%;\n    width: 24px;\n    height: 24px;\n    box-shadow: ", ";\n    margin: auto;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 2px ".concat(theme.palette.grey[400], " inset") : "0 0 0 2px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var MediumOuterBase = styles.styled('span')(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 100%;\n    width: 20px;\n    height: 20px;\n    box-shadow: ", ";\n    margin: auto;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 1px ".concat(theme.palette.grey[400], " inset") : "0 0 0 1px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var SmallOuterBase = styles.styled('span')(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    display: flex;\n    border-radius: 100%;\n    width: 12px;\n    height: 12px;\n    box-shadow: ", ";\n    margin: auto;\n    background-color: ", ";\n  "])), disabled ? "0 0 0 1px ".concat(theme.palette.grey[400], " inset") : "0 0 0 1px ".concat(theme.palette.primary[600], " inset"), disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var LargeInnerBase = styles.styled('span')(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 100%;\n    width: 12px;\n    height: 12px;\n    margin: auto;\n  "])), disabled ? theme.palette.grey[500] : theme.palette.primary[600]);
  var MediumInnerBase = styles.styled('span')(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 100%;\n    width: 14px;\n    height: 14px;\n    margin: auto;\n  "])), disabled ? theme.palette.grey[500] : theme.palette.primary[600]);
  var SmallInnerBase = styles.styled('span')(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 100%;\n    width: 6px;\n    height: 6px;\n    margin: auto;\n  "])), disabled ? theme.palette.grey[500] : theme.palette.primary[600]);
  var OuterBase, InnerBase;

  if (size === 'small') {
    OuterBase = SmallOuterBase;
    InnerBase = SmallInnerBase;
  } else if (size === 'large') {
    OuterBase = LargeOuterBase;
    InnerBase = LargeInnerBase;
  } else {
    OuterBase = MediumOuterBase;
    InnerBase = MediumInnerBase;
  }

  return /*#__PURE__*/React__default["default"].createElement(OuterBase, null, /*#__PURE__*/React__default["default"].createElement(InnerBase, null));
};

var UncheckIcon = function UncheckIcon(_ref2) {
  var size = _ref2.size,
      disabled = _ref2.disabled;
  var LargeBase = styles.styled('span')(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 2px ", " inset;\n    width: 24px;\n    height: 24px;\n    background-color: ", ";\n  "])), theme.palette.grey[400], disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var MediumBase = styles.styled('span')(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 1px ", " inset;\n    width: 20px;\n    height: 20px;\n    background-color: ", ";\n  "])), theme.palette.grey[500], disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var SmallBase = styles.styled('span')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 1px ", " inset;\n    width: 12px;\n    height: 12px;\n    background-color: ", ";\n  "])), theme.palette.grey[500], disabled ? theme.palette.grey[200] : theme.palette.white.main);
  var Base;

  if (size === 'small') {
    Base = SmallBase;
  } else if (size === 'large') {
    Base = LargeBase;
  } else {
    Base = MediumBase;
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, null);
};

var OUIRadio = function OUIRadio(_ref3) {
  var size = _ref3.size,
      label = _ref3.label,
      controlSx = _ref3.controlSx,
      props = _objectWithoutProperties(_ref3, _excluded$b);

  // const [checked, setChecked] = useState(false)
  var LargeBase = styles.styled(CheckboxBase)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    &:hover {\n      & > span {\n        box-shadow: 0 0 0 2px ", " inset;\n      }\n    }\n  "])), theme.palette.primary[600]);
  var ElseBase = styles.styled(CheckboxBase)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    &:hover {\n      & > span {\n        box-shadow: 0 0 0 1px ", " inset;\n      }\n    }\n  "])), theme.palette.primary[600]);
  var Base, variant;

  if (size === 'small') {
    Base = ElseBase;
    variant = 'caption';
  } else if (size === 'large') {
    Base = LargeBase;
    variant = 'subh1';
  } else {
    Base = ElseBase;
    variant = 'body2';
  }

  return /*#__PURE__*/React__default["default"].createElement(material.FormControlLabel, {
    control: /*#__PURE__*/React__default["default"].createElement(Base, _extends({
      checked: props.checked,
      onChange: props.onChange,
      name: "checkbox",
      checkedIcon: /*#__PURE__*/React__default["default"].createElement(CheckIcon$1, {
        size: size,
        disabled: props.disabled
      }),
      icon: /*#__PURE__*/React__default["default"].createElement(UncheckIcon, {
        size: size,
        disabled: props.disabled
      }),
      disableRipple: true
    }, props)),
    label: /*#__PURE__*/React__default["default"].createElement(material.Typography, {
      variant: variant,
      style: {
        display: 'inline',
        verticalAlign: 'middle',
        color: props.disabled ? theme.palette.grey[400] : theme.palette.grey[700]
      }
    }, label),
    sx: controlSx
  });
};

var _excluded$a = ["label", "icon", "text", "id", "key", "clicked", "setClicked", "children"],
    _excluded2$1 = ["label", "text", "id", "key", "multichoice", "clicked", "setClicked", "children"],
    _excluded3 = ["label", "title", "text", "id", "key", "multichoice", "clicked", "setClicked", "children"],
    _excluded4 = ["label", "icon", "text", "id", "key", "multichoice", "title", "clicked", "setClicked", "children"];

var _templateObject$8, _templateObject2$6, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1;
var IconWrapper = material.styled(material.Box)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  width: 288px;\n  height: 195px;\n  border-radius: 12px;\n  background-color: ", ";\n  padding: 16px 8px 0 12px;\n  transition-duration: 0.3s;\n  box-sizing: border-box;\n  margin: 2px 0;\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n    cursor: pointer;\n    & .orkaui-radio-button {\n      background-color: ", ";\n    }\n  }\n  &:active {\n    box-shadow: 0 0 0 2px ", ";\n    & .orkaui-radio-button {\n      background-color: ", ";\n    }\n  }\n"])), theme.palette.white.main, theme.palette.primary[600], theme.palette.white.cold, theme.palette.primary[600], theme.palette.white.main);
var ActiveIconWrapper = material.styled(material.Box)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  width: 288px;\n  height: 195px;\n  border-radius: 12px;\n  background-color: ", ";\n  box-shadow: 0 0 0 2px ", ";\n  cursor: pointer;\n  padding: 16px 8px 0 12px;\n  box-sizing: border-box;\n  margin: 2px 0;\n"])), theme.palette.primary[100], theme.palette.primary[600]);
var NoIconWrapper = material.styled(material.Box)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  min-width: 279px;\n  // max-width: 579px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  text-align: left;\n  transition-duration: 0.3s;\n  user-select: none;\n  padding: 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-sizing: border-box;\n  overflow: hidden;\n  margin: 2px 0;\n  & .orkaui-radio-button {\n    margin-right: 8px;\n    min-width: 24px;\n  }\n  &:hover {\n    background-color: ", ";\n    box-shadow: 0 0 0 2px ", ";\n    & .orkaui-radio-button {\n      margin-right: 8px;\n      background-color: ", ";\n      box-shadow: 0 0 0 2px ", " inset;\n    }\n  }\n  &:active .orkaui-radio-button {\n    box-shadow: 0 0 0 2px ", " inset;\n    background-color: ", ";\n  }\n  ", ": {\n    width: 90vw;\n    max-width: 579px;\n    border: solid 3px #ffffff;\n  }\n"])), theme.palette.white.main, theme.palette.white.main, theme.palette.primary[600], theme.palette.white.cold, theme.palette.primary[600], theme.palette.primary[600], theme.palette.primary[100], function (props) {
  return props.theme.breakpoints.down('md');
});
var ActiveNoIconWrapper = material.styled(material.Box)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  min-width: 279px;\n  // max-width: 579px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  text-align: left;\n  transition-duration: 0.3s;\n  user-select: none;\n  padding: 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-sizing: border-box;\n  box-shadow: 0 0 0 2px ", ";\n  overflow: hidden;\n  & .orkaui-radio-button {\n    margin-right: 8px;\n    min-width: 24px;\n  }\n  margin: 2px 0;\n"])), theme.palette.primary[100], theme.palette.primary[600]);

var SelectRadio = function SelectRadio(_ref) {
  var selected = _ref.selected;
  var OuterRadio = material.styled('div')(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 2px ", " inset;\n    width: 24px;\n    height: 24px;\n    background-color: ", ";\n    transition-duration: 0.3s;\n    box-sizing: border-box;\n  "])), theme.palette.grey[400], theme.palette.white.main);
  var ActiveOuterRadio = material.styled('div')(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 2px ", " inset;\n    width: 24px;\n    height: 24px;\n    background-color: ", ";\n    padding: 6px;\n    box-sizing: border-box;\n  "])), theme.palette.primary[600], theme.palette.primary[100]);
  var InnerRadio = material.styled('span')(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    display: block;\n    width: 12px;\n    height: 12px;\n    background-color: ", ";\n    border-radius: 100%;\n    margin: auto;\n    box-sizing: border-box;\n  "])), theme.palette.primary[600]);
  var Base = selected ? ActiveOuterRadio : OuterRadio;
  return /*#__PURE__*/React__default["default"].createElement(Base, {
    className: "orkaui-radio-button"
  }, selected && /*#__PURE__*/React__default["default"].createElement(InnerRadio, null));
};

var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.91006 10.9959L3.7071 8.79291C3.31658 8.40239 2.68342 8.40239 2.29289 8.79291C1.90237 9.18343 1.90237 9.8166 2.29289 10.2071L5.29288 13.2071C5.7168 13.631 6.4159 13.5892 6.7863 13.1178L13.7863 5.11786C14.1275 4.68359 14.0521 4.05494 13.6178 3.71372C13.1835 3.37251 12.5549 3.44795 12.2136 3.88222L5.91006 10.9959Z",
    fill: "white"
  }));
};

var SelectCheckbox = function SelectCheckbox(_ref2) {
  var selected = _ref2.selected;
      _ref2.className;
  var OuterRadio = material.styled('div')(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: 0 0 0 2px ", " inset;\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    background-color: ", ";\n    transition-duration: 0.3s;\n    box-sizing: border-box;\n  "])), theme.palette.grey[400], theme.palette.white.main);
  var ActiveOuterRadio = material.styled('div')(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: 0 0 0 2px ", " inset;\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    background-color: ", ";\n    padding: 4px;\n    box-sizing: border-box;\n  "])), theme.palette.primary[600], theme.palette.primary[600]);
  var Base = selected ? ActiveOuterRadio : OuterRadio;
  return /*#__PURE__*/React__default["default"].createElement(Base, {
    className: "orkaui-radio-button"
  }, selected && /*#__PURE__*/React__default["default"].createElement(CheckIcon, null));
};

var IconSelectbar = function IconSelectbar(_ref3) {
  var label = _ref3.label,
      icon = _ref3.icon;
      _ref3.text;
      var id = _ref3.id,
      key = _ref3.key,
      clicked = _ref3.clicked,
      setClicked = _ref3.setClicked,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded$a);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      _clicked = _useState2[0],
      _setClicked = _useState2[1];

  if (clicked === undefined) {
    clicked = _clicked;
    setClicked = _setClicked;
  }

  var Base = clicked ? ActiveIconWrapper : IconWrapper;

  var handleClick = function handleClick() {
    setClicked && setClicked(!clicked);
    props.onClick && props.onClick();
  };

  return /*#__PURE__*/React__default["default"].createElement(Base, {
    onClick: handleClick,
    id: id,
    key: key,
    sx: props.sx
  }, /*#__PURE__*/React__default["default"].createElement(SelectRadio, {
    selected: clicked
  }), /*#__PURE__*/React__default["default"].createElement(material.Box, {
    style: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '8px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, icon, /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    variant: "subh1",
    style: {
      marginTop: '16px'
    }
  }, label)), children);
};

var NoIconSelectbar = function NoIconSelectbar(_ref4) {
  var label = _ref4.label;
      _ref4.text;
      var id = _ref4.id,
      key = _ref4.key,
      multichoice = _ref4.multichoice,
      clicked = _ref4.clicked,
      setClicked = _ref4.setClicked,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded2$1);

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      _clicked = _useState4[0],
      _setClicked = _useState4[1];

  if (clicked === undefined) {
    clicked = _clicked;
    setClicked = _setClicked;
  }

  var Base = clicked ? ActiveNoIconWrapper : NoIconWrapper;

  var handleClick = function handleClick() {
    setClicked && setClicked(!clicked);
    props.onClick && props.onClick();
  };

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Base, {
    onClick: handleClick,
    id: id,
    key: key,
    sx: props.sx
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, multichoice ? /*#__PURE__*/React__default["default"].createElement(SelectCheckbox, {
    selected: clicked
  }) : /*#__PURE__*/React__default["default"].createElement(SelectRadio, {
    selected: clicked
  }), /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    variant: "subh1"
  }, label)), children));
};

var ComplexSelectBar = function ComplexSelectBar(_ref5) {
  var label = _ref5.label,
      title = _ref5.title;
      _ref5.text;
      var id = _ref5.id,
      key = _ref5.key,
      multichoice = _ref5.multichoice,
      clicked = _ref5.clicked,
      setClicked = _ref5.setClicked,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, _excluded3);

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      _clicked = _useState6[0],
      _setClicked = _useState6[1];

  if (clicked === undefined) {
    clicked = _clicked;
    setClicked = _setClicked;
  }

  var Base = clicked ? ActiveNoIconWrapper : NoIconWrapper;

  var handleClick = function handleClick() {
    setClicked && setClicked(!clicked);
    props.onClick && props.onClick();
  };

  return /*#__PURE__*/React__default["default"].createElement(Base, {
    onClick: handleClick,
    id: id,
    key: key,
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      padding: '24px',
      background: '#f1f1f1',
      width: '100%',
      boxSizing: 'border-box'
    }
  }, title), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      padding: '16px',
      background: '#ffffff',
      width: '100%',
      boxSizing: 'border-box'
    }
  }, label), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      padding: '0 14px 24px',
      background: '#ffffff',
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row-reverse'
    }
  }, multichoice ? /*#__PURE__*/React__default["default"].createElement(SelectCheckbox, {
    selected: clicked
  }) : /*#__PURE__*/React__default["default"].createElement(SelectRadio, {
    selected: clicked
  }), children)));
};

var OUISelectbar = function OUISelectbar(_ref6) {
  var label = _ref6.label,
      icon = _ref6.icon,
      text = _ref6.text,
      id = _ref6.id,
      key = _ref6.key,
      multichoice = _ref6.multichoice,
      title = _ref6.title,
      clicked = _ref6.clicked,
      setClicked = _ref6.setClicked,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, _excluded4);

  if (title === undefined) {
    return icon ? /*#__PURE__*/React__default["default"].createElement(IconSelectbar, _extends({
      label: label,
      icon: icon,
      text: text,
      id: id,
      key: key,
      multichoice: multichoice,
      clicked: clicked,
      setClicked: setClicked
    }, props), children) : /*#__PURE__*/React__default["default"].createElement(NoIconSelectbar, _extends({
      label: label,
      icon: icon,
      text: text,
      id: id,
      key: key,
      multichoice: multichoice,
      clicked: clicked,
      setClicked: setClicked
    }, props), children);
  } else {
    return /*#__PURE__*/React__default["default"].createElement(ComplexSelectBar, _extends({
      label: label,
      title: title,
      text: text,
      id: id,
      key: key,
      multichoice: multichoice,
      clicked: clicked,
      setClicked: setClicked
    }, props), children);
  }
};

var _excluded$9 = ["children", "clicked", "onClick", "disabled", "size", "today"];

var _templateObject$7, _templateObject2$5, _templateObject3$3, _templateObject4$3;
var Unselected$1 = material.styled(material.Button)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  border-radius: 100%;\n  width: 40px;\n  height: 40px;\n  min-width: 0;\n  padding: 0;\n  ", "\n  ", "\n  & span:first-of-type {\n    color: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  &.Mui-disabled {\n    & span:first-of-type {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.today && "box-shadow: 0 0 0 1.5px ".concat(theme.palette.primary[600], " inset;");
}, function (props) {
  return props.today && 'cursor: unset;';
}, theme.palette.grey[800], function (props) {
  return props.today ? theme.palette.primary[100] : theme.palette.grey[200];
}, theme.palette.grey[500]);
var SmallUnselected = material.styled(Unselected$1)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  & span:first-of-type {\n    font-size: 16px;\n  }\n"])));
var Selected$1 = material.styled(material.Button)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 100%;\n  width: 40px;\n  height: 40px;\n  min-width: 0;\n  padding: 0;\n  box-shadow: 0 8px 20px rgba(53, 140, 255, 0.1);\n  & span:first-of-type {\n    color: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), theme.palette.primary[700], theme.palette.white.main, theme.palette.primary[700], theme.palette.white.main);
var SmallSelected = material.styled(Selected$1)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  & span:first-of-type {\n    font-size: 16px;\n  }\n"])));

var DatePicker = function DatePicker(_ref) {
  var children = _ref.children,
      clicked = _ref.clicked,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      size = _ref.size,
      today = _ref.today,
      props = _objectWithoutProperties(_ref, _excluded$9);

  var Base;

  if (size === 'small' && !clicked) {
    Base = SmallUnselected;
  } else if (size === 'small' && clicked) {
    Base = SmallSelected;
  } else if (size !== 'small' && clicked) {
    Base = Selected$1;
  } else {
    Base = Unselected$1;
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, _extends({
    disabled: disabled,
    onClick: today ? null : onClick,
    today: today
  }, props), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "subh2"
  }, children));
};

var _excluded$8 = ["disabled", "onChange", "checked", "controlSx"];

var _templateObject$6, _templateObject2$4, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1;
var LargeBase = material.styled(material.Switch)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  width: 52px;\n  height: 32px;\n  padding: 4px;\n  &:hover {\n    & .MuiSwitch-track {\n      box-shadow: 0 0 0 4px ", ";\n    }\n    & .MuiSwitch-switchBase {\n      &.Mui-checked {\n        & + .MuiSwitch-track {\n          box-shadow: 0 0 0 4px ", ";\n        }\n      }\n    }\n  }\n  & .MuiSwitch-switchBase {\n    padding: 0;\n    margin: 6px;\n    &.Mui-checked {\n      & > .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n      & + .MuiSwitch-track {\n        background-color: ", ";\n        opacity: 1;\n      }\n    }\n    &.Mui-disabled {\n      & > .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n      & + .MuiSwitch-track {\n        background-color: ", ";\n        opacity: 1;\n        box-shadow: none;\n      }\n      &.Mui-checked {\n        & > .MuiSwitch-thumb {\n          background-color: ", ";\n        }\n        & + .MuiSwitch-track {\n          background-color: ", ";\n          opacity: 1;\n          box-shadow: none;\n        }\n      }\n    }\n  }\n  & .MuiSwitch-thumb {\n    box-shadow: none;\n  }\n  & .MuiSwitch-track {\n    width: 44px;\n    height: 24px;\n    background-color: ", ";\n    border-radius: 5000px;\n    opacity: 1;\n  }\n"])), theme.palette.grey[200], theme.palette.primary[200], theme.palette.white.main, theme.palette.primary[600], theme.palette.grey[400], theme.palette.grey[200], theme.palette.white.main, theme.palette.grey[400], theme.palette.grey[600]);
var MediumBase = material.styled(LargeBase)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 28px;\n  & .MuiSwitch-track {\n    width: 36px;\n    height: 20px;\n  }\n  & .MuiSwitch-thumb {\n    width: 16px;\n    height: 16px;\n  }\n  & .MuiSwitch-switchBase {\n    &.Mui-checked {\n      transform: translateX(16px);\n    }\n  }\n"])));
var SmallBase = material.styled(LargeBase)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  width: 34px;\n  height: 22px;\n  padding: 3px;\n  & .MuiSwitch-track {\n    width: 28px;\n    height: 16px;\n  }\n  & .MuiSwitch-thumb {\n    width: 12px;\n    height: 12px;\n  }\n  & .MuiSwitch-switchBase {\n    margin: 5px;\n    &.Mui-checked {\n      transform: translateX(12px);\n    }\n  }\n  &:hover {\n    & .MuiSwitch-track {\n      box-shadow: 0 0 0 3px ", ";\n    }\n    & .MuiSwitch-switchBase {\n      &.Mui-checked {\n        & + .MuiSwitch-track {\n          box-shadow: 0 0 0 3px ", ";\n        }\n      }\n    }\n  }\n"])), theme.palette.grey[200], theme.palette.primary[200]);
var LargeControlLabel = material.styled(material.FormControlLabel)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  & .MuiFormControlLabel-label {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    color: ", ";\n    margin-right: 24px;\n    &.Mui-disabled {\n      color: ", ";\n    }\n  }\n"])), theme.palette.grey[700], theme.palette.grey[400]);
var MediumControlLabel = material.styled(LargeControlLabel)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  & .MuiFormControlLabel-label {\n    font-size: 14px;\n    line-height: 20px;\n  }\n"])));
var SmallControlLabel = material.styled(LargeControlLabel)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  & .MuiFormControlLabel-label {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.4px;\n  }\n"])));

var OUISwitch = function OUISwitch(_ref) {
  var disabled = _ref.disabled,
      onChange = _ref.onChange,
      checked = _ref.checked,
      controlSx = _ref.controlSx,
      props = _objectWithoutProperties(_ref, _excluded$8);

  var Base, Control;

  if (props.size === 'large') {
    Base = LargeBase;
    Control = LargeControlLabel;
  } else if (props.size === 'small') {
    Base = SmallBase;
    Control = SmallControlLabel;
  } else {
    Base = MediumBase;
    Control = MediumControlLabel;
  }

  return /*#__PURE__*/React__default["default"].createElement(Control, {
    control: /*#__PURE__*/React__default["default"].createElement(Base, _extends({
      checked: checked,
      disabled: disabled,
      onChange: onChange
    }, props)),
    disabled: disabled,
    label: props.label,
    labelPlacement: "start",
    sx: controlSx
  });
};

var PREFIX = 'ExpandQuestions';
var classes = {
  summaryContainer: "".concat(PREFIX, "-summaryContainer"),
  summaryContent: "".concat(PREFIX, "-summaryContent"),
  summaryIcon: "".concat(PREFIX, "-summaryIcon"),
  detailsText: "".concat(PREFIX, "-detailsText")
};
var StyleAccordion = styles.styled(material.Accordion)(function () {
  return {
    margin: '0 !important',
    padding: '24px 0',
    boxShadow: 'none',
    minHeight: '36px',
    width: '100%',
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      minHeight: '36px'
    }
  };
});
var StyleAccordionSummary = styles.styled(material.AccordionSummary)(function () {
  var _ref;

  return _ref = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    margin: 0,
    padding: 0,
    minHeight: '36px !important',
    width: '100%',
    '& > div:first-of-type ': {
      margin: '0px'
    },
    '&$expanded': {
      minHeight: '36px'
    },
    content: {
      marginTop: '0px',
      marginBottom: '0px',
      '&$expanded': {
        margin: '0px 0px'
      }
    }
  }, _defineProperty(_ref, "& .".concat(classes.summaryContent), {
    flex: 1,
    paddingRight: '16px'
  }), _defineProperty(_ref, "& .".concat(classes.summaryIcon), {
    width: '32px',
    height: '32px',
    objectFit: 'contain',
    marginTop: 4
  }), _ref;
});
var StyleAccordionDetails = styles.styled(material.AccordionDetails)(function () {
  var _ref2;

  return _ref2 = {
    '& a': {
      color: theme.palette.multicolor[300],
      fontWeight: '600'
    },
    '& a:hover': {
      textDecoration: 'underline'
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    letterSpacing: 0.5,
    padding: '24px 0 0',
    '& a em': {
      fontStyle: 'normal'
    },
    '& *': _objectSpread2({
      width: '100%'
    }, theme.components.MuiTypography.styleOverrides.body2)
  }, _defineProperty(_ref2, "& p", {
    margin: '0'
  }), _defineProperty(_ref2, "& ul", {
    margin: '0'
  }), _defineProperty(_ref2, "& ol", {
    margin: '0'
  }), _defineProperty(_ref2, "&>div", {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  }), _ref2;
});

var numToLetter = function numToLetter(num) {
  num = new String(num);
  var letter = '';
  Array.from.apply(Array, _toConsumableArray(num)).forEach(function (n) {
    letter += String.fromCharCode(65 + n);
  });
  return letter;
};

function ExpandQuestions(props) {
  var question = props.question,
      answer = props.answer,
      expanded = props.expanded,
      setExpansion = props.setExpansion,
      id = props.id,
      overrides = props.overrides;
  var resultContent;

  if (typeof expanded === 'undefined') {
    var _React$useState = React__default["default"].useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        _expanded = _React$useState2[0],
        _setExpanded = _React$useState2[1];

    var _setExpansion = function _setExpansion() {
      return _setExpanded(!_expanded);
    };
  } else {
    var _expanded = expanded;
    var _setExpansion = setExpansion;
  }

  var mdOverrides = {};

  if (typeof answer === 'string') {
    resultContent = answer.replace(/<br>/g, '\n\n');

    if (Array.isArray(overrides)) {
      overrides.forEach(function (item, idx) {
        idx = numToLetter(idx);
        var text = item.text,
            component = item.component;
        resultContent = resultContent.replace(new RegExp(text, 'gi'), "<Replacementcomp".concat(idx, "/>"));
        mdOverrides["Replacementcomp".concat(idx)] = component;
      });
    }
  } else {
    // Directly render React Component
    resultContent = answer;
  }

  return /*#__PURE__*/React__default["default"].createElement(StyleAccordion, {
    expanded: _expanded,
    onChange: _setExpansion,
    id: id
  }, /*#__PURE__*/React__default["default"].createElement(StyleAccordionSummary, {
    className: classes.summaryContainer,
    id: id + '_question'
  }, typeof question === 'string' ? /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "title2",
    className: classes.summaryContent
  }, question) : /*#__PURE__*/React__default["default"].createElement(material.Box, {
    width: "100%"
  }, question), /*#__PURE__*/React__default["default"].createElement(InteractiveButton, {
    type: "expand",
    isActive: !_expanded,
    onClick: _setExpansion,
    sx: {
      padding: 0
    }
  })), /*#__PURE__*/React__default["default"].createElement(StyleAccordionDetails, {
    className: classes.detailsText,
    id: id + '_answer'
  }, typeof answer === 'string' ? /*#__PURE__*/React__default["default"].createElement(Markdown__default["default"], {
    options: {
      overrides: mdOverrides
    }
  }, resultContent) : resultContent));
}

function ProgressiveReading(props) {
  var content = props.content,
      exclusive = props.exclusive;
      props.expanded;
      props.setExpansion;
      var hasLastDivider = props.hasLastDivider,
      overrides = props.overrides;

  var _React$useState3 = React__default["default"].useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      expandId = _React$useState4[0],
      setExpandId = _React$useState4[1];

  if (exclusive) {
    return content.map(function (itm, idx) {
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
        key: idx
      }, /*#__PURE__*/React__default["default"].createElement(ExpandQuestions, {
        question: itm.question,
        answer: itm.answer,
        expanded: expandId === idx,
        setExpansion: function setExpansion() {
          return setExpandId(idx === expandId ? (idx + 1) % content.length : idx);
        },
        id: itm.id
      }), (hasLastDivider || idx < content.length - 1) && /*#__PURE__*/React__default["default"].createElement("hr", {
        style: {
          border: 'none',
          borderBottom: '1px 0 0 0 0 solid #E6E6E6',
          margin: 0
        }
      }));
    });
  }

  return content.map(function (itm, idx) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: idx
    }, /*#__PURE__*/React__default["default"].createElement(ExpandQuestions, {
      question: itm.question,
      answer: itm.answer,
      key: idx,
      expanded: itm.expanded,
      setExpansion: itm.setExpansion,
      id: itm.id,
      overrides: overrides
    }), (hasLastDivider || idx < content.length - 1) && /*#__PURE__*/React__default["default"].createElement("hr", {
      style: {
        border: 'none',
        borderBottom: '1px solid #E6E6E6',
        margin: 0
      }
    }));
  });
}

var _excluded$7 = ["light"],
    _excluded2 = ["light"];

var _templateObject$5, _templateObject2$3;
var Bg = material.styled(material.Button)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 40px;\n  height: 40px;\n  min-width: 0;\n  padding: 0;\n  border-radius: 100%;\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n    svg {\n      path {\n        fill: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n  &:active {\n    background-color: ", ";\n  }\n"])), theme.palette.grey[300], theme.palette.grey[400], theme.palette.grey[300], theme.palette.primary[600], theme.palette.primary[600], theme.palette.grey[400]);
var LightBg = material.styled(Bg)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 40px;\n  height: 40px;\n  min-width: 0;\n  padding: 0;\n  border-radius: 100%;\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n    svg {\n      path {\n        fill: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg {\n      path {\n        fill: ", ";\n      }\n      line {\n        stroke: ", ";\n      }\n    }\n  }\n"])), theme.palette.white.main, theme.palette.grey[200], theme.palette.grey[200], theme.palette.grey[800], theme.palette.grey[800], theme.palette.grey[200], theme.palette.primary[600], theme.palette.primary[600]);
var SwitchPageLeft = function SwitchPageLeft(_ref) {
  var light = _ref.light,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var Base;
  Base = light ? LightBg : Bg;
  return /*#__PURE__*/React__default["default"].createElement(Base, props, /*#__PURE__*/React__default["default"].createElement(ArrowLeft24__default["default"], null));
};
var SwitchPageRight = function SwitchPageRight(_ref2) {
  var light = _ref2.light,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var Base;
  Base = light ? LightBg : Bg;
  return /*#__PURE__*/React__default["default"].createElement(Base, props, /*#__PURE__*/React__default["default"].createElement(ArrowRight24__default["default"], null));
};

var _excluded$6 = ["children", "clicked", "onClick", "fullWidth", "disabled"];

var _templateObject$4, _templateObject2$2;
var Unselected = material.styled(material.Button)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tbox-shadow: 0 0 0 1px ", " inset;\n\twidth: ", ";\n\tborder-radius: 8px;\n\tmin-width: 0;\n\tpadding: 8px 14px;\n\t& span:first-of-type {\n\t\tcolor: ", ";\n\t}\n\t&:hover {\n\t\tbox-shadow: unset;\n\t\tbackground-color: ", ";\n\t}\n\t&.Mui-disabled {\n\t\tbox-shadow: unset;\n\t\tbackground-color: ", ";\n\t\t& span:first-of-type {rgba(25, 118, 210, 0.04);\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"])), theme.palette.white.main, theme.palette.grey[300], function (props) {
  return props.fullWidth ? '100%' : 'fit-content';
}, theme.palette.grey[600], theme.palette.grey[200], theme.palette.grey[200], theme.palette.grey[400]);
var Selected = material.styled(Unselected)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: unset;\n  border-radius: 8px;\n  min-width: 0;\n  padding: 8px 14px;\n  & span:first-of-type {\n    color: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), theme.palette.primary[700], theme.palette.white.main, theme.palette.primary[700], theme.palette.white.main);

var TimeSlot = function TimeSlot(_ref) {
  var children = _ref.children,
      clicked = _ref.clicked,
      onClick = _ref.onClick,
      fullWidth = _ref.fullWidth,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded$6);

  var Base;

  if (clicked) {
    Base = Selected;
  } else {
    Base = Unselected;
  }

  return /*#__PURE__*/React__default["default"].createElement(Base, _extends({
    disabled: disabled,
    onClick: onClick,
    fullWidth: fullWidth
  }, props), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "subh2"
  }, children));
};

var _excluded$5 = ["count", "icon"];

var _templateObject$3;
var Item = material.styled(material.PaginationItem)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  background-color: ", ";\n  border-radius: 0px;\n  color: ", ";\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.24px;\n  font-weight: 400;\n  padding: 0;\n  margin: 0;\n  &.MuiPaginationItem-sizeLarge {\n    width: 48px;\n    height: 48px;\n    font-size: 16px;\n    &.MuiPaginationItem-previousNext {\n      width: ", ";\n    }\n  }\n  &.MuiPaginationItem-sizeSmall {\n    width: 36px;\n    height: 36px;\n    font-size: 12px;\n    &.MuiPaginationItem-previousNext {\n      width: ", ";\n    }\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  & svg {\n    path {\n      stroke: ", ";\n    }\n  }\n  &.Mui-selected {\n    background-color: ", ";\n    color: ", ";\n    border-radius: 4px;\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &.MuiPaginationItem-ellipsis {\n    padding: 10px;\n  }\n  &.MuiPaginationItem-previousNext {\n    width: ", ";\n    margin: 0 16px;\n    &:active {\n      background-color: ", ";\n    }\n  }\n"])), theme.palette.white.main, theme.palette.grey[700], function (props) {
  return props.icon ? '48px' : '71px';
}, function (props) {
  return props.icon ? '36px' : '49px';
}, theme.palette.white.main, theme.palette.grey[500], theme.palette.primary[600], theme.palette.white.main, theme.palette.primary[600], theme.palette.primary[600], function (props) {
  return props.icon ? '40px' : '58px';
}, theme.palette.white.main);

var RightButton = function RightButton(_ref) {
  var size = _ref.size;
  var fz;
  if (size === 'large') fz = '16px';else if (size === 'small') fz = '12px';else fz = '14px';
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    style: {
      fontSize: fz,
      fontWeight: '600',
      lineHeight: '24px',
      color: theme.palette.grey[500]
    }
  }, "Next"), /*#__PURE__*/React__default["default"].createElement(ChevronRightSmall24__default["default"], null));
};

var LeftButton = function LeftButton(_ref2) {
  var size = _ref2.size;
  var fz;
  if (size === 'large') fz = '16px';else if (size === 'small') fz = '12px';else fz = '14px';
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ChevronLeft24__default["default"], null), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    style: {
      fontSize: fz,
      fontWeight: '600',
      lineHeight: '16px',
      color: theme.palette.grey[500]
    }
  }, "Back"));
};

var OUIPagination = function OUIPagination(_ref3) {
  var count = _ref3.count,
      icon = _ref3.icon,
      props = _objectWithoutProperties(_ref3, _excluded$5);

  return /*#__PURE__*/React__default["default"].createElement(material.Pagination, _extends({
    count: count,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/React__default["default"].createElement(Item, _extends({
        components: {
          next: icon ? ChevronRightSmall24__default["default"] : function () {
            return /*#__PURE__*/React__default["default"].createElement(RightButton, {
              size: props.size
            });
          },
          previous: icon ? ChevronLeft24__default["default"] : function () {
            return /*#__PURE__*/React__default["default"].createElement(LeftButton, {
              size: props.size
            });
          }
        }
      }, item));
    }
  }, props));
};

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var ActiveBase = material.styled('div')(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n  box-sizing: border-box;\n"])), theme.palette.grey[800]);
var PendingBase = material.styled(ActiveBase)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: 0 0 0 1.5px ", " inset;\n  padding: 6px;\n"])), theme.palette.white.main, theme.palette.grey[800]);
var InactiveBase = material.styled(ActiveBase)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: 0 0 0 1.5px ", " inset;\n  padding: 6px;\n"])), theme.palette.grey[200], theme.palette.grey[400]);
var ActiveLine = material.styled('div')(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  height: 1.5px;\n  background-color: ", ";\n  width: ", ";\n"])), theme.palette.grey[800], function (props) {
  return props.length;
});
var InactiveLine = material.styled(ActiveLine)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), theme.palette.grey[400]);
var ActiveVerticalLine = material.styled('div')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 1.5px;\n  background-color: ", ";\n  height: ", ";\n"])), theme.palette.grey[800], function (props) {
  return props.length;
});
var InactiveVerticalLine = material.styled(ActiveVerticalLine)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), theme.palette.grey[400]);
var Controller = material.styled(material.FormControlLabel)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 0;\n"])));

var ActiveCircle = function ActiveCircle(_ref) {
  var tail = _ref.tail,
      placement = _ref.placement,
      length = _ref.length;
  var line;

  if (placement === 'top' || placement === 'bottom') {
    line = /*#__PURE__*/React__default["default"].createElement(ActiveVerticalLine, {
      length: length
    });
  } else {
    line = /*#__PURE__*/React__default["default"].createElement(ActiveLine, {
      length: length
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(Controller, {
    control: /*#__PURE__*/React__default["default"].createElement(ActiveBase, null, /*#__PURE__*/React__default["default"].createElement(Tick24__default["default"], {
      size: '16px',
      forceStroke: "white"
    })),
    label: tail && line,
    labelPlacement: placement
  });
};

var PendingCircle = function PendingCircle(_ref2) {
  var tail = _ref2.tail,
      placement = _ref2.placement,
      length = _ref2.length,
      content = _ref2.content;
  var line;

  if (placement === 'top' || placement === 'bottom') {
    line = /*#__PURE__*/React__default["default"].createElement(ActiveVerticalLine, {
      length: length
    });
  } else {
    line = /*#__PURE__*/React__default["default"].createElement(ActiveLine, {
      length: length
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(Controller, {
    control: /*#__PURE__*/React__default["default"].createElement(PendingBase, null, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
      variant: "subh1"
    }, content)),
    label: tail && line,
    labelPlacement: placement
  });
};

var InactiveCircle = function InactiveCircle(_ref3) {
  var tail = _ref3.tail,
      placement = _ref3.placement,
      length = _ref3.length,
      content = _ref3.content;
  var line;

  if (placement === 'top' || placement === 'bottom') {
    line = /*#__PURE__*/React__default["default"].createElement(InactiveVerticalLine, {
      length: length
    });
  } else {
    line = /*#__PURE__*/React__default["default"].createElement(InactiveLine, {
      length: length
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(Controller, {
    control: /*#__PURE__*/React__default["default"].createElement(InactiveBase, null, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
      variant: "subh1",
      style: {
        color: theme.palette.grey[500]
      }
    }, content)),
    label: tail && line,
    labelPlacement: placement
  });
};

var StepCircle = function StepCircle(_ref4) {
  var state = _ref4.state,
      tail = _ref4.tail,
      placement = _ref4.placement,
      length = _ref4.length,
      content = _ref4.content;
  var circle;

  if (state === 1) {
    circle = /*#__PURE__*/React__default["default"].createElement(PendingCircle, {
      tail: tail,
      placement: placement,
      length: length,
      content: content
    });
  } else if (state === 2) {
    circle = /*#__PURE__*/React__default["default"].createElement(InactiveCircle, {
      tail: tail,
      placement: placement,
      length: length,
      content: content
    });
  } else {
    circle = /*#__PURE__*/React__default["default"].createElement(ActiveCircle, {
      tail: tail,
      placement: placement,
      length: length
    });
  }

  return circle;
};

var BorderLinearProgress = material.styled(material.LinearProgress)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: 11px;\n  border-radius: 10;\n  backgroundcolor: #eeeeee;\n  &.MuiLinearProgress-colorPrimary {\n    background-color: #ebebeb;\n  }\n  & .MuiLinearProgress-bar {\n    border-radius: 11px;\n    background-color: ", ";\n  }\n"])), theme.palette.primary[500]);

var OUILinearProgress = function OUILinearProgress(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    sx: {
      marginTop: '1px',
      width: '100%',
      p: {
        xs: '42px 0 0',
        md: '55px 0 0'
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(BorderLinearProgress, {
    variant: "determinate",
    value: props.progress
  }));
};

var _excluded$4 = ["className"];
var BootstrapTooltip = material.styled(function (_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded$4);

  if (!props.title) props.title = props.content; // orkaui 1.0 compatibility fitting

  return /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], _extends({}, props, {
    arrow: true,
    classes: {
      popper: className
    }
  }));
})(function () {
  var _ref2;

  return _ref2 = {
    filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.08))'
  }, _defineProperty(_ref2, "& .".concat(Tooltip.tooltipClasses.arrow), {
    color: theme.palette.common.white
  }), _defineProperty(_ref2, "& .".concat(Tooltip.tooltipClasses.tooltip), _objectSpread2({
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[700],
    padding: '12px',
    borderRadius: '8px'
  }, theme.components.MuiTypography.styleOverrides.body3)), _ref2;
});

var _templateObject$1;
var CouponDiv = material.styled(material.Box)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 8px 4px 8px 8px;\n  width: fit-content;\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])), theme.palette.grey[100]);

var Coupon = function Coupon(_ref) {
  var content = _ref.content,
      onClick = _ref.onClick,
      sx = _ref.sx;
  return /*#__PURE__*/React__default["default"].createElement(CouponDiv, {
    sx: sx
  }, /*#__PURE__*/React__default["default"].createElement(material.Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      marginRight: '4px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Coupon24__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body2",
    style: {
      marginRight: '8px'
    }
  }, content)), /*#__PURE__*/React__default["default"].createElement("div", {
    onClick: onClick,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Close24__default["default"], {
    forceFill: "#979797"
  })));
};

var Section = function Section(props) {
  var type = props.type,
      grid = props.grid,
      horizontalAlign = props.horizontalAlign,
      verticalAlign = props.verticalAlign;
  var minHeight = props.minHeight;

  if (!minHeight) {
    switch (type) {
      case 'first':
        minHeight = '85vh';
        break;

      case 'full':
        minHeight = '100vh';
        break;

      default:
        minHeight = 0;
    }
  } // parse horizontal and vertical align attributes


  var horizontalAlignFlex, verticalAlignFlex;

  switch (true) {
    case !horizontalAlign || horizontalAlign === 'left':
      {
        horizontalAlignFlex = 'flex-start';
        break;
      }

    case horizontalAlign === 'right':
      {
        horizontalAlignFlex = 'flex-end';
        break;
      }

    default:
      horizontalAlignFlex = horizontalAlign;
  }

  switch (true) {
    case !verticalAlign || verticalAlign === 'top':
      {
        verticalAlignFlex = 'flex-start';
        break;
      }

    case verticalAlign === 'bottom':
      {
        verticalAlignFlex = 'flex-end';
        break;
      }

    default:
      verticalAlignFlex = verticalAlign;
  }

  var defaultStyles = _objectSpread2({
    padding: {
      xs: '40px 16px',
      sm: '80px 80px',
      md: '80px max(108px, calc(100% - 1320px)/2)'
    },
    maxWidth: 'calc(1320px + max(108px, calc(100% - 1320px)))',
    boxSizing: 'border-box',
    minHeight: minHeight,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: verticalAlignFlex
  }, props.sx);

  if (grid) {
    return /*#__PURE__*/React__default["default"].createElement(material.Box, {
      sx: _objectSpread2({}, defaultStyles)
    }, /*#__PURE__*/React__default["default"].createElement(material.Grid, {
      container: true,
      spacing: {
        sm: 3,
        xs: 2
      },
      rowSpacing: 1,
      columns: {
        xs: 4,
        sm: 8,
        md: 12
      },
      children: props.children,
      sx: {
        justifyContent: horizontalAlign
      }
    }));
  } else {
    return /*#__PURE__*/React__default["default"].createElement(material.Box, _extends({}, props, {
      sx: _objectSpread2({
        alignItems: horizontalAlignFlex
      }, defaultStyles)
    }));
  }
};

var GridBreak = function GridBreak() {
  return /*#__PURE__*/React__default["default"].createElement(material.Box, {
    sx: {
      width: '100%'
    }
  });
};

var AppGalleryBlack = "<svg width=\"133\" height=\"40\" viewBox=\"0 0 133 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"132\" height=\"39\" rx=\"5.5\" fill=\"black\" stroke=\"#A6A6A6\"/>\n<path d=\"M45.3962 25.4116H48.8919L47.6404 22.0615C47.4682 21.5986 47.2989 21.0875 47.1319 20.5276C46.9813 21.0229 46.817 21.5286 46.6394 22.0453L45.3962 25.4116ZM49.4893 27.0021H44.8068L43.6607 30.1344H41.6021L46.1874 18.4368H48.133L52.8234 30.1344H50.6599L49.4893 27.0021Z\" fill=\"white\"/>\n<path d=\"M58.8962 28.0072C59.3026 27.461 59.5058 26.663 59.5058 25.6135C59.5058 24.6396 59.3375 23.933 59.0013 23.4942C58.6647 23.0557 58.2167 22.8364 57.657 22.8364C57.2695 22.8364 56.9117 22.9281 56.5834 23.1109C56.2551 23.2939 55.9429 23.5387 55.6469 23.8455V28.5117C55.8461 28.6085 56.0775 28.6853 56.3413 28.7416C56.605 28.7984 56.8661 28.8266 57.1242 28.8266C57.8994 28.8266 58.4898 28.5533 58.8962 28.0072ZM53.653 23.555C53.653 22.9092 53.6314 22.1986 53.5885 21.4237H55.4613C55.5311 21.7844 55.5797 22.1531 55.6066 22.5297C56.3815 21.6849 57.2695 21.2622 58.2706 21.2622C58.8519 21.2622 59.3901 21.4088 59.8853 21.7021C60.3802 21.9955 60.7799 22.4583 61.0839 23.0906C61.3882 23.7231 61.5402 24.5265 61.5402 25.5005C61.5402 26.5177 61.3666 27.387 61.0194 28.108C60.6722 28.8294 60.1866 29.3754 59.5623 29.747C58.9381 30.1181 58.2167 30.3039 57.3989 30.3039C56.8066 30.3039 56.2226 30.2042 55.6469 30.0053V33.6056L53.653 33.7752V23.555Z\" fill=\"white\"/>\n<path d=\"M67.9935 28.0072C68.3999 27.461 68.6031 26.663 68.6031 25.6135C68.6031 24.6396 68.4349 23.933 68.0986 23.4942C67.7621 23.0557 67.3141 22.8364 66.7543 22.8364C66.3669 22.8364 66.009 22.9281 65.6807 23.1109C65.3522 23.2939 65.0402 23.5387 64.7442 23.8455V28.5117C64.9434 28.6085 65.1746 28.6853 65.4386 28.7416C65.7021 28.7984 65.9631 28.8266 66.2215 28.8266C66.9964 28.8266 67.5871 28.5533 67.9935 28.0072ZM62.7501 23.555C62.7501 22.9092 62.7285 22.1986 62.6855 21.4237H64.5586C64.6285 21.7844 64.677 22.1531 64.7039 22.5297C65.4789 21.6849 66.3668 21.2622 67.3679 21.2622C67.9493 21.2622 68.4871 21.4088 68.9826 21.7021C69.4775 21.9955 69.8772 22.4583 70.1815 23.0906C70.4852 23.7231 70.6375 24.5265 70.6375 25.5005C70.6375 26.5177 70.4637 27.387 70.1167 28.108C69.7695 28.8294 69.2837 29.3754 68.6597 29.747C68.0351 30.1181 67.314 30.3039 66.4959 30.3039C65.9039 30.3039 65.3199 30.2042 64.7442 30.0053V33.6056L62.7501 33.7752V23.555Z\" fill=\"white\"/>\n<path d=\"M74.3005 29.5813C73.4391 29.1053 72.7773 28.4229 72.3146 27.5349C71.8514 26.6469 71.6202 25.5974 71.6202 24.3864C71.6202 23.0734 71.8866 21.9578 72.4194 21.0401C72.9522 20.1227 73.6775 19.4337 74.5949 18.9735C75.5127 18.5134 76.5418 18.2833 77.6831 18.2833C78.3557 18.2833 78.9975 18.3574 79.6085 18.5053C80.2191 18.6534 80.7882 18.8564 81.3159 19.1149L80.8071 20.6486C79.7468 20.1428 78.7351 19.8898 77.7719 19.8898C76.9591 19.8898 76.2474 20.0634 75.6367 20.4106C75.0258 20.7578 74.5506 21.2677 74.2117 21.9404C73.8725 22.6132 73.7031 23.4258 73.7031 24.3783C73.7031 25.2128 73.8335 25.9526 74.0943 26.5984C74.3557 27.2442 74.7674 27.7557 75.3298 28.1323C75.8922 28.509 76.6013 28.6973 77.457 28.6973C77.8445 28.6973 78.2319 28.6651 78.6194 28.6005C79.0069 28.536 79.3703 28.4418 79.7093 28.3179V25.9526H77.005V24.4026H81.6469V29.3272C80.9794 29.6392 80.2783 29.8789 79.5439 30.0456C78.809 30.2123 78.0786 30.2957 77.3519 30.2957C76.1786 30.2957 75.1613 30.0579 74.3005 29.5813Z\" fill=\"white\"/>\n<path d=\"M87.5381 28.5197C87.9522 28.3208 88.2914 28.073 88.5551 27.7771V26.1625C88.0114 26.1034 87.5674 26.0737 87.2231 26.0737C86.3997 26.0737 85.8303 26.2068 85.5159 26.4734C85.2007 26.7394 85.0434 27.0989 85.0434 27.5509C85.0434 27.9818 85.1578 28.3005 85.3866 28.5077C85.6154 28.7149 85.9261 28.8184 86.3189 28.8184C86.717 28.8184 87.1234 28.7189 87.5381 28.5197ZM88.7327 30.1344C88.6626 29.7952 88.6167 29.4106 88.5954 28.98C88.2887 29.3461 87.8893 29.6568 87.3965 29.9125C86.9045 30.168 86.3485 30.2957 85.7295 30.2957C85.229 30.2957 84.773 30.1976 84.361 30.001C83.9498 29.8048 83.6226 29.5087 83.3805 29.113C83.1383 28.7176 83.017 28.2347 83.017 27.6639C83.017 26.8192 83.321 26.145 83.9293 25.6416C84.5375 25.1385 85.5519 24.887 86.9727 24.887C87.5055 24.887 88.033 24.9248 88.5551 25V24.8305C88.5551 24.0609 88.3909 23.5187 88.0626 23.2036C87.7343 22.889 87.2634 22.7316 86.6501 22.7316C86.2247 22.7316 85.7701 22.7935 85.2855 22.9172C84.8013 23.0411 84.3759 23.189 84.0101 23.3612L83.6951 21.9081C84.0503 21.7465 84.5186 21.5986 85.0999 21.464C85.6813 21.3297 86.2946 21.2622 86.9405 21.2622C87.6941 21.2622 88.3343 21.3765 88.8618 21.6052C89.3893 21.834 89.801 22.2271 90.097 22.7838C90.393 23.3411 90.541 24.0906 90.541 25.0323V28.4954C90.541 28.8562 90.5623 29.4027 90.6055 30.1344H88.7327Z\" fill=\"white\"/>\n<path d=\"M92.0709 28.0434V17.7505L94.0567 17.5891V27.6882C94.0567 28.0597 94.1199 28.3218 94.2463 28.4754C94.3727 28.6285 94.5732 28.7056 94.8479 28.7056C94.9716 28.7056 95.1466 28.676 95.3724 28.6168L95.6066 30.0456C95.418 30.121 95.1882 30.1816 94.9167 30.2272C94.6447 30.2728 94.3876 30.2957 94.1455 30.2957C92.762 30.2957 92.0709 29.5451 92.0709 28.0434Z\" fill=\"white\"/>\n<path d=\"M97.0356 28.0434V17.7505L99.0215 17.5891V27.6882C99.0215 28.0597 99.0847 28.3218 99.2111 28.4754C99.3378 28.6285 99.5383 28.7056 99.8127 28.7056C99.9365 28.7056 100.111 28.676 100.338 28.6168L100.572 30.0456C100.383 30.121 100.153 30.1816 99.8815 30.2272C99.6095 30.2728 99.3524 30.2957 99.1103 30.2957C97.7271 30.2957 97.0356 29.5451 97.0356 28.0434Z\" fill=\"white\"/>\n<path d=\"M106.795 24.7659C106.755 24.0716 106.581 23.551 106.269 23.2036C105.957 22.8568 105.539 22.683 105.019 22.683C104.512 22.683 104.091 22.8581 103.755 23.2078C103.419 23.5578 103.197 24.0771 103.096 24.7659H106.795ZM108.739 26.0333H103.04C103.131 27.8579 104 28.7701 105.648 28.7701C106.056 28.7701 106.475 28.7203 106.904 28.6208C107.331 28.521 107.741 28.388 108.133 28.221L108.571 29.5853C107.595 30.0592 106.501 30.2957 105.285 30.2957C104.357 30.2957 103.579 30.121 102.944 29.7711C102.307 29.4213 101.829 28.9181 101.509 28.2613C101.19 27.6051 101.03 26.8138 101.03 25.888C101.03 24.9248 101.199 24.0958 101.539 23.4016C101.877 22.7073 102.349 22.1773 102.955 21.8112C103.56 21.4453 104.259 21.2622 105.051 21.2622C105.875 21.2622 106.56 21.4547 107.112 21.8396C107.664 22.2241 108.072 22.737 108.339 23.3773C108.605 24.018 108.739 24.7255 108.739 25.5005V26.0333Z\" fill=\"white\"/>\n<path d=\"M110.248 23.6115C110.248 23.1326 110.224 22.4034 110.181 21.4237H112.048C112.08 21.6659 112.109 21.9552 112.141 22.2916C112.171 22.6279 112.189 22.901 112.2 23.1109C112.432 22.7288 112.659 22.4073 112.883 22.1463C113.107 21.8851 113.368 21.6727 113.667 21.5083C113.965 21.3443 114.304 21.2622 114.688 21.2622C114.995 21.2622 115.256 21.2946 115.477 21.3592L115.227 23.0868C115.035 23.0276 114.819 22.9979 114.581 22.9979C114.115 22.9979 113.704 23.1177 113.355 23.3573C113.005 23.5965 112.632 23.9908 112.232 24.5398V30.1344H110.248V23.6115Z\" fill=\"white\"/>\n<path d=\"M116.597 33.6984C116.307 33.6475 116.067 33.5896 115.88 33.5251L116.243 32.072C116.376 32.1094 116.547 32.1458 116.752 32.1808C116.955 32.216 117.149 32.2333 117.333 32.2333C118.216 32.2333 118.877 31.6653 119.317 30.5299L119.448 30.207L116.235 21.4237H118.373L119.989 26.332C120.251 27.1717 120.421 27.8149 120.496 28.2613C120.648 27.6317 120.824 27.0021 121.029 26.3724L122.669 21.4237H124.677L121.475 30.2475C121.173 31.0816 120.845 31.7541 120.496 32.2656C120.147 32.7768 119.733 33.1562 119.259 33.4039C118.781 33.6512 118.208 33.7752 117.533 33.7752C117.2 33.7752 116.888 33.7499 116.597 33.6984Z\" fill=\"white\"/>\n<path d=\"M41.5933 7.30106H45.1474L45.0474 8.15946H42.6349V9.82186H44.9098V10.6261H42.6349V12.4677H45.1765L45.089 13.3344H41.5933V7.30106Z\" fill=\"white\"/>\n<path d=\"M47.5973 10.2552L45.7223 7.30106H46.9055L48.1765 9.472L49.514 7.30106H50.6639L48.8055 10.2176L50.8181 13.3344H49.6181L48.1807 10.9595L46.7181 13.3344H45.5682L47.5973 10.2552Z\" fill=\"white\"/>\n<path d=\"M54.1973 9.99466C54.4194 9.7936 54.5306 9.50933 54.5306 9.14266C54.5306 8.7704 54.4172 8.50266 54.1911 8.33866C53.9647 8.17466 53.6319 8.0928 53.1932 8.0928H52.6266V10.2344C52.8876 10.276 53.0876 10.2968 53.2266 10.2968C53.6514 10.2968 53.9751 10.1963 54.1973 9.99466ZM51.5847 7.30106H53.2098C53.9735 7.30106 54.5583 7.4568 54.9639 7.76773C55.3695 8.07893 55.5722 8.5288 55.5722 9.1176C55.5722 9.5176 55.4813 9.8672 55.2994 10.1656C55.1173 10.4643 54.8639 10.6936 54.5388 10.8531C54.214 11.0131 53.8402 11.0928 53.418 11.0928C53.1876 11.0928 52.9236 11.0651 52.6266 11.0093V13.3344H51.5847V7.30106Z\" fill=\"white\"/>\n<path d=\"M56.6015 7.30106H57.6431V12.4427H60.1389L60.0514 13.3344H56.6015V7.30106Z\" fill=\"white\"/>\n<path d=\"M64.4223 12.2989C64.714 12.1032 64.9319 11.8339 65.0764 11.4907C65.221 11.1477 65.2932 10.7552 65.2932 10.3136C65.2932 9.88026 65.2292 9.49439 65.1015 9.15519C64.9735 8.81625 64.7695 8.54639 64.489 8.34479C64.2084 8.14346 63.8474 8.04266 63.4055 8.04266C62.9834 8.04266 62.625 8.14479 62.3306 8.34906C62.0362 8.55306 61.8154 8.82692 61.6682 9.16986C61.521 9.51306 61.4474 9.89145 61.4474 10.3053C61.4474 10.7413 61.5167 11.1317 61.6556 11.476C61.7943 11.8205 62.0068 12.0928 62.2932 12.2928C62.5791 12.4928 62.9332 12.5928 63.3556 12.5928C63.7751 12.5928 64.1306 12.4947 64.4223 12.2989ZM61.7223 13.0387C61.2807 12.7859 60.9431 12.4309 60.7098 11.9739C60.4764 11.5171 60.3599 10.9859 60.3599 10.3803C60.3599 9.74426 60.4839 9.18799 60.7327 8.71146C60.9813 8.23519 61.3396 7.86719 61.8076 7.60719C62.2756 7.34772 62.8277 7.21759 63.4639 7.21759C64.0722 7.21759 64.5959 7.34346 65.0348 7.59466C65.4735 7.84639 65.8084 8.19972 66.0388 8.65519C66.2695 9.11092 66.3847 9.63865 66.3847 10.2387C66.3847 10.8859 66.2591 11.4485 66.0076 11.9261C65.7562 12.4037 65.3981 12.772 64.9327 13.0301C64.4674 13.2885 63.921 13.4177 63.2932 13.4177C62.6876 13.4177 62.1639 13.2915 61.7223 13.0387Z\" fill=\"white\"/>\n<path d=\"M69.1807 10.1552C69.4333 10.1552 69.657 10.1061 69.8514 10.0072C70.0458 9.9088 70.1973 9.76986 70.3055 9.59066C70.4141 9.41146 70.4682 9.20373 70.4682 8.96773C70.4682 8.66506 70.3722 8.44346 70.1807 8.3032C69.989 8.16293 69.7098 8.0928 69.3431 8.0928H68.589V10.1552H69.1807ZM67.5474 7.30106H69.4349C70.1237 7.30106 70.6453 7.43866 70.9994 7.7136C71.3535 7.98853 71.5306 8.38186 71.5306 8.8928C71.5306 9.21226 71.4666 9.4936 71.3389 9.73653C71.2111 9.97973 71.0527 10.1776 70.864 10.3301C70.6749 10.4829 70.4807 10.5968 70.2807 10.672L72.1349 13.3344H70.9266L69.3557 10.9427H68.589V13.3344H67.5474V7.30106Z\" fill=\"white\"/>\n<path d=\"M72.9599 7.30106H76.5141L76.4141 8.15946H74.0015V9.82186H76.2765V10.6261H74.0015V12.4677H76.5431L76.4556 13.3344H72.9599V7.30106Z\" fill=\"white\"/>\n<path d=\"M80.3807 7.30106H81.4223V13.3344H80.3807V7.30106Z\" fill=\"white\"/>\n<path d=\"M84.1765 8.172H82.3055L82.3973 7.30106H87.0933L86.9973 8.172H85.218V13.3344H84.1765V8.172Z\" fill=\"white\"/>\n<path d=\"M94.3141 12.2989C94.6055 12.1032 94.8237 11.8339 94.9682 11.4907C95.1125 11.1477 95.1847 10.7552 95.1847 10.3136C95.1847 9.88026 95.1207 9.49439 94.9933 9.15519C94.8653 8.81625 94.661 8.54639 94.3807 8.34479C94.0999 8.14346 93.7389 8.04266 93.2973 8.04266C92.8749 8.04266 92.5167 8.14479 92.2223 8.34906C91.9277 8.55306 91.7069 8.82692 91.5599 9.16986C91.4125 9.51306 91.3389 9.89145 91.3389 10.3053C91.3389 10.7413 91.4082 11.1317 91.5474 11.476C91.6861 11.8205 91.8986 12.0928 92.1847 12.2928C92.4709 12.4928 92.825 12.5928 93.2474 12.5928C93.6666 12.5928 94.0223 12.4947 94.3141 12.2989ZM91.6141 13.0387C91.1722 12.7859 90.8349 12.4309 90.6015 11.9739C90.3682 11.5171 90.2514 10.9859 90.2514 10.3803C90.2514 9.74426 90.3757 9.18799 90.6245 8.71146C90.8727 8.23519 91.2311 7.86719 91.6994 7.60719C92.1674 7.34772 92.7194 7.21759 93.3557 7.21759C93.9639 7.21759 94.4874 7.34346 94.9266 7.59466C95.3653 7.84639 95.6999 8.19972 95.9306 8.65519C96.161 9.11092 96.2765 9.63865 96.2765 10.2387C96.2765 10.8859 96.1506 11.4485 95.8994 11.9261C95.6479 12.4037 95.2895 12.772 94.8245 13.0301C94.3591 13.2885 93.8125 13.4177 93.1847 13.4177C92.5791 13.4177 92.0557 13.2915 91.6141 13.0387Z\" fill=\"white\"/>\n<path d=\"M97.4389 7.30106H98.6349L101.619 11.976C101.592 11.5317 101.581 11.1219 101.581 10.7469V7.30106H102.547V13.3344H101.389L98.3599 8.58426C98.3903 9.12346 98.4055 9.60106 98.4055 10.0176V13.3344H97.4389V7.30106Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.9419 7.33329H15.8635C10.6449 7.33329 8.73608 9.24209 8.73608 14.4608V25.5393C8.73608 30.7579 10.6449 32.6666 15.8635 32.6666H26.9385C32.1571 32.6666 34.0694 30.7579 34.0694 25.5393V14.4608C34.0694 9.24209 32.1606 7.33329 26.9419 7.33329Z\" fill=\"#C91C2E\"/>\n<path d=\"M19.7883 22.0255H20.8043L20.2947 20.8404L19.7883 22.0255ZM19.5382 22.6229L19.2368 23.3125H18.5507L20.0099 20.0021H20.6027L22.056 23.3125H21.3515L21.0539 22.6229H19.5382ZM30.579 23.3102H31.2422V20.0021H30.579V23.3102ZM27.9398 21.8887H29.1619V21.2859H27.9398V20.6078H29.7139V20.0042H27.2768V23.3121H29.7779V22.7088H27.9398V21.8887ZM25.3048 22.2796L24.5528 20.002H24.0046L23.2526 22.2796L22.5208 20.0036H21.8056L22.96 23.314H23.5163L24.2694 21.1395L25.0222 23.314H25.5835L26.735 20.0036H26.0382L25.3048 22.2796ZM17.5384 21.8979C17.5384 22.4364 17.271 22.7241 16.7854 22.7241C16.2971 22.7241 16.0283 22.4283 16.0283 21.875V20.004H15.3563V21.8979C15.3563 22.8296 15.8739 23.3638 16.7763 23.3638C17.6875 23.3638 18.2102 22.8194 18.2102 21.8705V20.002H17.5384V21.8979ZM13.7528 20.0021H14.4246V23.3142H13.7528V21.9692H12.2352V23.3142H11.5632V20.0021H12.2352V21.3383H13.7528V20.0021Z\" fill=\"white\"/>\n<path d=\"M21.4028 15.7851C19.0778 15.7851 17.186 13.8933 17.186 11.5683H17.7818C17.7818 13.5649 19.406 15.1894 21.4028 15.1894C23.3996 15.1894 25.0239 13.5649 25.0239 11.5683H25.6196C25.6196 13.8933 23.7279 15.7851 21.4028 15.7851Z\" fill=\"white\"/>\n</svg>";

var AppGalleryOutline = "<svg width=\"133\" height=\"40\" viewBox=\"0 0 133 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"132\" height=\"39\" rx=\"5.5\" fill=\"white\" stroke=\"black\"/>\n<path d=\"M45.3962 25.4116H48.8919L47.6404 22.0615C47.4682 21.5986 47.2989 21.0875 47.1319 20.5276C46.9813 21.0229 46.817 21.5286 46.6394 22.0453L45.3962 25.4116ZM49.4893 27.0021H44.8068L43.6607 30.1344H41.6021L46.1874 18.4368H48.133L52.8234 30.1344H50.6599L49.4893 27.0021Z\" fill=\"black\"/>\n<path d=\"M58.8962 28.0072C59.3026 27.461 59.5058 26.663 59.5058 25.6135C59.5058 24.6396 59.3375 23.933 59.0013 23.4942C58.6647 23.0557 58.2167 22.8364 57.657 22.8364C57.2695 22.8364 56.9117 22.9281 56.5834 23.1109C56.2551 23.2939 55.9429 23.5387 55.6469 23.8455V28.5117C55.8461 28.6085 56.0775 28.6853 56.3413 28.7416C56.605 28.7984 56.8661 28.8266 57.1242 28.8266C57.8994 28.8266 58.4898 28.5533 58.8962 28.0072ZM53.653 23.555C53.653 22.9092 53.6314 22.1986 53.5885 21.4237H55.4613C55.5311 21.7844 55.5797 22.1531 55.6066 22.5297C56.3815 21.6849 57.2695 21.2622 58.2706 21.2622C58.8519 21.2622 59.3901 21.4088 59.8853 21.7021C60.3802 21.9955 60.7799 22.4583 61.0839 23.0906C61.3882 23.7231 61.5402 24.5265 61.5402 25.5005C61.5402 26.5177 61.3666 27.387 61.0194 28.108C60.6722 28.8294 60.1866 29.3754 59.5623 29.747C58.9381 30.1181 58.2167 30.3039 57.3989 30.3039C56.8066 30.3039 56.2226 30.2042 55.6469 30.0053V33.6056L53.653 33.7752V23.555Z\" fill=\"black\"/>\n<path d=\"M67.9935 28.0072C68.3999 27.461 68.6031 26.663 68.6031 25.6135C68.6031 24.6396 68.4349 23.933 68.0986 23.4942C67.7621 23.0557 67.3141 22.8364 66.7543 22.8364C66.3669 22.8364 66.009 22.9281 65.6807 23.1109C65.3522 23.2939 65.0402 23.5387 64.7442 23.8455V28.5117C64.9434 28.6085 65.1746 28.6853 65.4386 28.7416C65.7021 28.7984 65.9631 28.8266 66.2215 28.8266C66.9964 28.8266 67.5871 28.5533 67.9935 28.0072ZM62.7501 23.555C62.7501 22.9092 62.7285 22.1986 62.6855 21.4237H64.5586C64.6285 21.7844 64.677 22.1531 64.7039 22.5297C65.4789 21.6849 66.3668 21.2622 67.3679 21.2622C67.9493 21.2622 68.4871 21.4088 68.9826 21.7021C69.4775 21.9955 69.8772 22.4583 70.1815 23.0906C70.4852 23.7231 70.6375 24.5265 70.6375 25.5005C70.6375 26.5177 70.4637 27.387 70.1167 28.108C69.7695 28.8294 69.2837 29.3754 68.6597 29.747C68.0351 30.1181 67.314 30.3039 66.4959 30.3039C65.9039 30.3039 65.3199 30.2042 64.7442 30.0053V33.6056L62.7501 33.7752V23.555Z\" fill=\"black\"/>\n<path d=\"M74.3005 29.5813C73.4391 29.1053 72.7773 28.4229 72.3146 27.5349C71.8514 26.6469 71.6202 25.5974 71.6202 24.3864C71.6202 23.0734 71.8866 21.9578 72.4194 21.0401C72.9522 20.1227 73.6775 19.4337 74.5949 18.9735C75.5127 18.5134 76.5418 18.2833 77.6831 18.2833C78.3557 18.2833 78.9975 18.3574 79.6085 18.5053C80.2191 18.6534 80.7882 18.8564 81.3159 19.1149L80.8071 20.6486C79.7468 20.1428 78.7351 19.8898 77.7719 19.8898C76.9591 19.8898 76.2474 20.0634 75.6367 20.4106C75.0258 20.7578 74.5506 21.2677 74.2117 21.9404C73.8725 22.6132 73.7031 23.4258 73.7031 24.3783C73.7031 25.2128 73.8335 25.9526 74.0943 26.5984C74.3557 27.2442 74.7674 27.7557 75.3298 28.1323C75.8922 28.509 76.6013 28.6973 77.457 28.6973C77.8445 28.6973 78.2319 28.6651 78.6194 28.6005C79.0069 28.536 79.3703 28.4418 79.7093 28.3179V25.9526H77.005V24.4026H81.6469V29.3272C80.9794 29.6392 80.2783 29.8789 79.5439 30.0456C78.809 30.2123 78.0786 30.2957 77.3519 30.2957C76.1786 30.2957 75.1613 30.0579 74.3005 29.5813Z\" fill=\"black\"/>\n<path d=\"M87.5381 28.5197C87.9522 28.3208 88.2914 28.073 88.5551 27.7771V26.1625C88.0114 26.1034 87.5674 26.0737 87.2231 26.0737C86.3997 26.0737 85.8303 26.2068 85.5159 26.4734C85.2007 26.7394 85.0434 27.0989 85.0434 27.5509C85.0434 27.9818 85.1578 28.3005 85.3866 28.5077C85.6154 28.7149 85.9261 28.8184 86.3189 28.8184C86.717 28.8184 87.1234 28.7189 87.5381 28.5197ZM88.7327 30.1344C88.6626 29.7952 88.6167 29.4106 88.5954 28.98C88.2887 29.3461 87.8893 29.6568 87.3965 29.9125C86.9045 30.168 86.3485 30.2957 85.7295 30.2957C85.229 30.2957 84.773 30.1976 84.361 30.001C83.9498 29.8048 83.6226 29.5087 83.3805 29.113C83.1383 28.7176 83.017 28.2347 83.017 27.6639C83.017 26.8192 83.321 26.145 83.9293 25.6416C84.5375 25.1385 85.5519 24.887 86.9727 24.887C87.5055 24.887 88.033 24.9248 88.5551 25V24.8305C88.5551 24.0609 88.3909 23.5187 88.0626 23.2036C87.7343 22.889 87.2634 22.7316 86.6501 22.7316C86.2247 22.7316 85.7701 22.7935 85.2855 22.9172C84.8013 23.0411 84.3759 23.189 84.0101 23.3612L83.6951 21.9081C84.0503 21.7465 84.5186 21.5986 85.0999 21.464C85.6813 21.3297 86.2946 21.2622 86.9405 21.2622C87.6941 21.2622 88.3343 21.3765 88.8618 21.6052C89.3893 21.834 89.801 22.2271 90.097 22.7838C90.393 23.3411 90.541 24.0906 90.541 25.0323V28.4954C90.541 28.8562 90.5623 29.4027 90.6055 30.1344H88.7327Z\" fill=\"black\"/>\n<path d=\"M92.0709 28.0434V17.7505L94.0567 17.5891V27.6882C94.0567 28.0597 94.1199 28.3218 94.2463 28.4754C94.3727 28.6285 94.5732 28.7056 94.8479 28.7056C94.9716 28.7056 95.1466 28.676 95.3724 28.6168L95.6066 30.0456C95.418 30.121 95.1882 30.1816 94.9167 30.2272C94.6447 30.2728 94.3876 30.2957 94.1455 30.2957C92.762 30.2957 92.0709 29.5451 92.0709 28.0434Z\" fill=\"black\"/>\n<path d=\"M97.0356 28.0434V17.7505L99.0215 17.5891V27.6882C99.0215 28.0597 99.0847 28.3218 99.2111 28.4754C99.3378 28.6285 99.5383 28.7056 99.8127 28.7056C99.9365 28.7056 100.111 28.676 100.338 28.6168L100.572 30.0456C100.383 30.121 100.153 30.1816 99.8815 30.2272C99.6095 30.2728 99.3524 30.2957 99.1103 30.2957C97.7271 30.2957 97.0356 29.5451 97.0356 28.0434Z\" fill=\"black\"/>\n<path d=\"M106.795 24.7659C106.755 24.0716 106.581 23.551 106.269 23.2036C105.957 22.8568 105.539 22.683 105.019 22.683C104.512 22.683 104.091 22.8581 103.755 23.2078C103.419 23.5578 103.197 24.0771 103.096 24.7659H106.795ZM108.739 26.0333H103.04C103.131 27.8579 104 28.7701 105.648 28.7701C106.056 28.7701 106.475 28.7203 106.904 28.6208C107.331 28.521 107.741 28.388 108.133 28.221L108.571 29.5853C107.595 30.0592 106.501 30.2957 105.285 30.2957C104.357 30.2957 103.579 30.121 102.944 29.7711C102.307 29.4213 101.829 28.9181 101.509 28.2613C101.19 27.6051 101.03 26.8138 101.03 25.888C101.03 24.9248 101.199 24.0958 101.539 23.4016C101.877 22.7073 102.349 22.1773 102.955 21.8112C103.56 21.4453 104.259 21.2622 105.051 21.2622C105.875 21.2622 106.56 21.4547 107.112 21.8396C107.664 22.2241 108.072 22.737 108.339 23.3773C108.605 24.018 108.739 24.7255 108.739 25.5005V26.0333Z\" fill=\"black\"/>\n<path d=\"M110.248 23.6115C110.248 23.1326 110.224 22.4034 110.181 21.4237H112.048C112.08 21.6659 112.109 21.9552 112.141 22.2916C112.171 22.6279 112.189 22.901 112.2 23.1109C112.432 22.7288 112.659 22.4073 112.883 22.1463C113.107 21.8851 113.368 21.6727 113.667 21.5083C113.965 21.3443 114.304 21.2622 114.688 21.2622C114.995 21.2622 115.256 21.2946 115.477 21.3592L115.227 23.0868C115.035 23.0276 114.819 22.9979 114.581 22.9979C114.115 22.9979 113.704 23.1177 113.355 23.3573C113.005 23.5965 112.632 23.9908 112.232 24.5398V30.1344H110.248V23.6115Z\" fill=\"black\"/>\n<path d=\"M116.597 33.6984C116.307 33.6475 116.067 33.5896 115.88 33.5251L116.243 32.072C116.376 32.1094 116.547 32.1458 116.752 32.1808C116.955 32.216 117.149 32.2333 117.333 32.2333C118.216 32.2333 118.877 31.6653 119.317 30.5299L119.448 30.207L116.235 21.4237H118.373L119.989 26.332C120.251 27.1717 120.421 27.8149 120.496 28.2613C120.648 27.6317 120.824 27.0021 121.029 26.3724L122.669 21.4237H124.677L121.475 30.2475C121.173 31.0816 120.845 31.7541 120.496 32.2656C120.147 32.7768 119.733 33.1562 119.259 33.4039C118.781 33.6512 118.208 33.7752 117.533 33.7752C117.2 33.7752 116.888 33.7499 116.597 33.6984Z\" fill=\"black\"/>\n<path d=\"M41.5933 7.30106H45.1474L45.0474 8.15946H42.6349V9.82186H44.9098V10.6261H42.6349V12.4677H45.1765L45.089 13.3344H41.5933V7.30106Z\" fill=\"black\"/>\n<path d=\"M47.5973 10.2552L45.7223 7.30106H46.9055L48.1765 9.472L49.514 7.30106H50.6639L48.8055 10.2176L50.8181 13.3344H49.6181L48.1807 10.9595L46.7181 13.3344H45.5682L47.5973 10.2552Z\" fill=\"black\"/>\n<path d=\"M54.1973 9.99466C54.4194 9.7936 54.5306 9.50933 54.5306 9.14266C54.5306 8.7704 54.4172 8.50266 54.1911 8.33866C53.9647 8.17466 53.6319 8.0928 53.1932 8.0928H52.6266V10.2344C52.8876 10.276 53.0876 10.2968 53.2266 10.2968C53.6514 10.2968 53.9751 10.1963 54.1973 9.99466ZM51.5847 7.30106H53.2098C53.9735 7.30106 54.5583 7.4568 54.9639 7.76773C55.3695 8.07893 55.5722 8.5288 55.5722 9.1176C55.5722 9.5176 55.4813 9.8672 55.2994 10.1656C55.1173 10.4643 54.8639 10.6936 54.5388 10.8531C54.214 11.0131 53.8402 11.0928 53.418 11.0928C53.1876 11.0928 52.9236 11.0651 52.6266 11.0093V13.3344H51.5847V7.30106Z\" fill=\"black\"/>\n<path d=\"M56.6015 7.30106H57.6431V12.4427H60.1389L60.0514 13.3344H56.6015V7.30106Z\" fill=\"black\"/>\n<path d=\"M64.4223 12.2989C64.714 12.1032 64.9319 11.8339 65.0764 11.4907C65.221 11.1477 65.2932 10.7552 65.2932 10.3136C65.2932 9.88026 65.2292 9.49439 65.1015 9.15519C64.9735 8.81625 64.7695 8.54639 64.489 8.34479C64.2084 8.14346 63.8474 8.04266 63.4055 8.04266C62.9834 8.04266 62.625 8.14479 62.3306 8.34906C62.0362 8.55306 61.8154 8.82692 61.6682 9.16986C61.521 9.51306 61.4474 9.89145 61.4474 10.3053C61.4474 10.7413 61.5167 11.1317 61.6556 11.476C61.7943 11.8205 62.0068 12.0928 62.2932 12.2928C62.5791 12.4928 62.9332 12.5928 63.3556 12.5928C63.7751 12.5928 64.1306 12.4947 64.4223 12.2989ZM61.7223 13.0387C61.2807 12.7859 60.9431 12.4309 60.7098 11.9739C60.4764 11.5171 60.3599 10.9859 60.3599 10.3803C60.3599 9.74426 60.4839 9.18799 60.7327 8.71146C60.9813 8.23519 61.3396 7.86719 61.8076 7.60719C62.2756 7.34772 62.8277 7.21759 63.4639 7.21759C64.0722 7.21759 64.5959 7.34346 65.0348 7.59466C65.4735 7.84639 65.8084 8.19972 66.0388 8.65519C66.2695 9.11092 66.3847 9.63865 66.3847 10.2387C66.3847 10.8859 66.2591 11.4485 66.0076 11.9261C65.7562 12.4037 65.3981 12.772 64.9327 13.0301C64.4674 13.2885 63.921 13.4177 63.2932 13.4177C62.6876 13.4177 62.1639 13.2915 61.7223 13.0387Z\" fill=\"black\"/>\n<path d=\"M69.1807 10.1552C69.4333 10.1552 69.657 10.1061 69.8514 10.0072C70.0458 9.9088 70.1973 9.76986 70.3055 9.59066C70.4141 9.41146 70.4682 9.20373 70.4682 8.96773C70.4682 8.66506 70.3722 8.44346 70.1807 8.3032C69.989 8.16293 69.7098 8.0928 69.3431 8.0928H68.589V10.1552H69.1807ZM67.5474 7.30106H69.4349C70.1237 7.30106 70.6453 7.43866 70.9994 7.7136C71.3535 7.98853 71.5306 8.38186 71.5306 8.8928C71.5306 9.21226 71.4666 9.4936 71.3389 9.73653C71.2111 9.97973 71.0527 10.1776 70.864 10.3301C70.6749 10.4829 70.4807 10.5968 70.2807 10.672L72.1349 13.3344H70.9266L69.3557 10.9427H68.589V13.3344H67.5474V7.30106Z\" fill=\"black\"/>\n<path d=\"M72.9599 7.30106H76.5141L76.4141 8.15946H74.0015V9.82186H76.2765V10.6261H74.0015V12.4677H76.5431L76.4556 13.3344H72.9599V7.30106Z\" fill=\"black\"/>\n<path d=\"M80.3807 7.30106H81.4223V13.3344H80.3807V7.30106Z\" fill=\"black\"/>\n<path d=\"M84.1765 8.172H82.3055L82.3973 7.30106H87.0933L86.9973 8.172H85.218V13.3344H84.1765V8.172Z\" fill=\"black\"/>\n<path d=\"M94.3141 12.2989C94.6055 12.1032 94.8237 11.8339 94.9682 11.4907C95.1125 11.1477 95.1847 10.7552 95.1847 10.3136C95.1847 9.88026 95.1207 9.49439 94.9933 9.15519C94.8653 8.81625 94.661 8.54639 94.3807 8.34479C94.0999 8.14346 93.7389 8.04266 93.2973 8.04266C92.8749 8.04266 92.5167 8.14479 92.2223 8.34906C91.9277 8.55306 91.7069 8.82692 91.5599 9.16986C91.4125 9.51306 91.3389 9.89145 91.3389 10.3053C91.3389 10.7413 91.4082 11.1317 91.5474 11.476C91.6861 11.8205 91.8986 12.0928 92.1847 12.2928C92.4709 12.4928 92.825 12.5928 93.2474 12.5928C93.6666 12.5928 94.0223 12.4947 94.3141 12.2989ZM91.6141 13.0387C91.1722 12.7859 90.8349 12.4309 90.6015 11.9739C90.3682 11.5171 90.2514 10.9859 90.2514 10.3803C90.2514 9.74426 90.3757 9.18799 90.6245 8.71146C90.8727 8.23519 91.2311 7.86719 91.6994 7.60719C92.1674 7.34772 92.7194 7.21759 93.3557 7.21759C93.9639 7.21759 94.4874 7.34346 94.9266 7.59466C95.3653 7.84639 95.6999 8.19972 95.9306 8.65519C96.161 9.11092 96.2765 9.63865 96.2765 10.2387C96.2765 10.8859 96.1506 11.4485 95.8994 11.9261C95.6479 12.4037 95.2895 12.772 94.8245 13.0301C94.3591 13.2885 93.8125 13.4177 93.1847 13.4177C92.5791 13.4177 92.0557 13.2915 91.6141 13.0387Z\" fill=\"black\"/>\n<path d=\"M97.4389 7.30106H98.6349L101.619 11.976C101.592 11.5317 101.581 11.1219 101.581 10.7469V7.30106H102.547V13.3344H101.389L98.3599 8.58426C98.3903 9.12346 98.4055 9.60106 98.4055 10.0176V13.3344H97.4389V7.30106Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.9419 7.33332H15.8635C10.6449 7.33332 8.73608 9.24212 8.73608 14.4608V25.5394C8.73608 30.7579 10.6449 32.6667 15.8635 32.6667H26.9385C32.1571 32.6667 34.0694 30.7579 34.0694 25.5394V14.4608C34.0694 9.24212 32.1606 7.33332 26.9419 7.33332Z\" fill=\"black\"/>\n<path d=\"M19.7883 22.0255H20.8043L20.2947 20.8404L19.7883 22.0255ZM19.5382 22.6229L19.2368 23.3125H18.5507L20.0099 20.0022H20.6027L22.056 23.3125H21.3515L21.0539 22.6229H19.5382ZM30.579 23.3102H31.2422V20.0022H30.579V23.3102ZM27.9398 21.8887H29.1619V21.2859H27.9398V20.6078H29.7139V20.0043H27.2768V23.3122H29.7779V22.7088H27.9398V21.8887ZM25.3048 22.2797L24.5528 20.0021H24.0046L23.2526 22.2797L22.5208 20.0036H21.8056L22.96 23.314H23.5163L24.2694 21.1396L25.0222 23.314H25.5835L26.735 20.0036H26.0382L25.3048 22.2797ZM17.5384 21.8979C17.5384 22.4364 17.271 22.7242 16.7854 22.7242C16.2971 22.7242 16.0283 22.4283 16.0283 21.875V20.004H15.3563V21.8979C15.3563 22.8297 15.8739 23.3639 16.7763 23.3639C17.6875 23.3639 18.2102 22.8195 18.2102 21.8705V20.0021H17.5384V21.8979ZM13.7528 20.0022H14.4246V23.3143H13.7528V21.9693H12.2352V23.3143H11.5632V20.0022H12.2352V21.3383H13.7528V20.0022Z\" fill=\"white\"/>\n<path d=\"M21.4028 15.7851C19.0778 15.7851 17.186 13.8933 17.186 11.5683H17.7818C17.7818 13.5649 19.406 15.1894 21.4028 15.1894C23.3996 15.1894 25.0239 13.5649 25.0239 11.5683H25.6196C25.6196 13.8933 23.7279 15.7851 21.4028 15.7851Z\" fill=\"white\"/>\n</svg>";

var AppStoreBlack = "<svg width=\"120\" height=\"40\" viewBox=\"0 0 120 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"119\" height=\"39\" rx=\"5.5\" fill=\"black\" stroke=\"#A6A6A6\"/>\n<path d=\"M81.5259 19.2009V21.4919H80.0899V22.9944H81.5259V28.0994C81.5259 29.8425 82.3145 30.5398 84.2984 30.5398C84.647 30.5398 84.9791 30.4983 85.2696 30.4485V28.9626C85.0206 28.9875 84.8628 29.0041 84.5889 29.0041C83.7007 29.0041 83.3106 28.5891 83.3106 27.6428V22.9944H85.2696V21.4919H83.3106V19.2009H81.5259Z\" fill=\"white\"/>\n<path d=\"M90.3234 30.6643C92.9631 30.6643 94.5817 28.8962 94.5817 25.9661C94.5817 23.0525 92.9548 21.2761 90.3234 21.2761C87.6838 21.2761 86.0568 23.0525 86.0568 25.9661C86.0568 28.8962 87.6755 30.6643 90.3234 30.6643ZM90.3234 29.0789C88.7712 29.0789 87.8996 27.9416 87.8996 25.9661C87.8996 24.0071 88.7712 22.8616 90.3234 22.8616C91.8674 22.8616 92.7473 24.0071 92.7473 25.9661C92.7473 27.9333 91.8674 29.0789 90.3234 29.0789Z\" fill=\"white\"/>\n<path d=\"M95.9666 30.49H97.7513V25.1526C97.7513 23.8826 98.7059 23.0276 100.059 23.0276C100.374 23.0276 100.906 23.0857 101.055 23.1355V21.3757C100.864 21.3259 100.524 21.301 100.258 21.301C99.0794 21.301 98.075 21.9485 97.8177 22.8367H97.6849V21.4504H95.9666V30.49Z\" fill=\"white\"/>\n<path d=\"M105.486 22.7952C106.806 22.7952 107.669 23.7165 107.711 25.136H103.145C103.245 23.7248 104.166 22.7952 105.486 22.7952ZM107.703 28.0496C107.371 28.7551 106.632 29.1453 105.553 29.1453C104.125 29.1453 103.204 28.1409 103.145 26.5554V26.4558H109.529V25.8332C109.529 22.9944 108.01 21.2761 105.495 21.2761C102.946 21.2761 101.328 23.1106 101.328 25.9993C101.328 28.8879 102.913 30.6643 105.503 30.6643C107.57 30.6643 109.014 29.6682 109.421 28.0496H107.703Z\" fill=\"white\"/>\n<path d=\"M69.8223 27.1518C69.96 29.3715 71.8098 30.7911 74.5629 30.7911C77.5053 30.7911 79.3464 29.3027 79.3464 26.9281C79.3464 25.0612 78.2968 24.0287 75.7502 23.4351L74.3822 23.0996C72.7647 22.721 72.1109 22.2134 72.1109 21.3272C72.1109 20.2088 73.1261 19.4775 74.6489 19.4775C76.0943 19.4775 77.0923 20.1916 77.273 21.3358H79.1486C79.0367 19.2452 77.1956 17.774 74.6747 17.774C71.9646 17.774 70.1579 19.2452 70.1579 21.4563C70.1579 23.2802 71.1817 24.3643 73.4272 24.8891L75.0275 25.2763C76.6707 25.6634 77.3934 26.2312 77.3934 27.1776C77.3934 28.2789 76.2578 29.079 74.7091 29.079C73.0487 29.079 71.8958 28.3305 71.7323 27.1518H69.8223Z\" fill=\"white\"/>\n<path d=\"M51.335 21.301C50.1065 21.301 49.044 21.9153 48.4961 22.9446H48.3633V21.4504H46.6451V33.4949H48.4297V29.1204H48.5708C49.044 30.0749 50.065 30.6394 51.3516 30.6394C53.6343 30.6394 55.087 28.8381 55.087 25.9661C55.087 23.094 53.6343 21.301 51.335 21.301ZM50.8287 29.0373C49.3345 29.0373 48.3965 27.8586 48.3965 25.9744C48.3965 24.0818 49.3345 22.9031 50.837 22.9031C52.3477 22.9031 53.2525 24.0569 53.2525 25.9661C53.2525 27.8835 52.3477 29.0373 50.8287 29.0373Z\" fill=\"white\"/>\n<path d=\"M61.3318 21.301C60.1033 21.301 59.0408 21.9153 58.4929 22.9446H58.3601V21.4504H56.6419V33.4949H58.4265V29.1204H58.5676C59.0408 30.0749 60.0618 30.6394 61.3484 30.6394C63.6311 30.6394 65.0838 28.8381 65.0838 25.9661C65.0838 23.094 63.6311 21.301 61.3318 21.301ZM60.8255 29.0373C59.3313 29.0373 58.3933 27.8586 58.3933 25.9744C58.3933 24.0818 59.3313 22.9031 60.8338 22.9031C62.3445 22.9031 63.2493 24.0569 63.2493 25.9661C63.2493 27.8835 62.3445 29.0373 60.8255 29.0373Z\" fill=\"white\"/>\n<path d=\"M43.4431 30.49H45.4907L41.0083 18.0751H38.9348L34.4524 30.49H36.4312L37.5755 27.1948H42.3074L43.4431 30.49ZM39.8726 20.3292H40.0189L41.817 25.5774H38.0659L39.8726 20.3292Z\" fill=\"white\"/>\n<path d=\"M35.6511 8.71094V14.7H37.8135C39.5981 14.7 40.6316 13.6001 40.6316 11.6868C40.6316 9.80249 39.5898 8.71094 37.8135 8.71094H35.6511ZM36.5808 9.55762H37.7097C38.9507 9.55762 39.6853 10.3462 39.6853 11.6992C39.6853 13.073 38.9631 13.8533 37.7097 13.8533H36.5808V9.55762Z\" fill=\"white\"/>\n<path d=\"M43.7967 14.7871C45.1165 14.7871 45.9258 13.9031 45.9258 12.438C45.9258 10.9812 45.1124 10.093 43.7967 10.093C42.4769 10.093 41.6634 10.9812 41.6634 12.438C41.6634 13.9031 42.4727 14.7871 43.7967 14.7871ZM43.7967 13.9944C43.0206 13.9944 42.5848 13.4258 42.5848 12.438C42.5848 11.4585 43.0206 10.8857 43.7967 10.8857C44.5687 10.8857 45.0086 11.4585 45.0086 12.438C45.0086 13.4216 44.5687 13.9944 43.7967 13.9944Z\" fill=\"white\"/>\n<path d=\"M52.818 10.1802H51.9256L51.1205 13.6292H51.0499L50.1202 10.1802H49.2652L48.3355 13.6292H48.2691L47.4598 10.1802H46.555L47.8001 14.7H48.7174L49.6471 11.3713H49.7176L50.6515 14.7H51.577L52.818 10.1802Z\" fill=\"white\"/>\n<path d=\"M53.8456 14.7H54.7379V12.0562C54.7379 11.3506 55.1571 10.9106 55.817 10.9106C56.477 10.9106 56.7924 11.2717 56.7924 11.998V14.7H57.6847V11.7739C57.6847 10.699 57.1286 10.093 56.12 10.093C55.4394 10.093 54.9911 10.396 54.7711 10.8982H54.7047V10.1802H53.8456V14.7Z\" fill=\"white\"/>\n<path d=\"M59.09 14.7H59.9824V8.41626H59.09V14.7Z\" fill=\"white\"/>\n<path d=\"M63.3384 14.7871C64.6582 14.7871 65.4675 13.9031 65.4675 12.438C65.4675 10.9812 64.6541 10.093 63.3384 10.093C62.0186 10.093 61.2051 10.9812 61.2051 12.438C61.2051 13.9031 62.0144 14.7871 63.3384 14.7871ZM63.3384 13.9944C62.5623 13.9944 62.1265 13.4258 62.1265 12.438C62.1265 11.4585 62.5623 10.8857 63.3384 10.8857C64.1104 10.8857 64.5503 11.4585 64.5503 12.438C64.5503 13.4216 64.1104 13.9944 63.3384 13.9944Z\" fill=\"white\"/>\n<path d=\"M68.1263 14.0234C67.6407 14.0234 67.2879 13.7869 67.2879 13.3801C67.2879 12.9817 67.5701 12.77 68.1927 12.7285L69.2967 12.658V13.0356C69.2967 13.5959 68.7986 14.0234 68.1263 14.0234ZM67.898 14.7747C68.4915 14.7747 68.9854 14.5173 69.2552 14.0649H69.3257V14.7H70.1849V11.6121C70.1849 10.6575 69.5457 10.093 68.4126 10.093C67.3875 10.093 66.657 10.5911 66.5657 11.3672H67.429C67.5286 11.0476 67.8731 10.865 68.3711 10.865C68.9812 10.865 69.2967 11.1348 69.2967 11.6121V12.0022L68.0723 12.0728C66.9974 12.1392 66.3914 12.6082 66.3914 13.4216C66.3914 14.2476 67.0264 14.7747 67.898 14.7747Z\" fill=\"white\"/>\n<path d=\"M73.213 14.7747C73.8355 14.7747 74.3626 14.48 74.6324 13.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543 10.4001 73.8314 10.1055 73.213 10.1055C72.0716 10.1055 71.337 11.0103 71.337 12.438C71.337 13.8699 72.0633 14.7747 73.213 14.7747ZM73.4662 10.9065C74.2132 10.9065 74.6822 11.5 74.6822 12.4421C74.6822 13.3884 74.2174 13.9736 73.4662 13.9736C72.7108 13.9736 72.2584 13.3967 72.2584 12.438C72.2584 11.4875 72.7149 10.9065 73.4662 10.9065Z\" fill=\"white\"/>\n<path d=\"M81.3444 14.7871C82.6643 14.7871 83.4736 13.9031 83.4736 12.438C83.4736 10.9812 82.6601 10.093 81.3444 10.093C80.0246 10.093 79.2111 10.9812 79.2111 12.438C79.2111 13.9031 80.0205 14.7871 81.3444 14.7871ZM81.3444 13.9944C80.5683 13.9944 80.1325 13.4258 80.1325 12.438C80.1325 11.4585 80.5683 10.8857 81.3444 10.8857C82.1164 10.8857 82.5563 11.4585 82.5563 12.438C82.5563 13.4216 82.1164 13.9944 81.3444 13.9944Z\" fill=\"white\"/>\n<path d=\"M84.6548 14.7H85.5471V12.0562C85.5471 11.3506 85.9663 10.9106 86.6262 10.9106C87.2861 10.9106 87.6016 11.2717 87.6016 11.998V14.7H88.4939V11.7739C88.4939 10.699 87.9377 10.093 86.9292 10.093C86.2485 10.093 85.8003 10.396 85.5803 10.8982H85.5139V10.1802H84.6548V14.7Z\" fill=\"white\"/>\n<path d=\"M92.6036 9.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036 14.3762 92.9979 14.7249 93.9898 14.7249C94.1642 14.7249 94.3302 14.7041 94.4754 14.6792V13.9363C94.3509 13.9487 94.2721 13.957 94.1351 13.957C93.691 13.957 93.4959 13.7495 93.4959 13.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z\" fill=\"white\"/>\n<path d=\"M95.6732 14.7H96.5656V12.0603C96.5656 11.3755 96.9723 10.9148 97.7028 10.9148C98.3336 10.9148 98.6698 11.28 98.6698 12.0022V14.7H99.5622V11.7822C99.5622 10.7073 98.9687 10.0972 98.0058 10.0972C97.3251 10.0972 96.8478 10.4001 96.6278 10.9065H96.5573V8.41626H95.6732V14.7Z\" fill=\"white\"/>\n<path d=\"M102.781 10.8525C103.441 10.8525 103.873 11.3132 103.894 12.0229H101.611C101.661 11.3174 102.121 10.8525 102.781 10.8525ZM103.889 13.4797C103.723 13.8325 103.354 14.0276 102.814 14.0276C102.101 14.0276 101.64 13.5254 101.611 12.7327V12.6829H104.802V12.3716C104.802 10.9521 104.043 10.093 102.785 10.093C101.511 10.093 100.702 11.0103 100.702 12.4546C100.702 13.8989 101.495 14.7871 102.789 14.7871C103.823 14.7871 104.545 14.2891 104.748 13.4797H103.889Z\" fill=\"white\"/>\n<path d=\"M24.769 20.3008C24.7907 18.6198 25.6934 17.0292 27.1256 16.1488C26.2221 14.8584 24.7088 14.0403 23.1344 13.9911C21.4552 13.8148 19.8272 14.9959 18.9715 14.9959C18.0992 14.9959 16.7817 14.0086 15.363 14.0378C13.5137 14.0975 11.7898 15.1489 10.8901 16.7656C8.95607 20.1141 10.3987 25.0351 12.2513 27.7417C13.1782 29.0671 14.2615 30.5475 15.6789 30.495C17.066 30.4375 17.584 29.6105 19.2583 29.6105C20.9171 29.6105 21.4031 30.495 22.8493 30.4616C24.3377 30.4375 25.2754 29.1304 26.1698 27.7925C26.8358 26.8481 27.3483 25.8044 27.6882 24.7C25.9391 23.9602 24.771 22.2 24.769 20.3008Z\" fill=\"white\"/>\n<path d=\"M22.0373 12.2111C22.8489 11.2369 23.2487 9.98469 23.1518 8.72046C21.912 8.85068 20.7668 9.44324 19.9443 10.3801C19.14 11.2954 18.7214 12.5255 18.8006 13.7415C20.0408 13.7542 21.2601 13.1777 22.0373 12.2111Z\" fill=\"white\"/>\n</svg>";

var AppStoreOutline = "<svg width=\"120\" height=\"40\" viewBox=\"0 0 120 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"119\" height=\"39\" rx=\"5.5\" fill=\"white\" stroke=\"black\"/>\n<path d=\"M81.5259 19.2009V21.4919H80.0899V22.9944H81.5259V28.0994C81.5259 29.8425 82.3145 30.5398 84.2984 30.5398C84.647 30.5398 84.9791 30.4983 85.2696 30.4485V28.9626C85.0206 28.9875 84.8628 29.0041 84.5889 29.0041C83.7007 29.0041 83.3106 28.5891 83.3106 27.6428V22.9944H85.2696V21.4919H83.3106V19.2009H81.5259Z\" fill=\"black\"/>\n<path d=\"M90.3234 30.6643C92.9631 30.6643 94.5817 28.8962 94.5817 25.9661C94.5817 23.0525 92.9548 21.2761 90.3234 21.2761C87.6838 21.2761 86.0568 23.0525 86.0568 25.9661C86.0568 28.8962 87.6755 30.6643 90.3234 30.6643ZM90.3234 29.0789C88.7712 29.0789 87.8996 27.9416 87.8996 25.9661C87.8996 24.0071 88.7712 22.8616 90.3234 22.8616C91.8674 22.8616 92.7473 24.0071 92.7473 25.9661C92.7473 27.9333 91.8674 29.0789 90.3234 29.0789Z\" fill=\"black\"/>\n<path d=\"M95.9666 30.49H97.7513V25.1526C97.7513 23.8826 98.7059 23.0276 100.059 23.0276C100.374 23.0276 100.906 23.0857 101.055 23.1355V21.3757C100.864 21.3259 100.524 21.301 100.258 21.301C99.0794 21.301 98.075 21.9485 97.8177 22.8367H97.6849V21.4504H95.9666V30.49Z\" fill=\"black\"/>\n<path d=\"M105.486 22.7952C106.806 22.7952 107.669 23.7165 107.711 25.136H103.145C103.245 23.7248 104.166 22.7952 105.486 22.7952ZM107.703 28.0496C107.371 28.7551 106.632 29.1453 105.553 29.1453C104.125 29.1453 103.204 28.1409 103.145 26.5554V26.4558H109.529V25.8332C109.529 22.9944 108.01 21.2761 105.495 21.2761C102.946 21.2761 101.328 23.1106 101.328 25.9993C101.328 28.8879 102.913 30.6643 105.503 30.6643C107.57 30.6643 109.014 29.6682 109.421 28.0496H107.703Z\" fill=\"black\"/>\n<path d=\"M69.8223 27.1518C69.96 29.3715 71.8098 30.7911 74.5629 30.7911C77.5053 30.7911 79.3464 29.3027 79.3464 26.9281C79.3464 25.0612 78.2968 24.0287 75.7502 23.4351L74.3822 23.0996C72.7647 22.721 72.1109 22.2134 72.1109 21.3272C72.1109 20.2088 73.1261 19.4775 74.6489 19.4775C76.0943 19.4775 77.0923 20.1916 77.273 21.3358H79.1486C79.0367 19.2452 77.1956 17.774 74.6747 17.774C71.9646 17.774 70.1579 19.2452 70.1579 21.4563C70.1579 23.2802 71.1817 24.3643 73.4272 24.8891L75.0275 25.2763C76.6707 25.6634 77.3934 26.2312 77.3934 27.1776C77.3934 28.2789 76.2578 29.079 74.7091 29.079C73.0487 29.079 71.8958 28.3305 71.7323 27.1518H69.8223Z\" fill=\"black\"/>\n<path d=\"M51.335 21.301C50.1065 21.301 49.044 21.9153 48.4961 22.9446H48.3633V21.4504H46.6451V33.4949H48.4297V29.1204H48.5708C49.044 30.0749 50.065 30.6394 51.3516 30.6394C53.6343 30.6394 55.087 28.8381 55.087 25.9661C55.087 23.094 53.6343 21.301 51.335 21.301ZM50.8287 29.0373C49.3345 29.0373 48.3965 27.8586 48.3965 25.9744C48.3965 24.0818 49.3345 22.9031 50.837 22.9031C52.3477 22.9031 53.2525 24.0569 53.2525 25.9661C53.2525 27.8835 52.3477 29.0373 50.8287 29.0373Z\" fill=\"black\"/>\n<path d=\"M61.3318 21.301C60.1033 21.301 59.0408 21.9153 58.4929 22.9446H58.3601V21.4504H56.6419V33.4949H58.4265V29.1204H58.5676C59.0408 30.0749 60.0618 30.6394 61.3484 30.6394C63.6311 30.6394 65.0838 28.8381 65.0838 25.9661C65.0838 23.094 63.6311 21.301 61.3318 21.301ZM60.8255 29.0373C59.3313 29.0373 58.3933 27.8586 58.3933 25.9744C58.3933 24.0818 59.3313 22.9031 60.8338 22.9031C62.3445 22.9031 63.2493 24.0569 63.2493 25.9661C63.2493 27.8835 62.3445 29.0373 60.8255 29.0373Z\" fill=\"black\"/>\n<path d=\"M43.4431 30.49H45.4907L41.0083 18.0751H38.9348L34.4524 30.49H36.4312L37.5755 27.1948H42.3074L43.4431 30.49ZM39.8726 20.3292H40.0189L41.817 25.5774H38.0659L39.8726 20.3292Z\" fill=\"black\"/>\n<path d=\"M35.6511 8.71094V14.7H37.8135C39.5981 14.7 40.6316 13.6001 40.6316 11.6868C40.6316 9.80249 39.5898 8.71094 37.8135 8.71094H35.6511ZM36.5808 9.55762H37.7097C38.9507 9.55762 39.6853 10.3462 39.6853 11.6992C39.6853 13.073 38.9631 13.8533 37.7097 13.8533H36.5808V9.55762Z\" fill=\"black\"/>\n<path d=\"M43.7967 14.7871C45.1165 14.7871 45.9258 13.9031 45.9258 12.438C45.9258 10.9812 45.1124 10.093 43.7967 10.093C42.4769 10.093 41.6634 10.9812 41.6634 12.438C41.6634 13.9031 42.4727 14.7871 43.7967 14.7871ZM43.7967 13.9944C43.0206 13.9944 42.5848 13.4258 42.5848 12.438C42.5848 11.4585 43.0206 10.8857 43.7967 10.8857C44.5687 10.8857 45.0086 11.4585 45.0086 12.438C45.0086 13.4216 44.5687 13.9944 43.7967 13.9944Z\" fill=\"black\"/>\n<path d=\"M52.818 10.1802H51.9256L51.1205 13.6292H51.0499L50.1202 10.1802H49.2652L48.3355 13.6292H48.2691L47.4598 10.1802H46.555L47.8001 14.7H48.7174L49.6471 11.3713H49.7176L50.6515 14.7H51.577L52.818 10.1802Z\" fill=\"black\"/>\n<path d=\"M53.8456 14.7H54.7379V12.0562C54.7379 11.3506 55.1571 10.9106 55.817 10.9106C56.477 10.9106 56.7924 11.2717 56.7924 11.998V14.7H57.6847V11.7739C57.6847 10.699 57.1286 10.093 56.12 10.093C55.4394 10.093 54.9911 10.396 54.7711 10.8982H54.7047V10.1802H53.8456V14.7Z\" fill=\"black\"/>\n<path d=\"M59.09 14.7H59.9824V8.41626H59.09V14.7Z\" fill=\"black\"/>\n<path d=\"M63.3384 14.7871C64.6582 14.7871 65.4675 13.9031 65.4675 12.438C65.4675 10.9812 64.6541 10.093 63.3384 10.093C62.0186 10.093 61.2051 10.9812 61.2051 12.438C61.2051 13.9031 62.0144 14.7871 63.3384 14.7871ZM63.3384 13.9944C62.5623 13.9944 62.1265 13.4258 62.1265 12.438C62.1265 11.4585 62.5623 10.8857 63.3384 10.8857C64.1104 10.8857 64.5503 11.4585 64.5503 12.438C64.5503 13.4216 64.1104 13.9944 63.3384 13.9944Z\" fill=\"black\"/>\n<path d=\"M68.1263 14.0234C67.6407 14.0234 67.2879 13.7869 67.2879 13.3801C67.2879 12.9817 67.5701 12.77 68.1927 12.7285L69.2967 12.658V13.0356C69.2967 13.5959 68.7986 14.0234 68.1263 14.0234ZM67.898 14.7747C68.4915 14.7747 68.9854 14.5173 69.2552 14.0649H69.3257V14.7H70.1849V11.6121C70.1849 10.6575 69.5457 10.093 68.4126 10.093C67.3875 10.093 66.657 10.5911 66.5657 11.3672H67.429C67.5286 11.0476 67.8731 10.865 68.3711 10.865C68.9812 10.865 69.2967 11.1348 69.2967 11.6121V12.0022L68.0723 12.0728C66.9974 12.1392 66.3914 12.6082 66.3914 13.4216C66.3914 14.2476 67.0264 14.7747 67.898 14.7747Z\" fill=\"black\"/>\n<path d=\"M73.213 14.7747C73.8355 14.7747 74.3626 14.48 74.6324 13.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543 10.4001 73.8314 10.1055 73.213 10.1055C72.0716 10.1055 71.337 11.0103 71.337 12.438C71.337 13.8699 72.0633 14.7747 73.213 14.7747ZM73.4662 10.9065C74.2132 10.9065 74.6822 11.5 74.6822 12.4421C74.6822 13.3884 74.2174 13.9736 73.4662 13.9736C72.7108 13.9736 72.2584 13.3967 72.2584 12.438C72.2584 11.4875 72.7149 10.9065 73.4662 10.9065Z\" fill=\"black\"/>\n<path d=\"M81.3444 14.7871C82.6643 14.7871 83.4736 13.9031 83.4736 12.438C83.4736 10.9812 82.6601 10.093 81.3444 10.093C80.0246 10.093 79.2111 10.9812 79.2111 12.438C79.2111 13.9031 80.0205 14.7871 81.3444 14.7871ZM81.3444 13.9944C80.5683 13.9944 80.1325 13.4258 80.1325 12.438C80.1325 11.4585 80.5683 10.8857 81.3444 10.8857C82.1164 10.8857 82.5563 11.4585 82.5563 12.438C82.5563 13.4216 82.1164 13.9944 81.3444 13.9944Z\" fill=\"black\"/>\n<path d=\"M84.6548 14.7H85.5471V12.0562C85.5471 11.3506 85.9663 10.9106 86.6262 10.9106C87.2861 10.9106 87.6016 11.2717 87.6016 11.998V14.7H88.4939V11.7739C88.4939 10.699 87.9377 10.093 86.9292 10.093C86.2485 10.093 85.8003 10.396 85.5803 10.8982H85.5139V10.1802H84.6548V14.7Z\" fill=\"black\"/>\n<path d=\"M92.6036 9.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036 14.3762 92.9979 14.7249 93.9898 14.7249C94.1642 14.7249 94.3302 14.7041 94.4754 14.6792V13.9363C94.3509 13.9487 94.2721 13.957 94.1351 13.957C93.691 13.957 93.4959 13.7495 93.4959 13.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z\" fill=\"black\"/>\n<path d=\"M95.6732 14.7H96.5656V12.0603C96.5656 11.3755 96.9723 10.9148 97.7028 10.9148C98.3336 10.9148 98.6698 11.28 98.6698 12.0022V14.7H99.5622V11.7822C99.5622 10.7073 98.9687 10.0972 98.0058 10.0972C97.3251 10.0972 96.8478 10.4001 96.6278 10.9065H96.5573V8.41626H95.6732V14.7Z\" fill=\"black\"/>\n<path d=\"M102.781 10.8525C103.441 10.8525 103.873 11.3132 103.894 12.0229H101.611C101.661 11.3174 102.121 10.8525 102.781 10.8525ZM103.889 13.4797C103.723 13.8325 103.354 14.0276 102.814 14.0276C102.101 14.0276 101.64 13.5254 101.611 12.7327V12.6829H104.802V12.3716C104.802 10.9521 104.043 10.093 102.785 10.093C101.511 10.093 100.702 11.0103 100.702 12.4546C100.702 13.8989 101.495 14.7871 102.789 14.7871C103.823 14.7871 104.545 14.2891 104.748 13.4797H103.889Z\" fill=\"black\"/>\n<path d=\"M24.769 20.3008C24.7907 18.6198 25.6934 17.0292 27.1256 16.1488C26.2221 14.8584 24.7088 14.0403 23.1344 13.9911C21.4552 13.8148 19.8272 14.9959 18.9715 14.9959C18.0992 14.9959 16.7817 14.0086 15.363 14.0378C13.5137 14.0975 11.7898 15.1489 10.8901 16.7656C8.95607 20.1141 10.3987 25.0351 12.2513 27.7417C13.1782 29.0671 14.2615 30.5475 15.6789 30.495C17.066 30.4375 17.584 29.6105 19.2583 29.6105C20.9171 29.6105 21.4031 30.495 22.8493 30.4616C24.3377 30.4375 25.2754 29.1304 26.1698 27.7925C26.8358 26.8481 27.3483 25.8044 27.6882 24.7C25.9391 23.9602 24.771 22.2 24.769 20.3008Z\" fill=\"black\"/>\n<path d=\"M22.0373 12.2111C22.8489 11.2369 23.2487 9.98469 23.1518 8.72046C21.912 8.85068 20.7668 9.44324 19.9443 10.3801C19.14 11.2954 18.7214 12.5255 18.8006 13.7415C20.0408 13.7542 21.2601 13.1777 22.0373 12.2111Z\" fill=\"black\"/>\n</svg>";

var FDroidBlack = "<svg width=\"112\" height=\"40\" viewBox=\"0 0 112 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"111\" height=\"39\" rx=\"5.5\" fill=\"black\" stroke=\"#A6A6A6\"/>\n<path d=\"M42.5498 31V29.7172L43.8743 29.4673V20.4125L42.5498 20.1626V18.8714H51.9878V22.0202H50.3468L50.2135 20.4958H45.9735V24.1943H50.3051V25.8187H45.9735V29.4673L47.2979 29.7172V31H42.5498Z\" fill=\"white\"/>\n<path d=\"M53.6871 26.6517V25.0273H58.1187V26.6517H53.6871Z\" fill=\"white\"/>\n<path d=\"M59.7931 31V29.7172L61.1259 29.4589V20.4291L59.7931 20.1626V18.8714H64.8744C65.9518 18.8714 66.8986 19.1268 67.715 19.6378C68.5313 20.1487 69.1672 20.8512 69.6226 21.7453C70.0779 22.6394 70.3056 23.664 70.3056 24.8191V25.0606C70.3056 26.1991 70.0807 27.2181 69.6309 28.1178C69.1866 29.0119 68.5619 29.7172 67.7566 30.2336C66.9514 30.7445 66.0101 31 64.9327 31H59.7931ZM63.2251 29.384H64.8244C65.5353 29.384 66.1406 29.1951 66.6404 28.8175C67.1457 28.4343 67.5317 27.9179 67.7983 27.2681C68.0648 26.6128 68.1981 25.877 68.1981 25.0606V24.8107C68.1981 23.9777 68.0648 23.2364 67.7983 22.5866C67.5317 21.9369 67.1457 21.426 66.6404 21.0539C66.1406 20.6818 65.5353 20.4958 64.8244 20.4958H63.2251V29.384Z\" fill=\"white\"/>\n<path d=\"M71.5551 31V29.7172L72.7963 29.4673V23.5279L71.4802 23.278V21.9868H74.7289L74.8372 23.1197L74.8538 23.303C75.337 22.3145 76.0367 21.8202 76.953 21.8202C77.2973 21.8202 77.6055 21.8647 77.8777 21.9535L77.6361 23.8944L76.4616 23.8278C76.0784 23.8056 75.7618 23.8805 75.5119 24.0527C75.262 24.2249 75.0565 24.4637 74.8955 24.7691V29.4673L76.145 29.7172V31H71.5551Z\" fill=\"white\"/>\n<path d=\"M82.7674 31.1749C81.9011 31.1749 81.1569 30.9806 80.535 30.5918C79.913 30.1975 79.4354 29.6561 79.1022 28.9674C78.769 28.2788 78.6024 27.4847 78.6024 26.585V26.4101C78.6024 25.516 78.769 24.7247 79.1022 24.036C79.4354 23.3474 79.913 22.806 80.535 22.4117C81.1569 22.0174 81.8955 21.8202 82.7508 21.8202C83.6171 21.8202 84.3612 22.0174 84.9832 22.4117C85.6052 22.8004 86.0828 23.3419 86.416 24.036C86.7492 24.7247 86.9158 25.516 86.9158 26.4101V26.585C86.9158 27.4902 86.7492 28.2872 86.416 28.9758C86.0828 29.6644 85.6052 30.2031 84.9832 30.5918C84.3668 30.9806 83.6282 31.1749 82.7674 31.1749ZM82.7674 29.5589C83.4616 29.5589 83.9781 29.284 84.3168 28.7342C84.6556 28.1789 84.8249 27.4625 84.8249 26.585V26.4101C84.8249 25.5493 84.6528 24.8413 84.3085 24.2859C83.9697 23.7251 83.4505 23.4446 82.7508 23.4446C82.0566 23.4446 81.5401 23.7251 81.2014 24.2859C80.8682 24.8413 80.7016 25.5493 80.7016 26.4101V26.585C80.7016 27.4625 80.8682 28.1789 81.2014 28.7342C81.5401 29.284 82.0621 29.5589 82.7674 29.5589Z\" fill=\"white\"/>\n<path d=\"M88.0154 31V29.7172L89.2649 29.4673V23.5279L87.9404 23.278V21.9868H91.3641V29.4673L92.6052 29.7172V31H88.0154ZM89.1816 19.946V18.0051H91.3641V19.946H89.1816Z\" fill=\"white\"/>\n<path d=\"M97.0618 31.1749C96.3343 31.1749 95.7124 30.9917 95.1959 30.6251C94.6794 30.2586 94.2824 29.7477 94.0047 29.0924C93.7326 28.4315 93.5965 27.6624 93.5965 26.785V26.61C93.5965 25.6549 93.7326 24.8191 94.0047 24.1027C94.2824 23.3807 94.6794 22.8199 95.1959 22.42C95.7124 22.0202 96.3316 21.8202 97.0535 21.8202C97.57 21.8202 98.0198 21.9202 98.403 22.1201C98.7917 22.3145 99.1249 22.5949 99.4026 22.9615V19.5461L98.0781 19.2962V18.0051H101.502V29.4673L102.751 29.7172V31H99.6858L99.5192 29.9087C98.9361 30.7529 98.117 31.1749 97.0618 31.1749ZM97.6533 29.5172C98.0531 29.5172 98.3974 29.4284 98.6862 29.2507C98.975 29.073 99.2138 28.8203 99.4026 28.4926V24.5192C99.2193 24.1915 98.9805 23.9361 98.6862 23.7528C98.3974 23.5696 98.0587 23.4779 97.6699 23.4779C96.9869 23.4779 96.4871 23.7667 96.1705 24.3443C95.854 24.9218 95.6957 25.6771 95.6957 26.61V26.785C95.6957 27.618 95.8484 28.2816 96.1539 28.7759C96.4648 29.2701 96.9646 29.5172 97.6533 29.5172Z\" fill=\"white\"/>\n<path d=\"M47.209 13.2211C46.9919 13.5041 46.6911 13.7184 46.3065 13.864C45.9218 14.0096 45.485 14.0824 44.996 14.0824C44.4932 14.0824 44.0481 13.9684 43.6607 13.7403C43.2733 13.5123 42.9739 13.1867 42.7623 12.7636C42.5535 12.3378 42.445 11.8419 42.4368 11.2759V10.8061C42.4368 9.89948 42.6538 9.19203 43.0879 8.68376C43.522 8.17274 44.1278 7.91724 44.9053 7.91724C45.5729 7.91724 46.1032 8.08208 46.496 8.41177C46.8889 8.74146 47.1252 9.21675 47.2049 9.83767H46.1828C46.0675 9.1151 45.6485 8.75382 44.9259 8.75382C44.4589 8.75382 44.1031 8.92278 43.8585 9.26071C43.6168 9.5959 43.4918 10.0891 43.4835 10.7402V11.2017C43.4835 11.8501 43.6195 12.3543 43.8915 12.7142C44.1663 13.0714 44.5468 13.2499 45.0331 13.2499C45.5661 13.2499 45.9452 13.129 46.1705 12.8873V11.7128H44.9342V10.9215H47.209V13.2211Z\" fill=\"white\"/>\n<path d=\"M51.9461 11.3213H49.4817V13.1675H52.3623V14H48.4391V7.99966H52.3335V8.84036H49.4817V10.497H51.9461V11.3213Z\" fill=\"white\"/>\n<path d=\"M57.7135 8.84036H55.8425V14H54.8081V8.84036H52.9536V7.99966H57.7135V8.84036Z\" fill=\"white\"/>\n<path d=\"M61.6284 14H60.5899V7.99966H61.6284V14Z\" fill=\"white\"/>\n<path d=\"M67.2062 8.84036H65.3352V14H64.3008V8.84036H62.4463V7.99966H67.2062V8.84036Z\" fill=\"white\"/>\n<path d=\"M74.8094 11.1564C74.8094 11.7444 74.7078 12.2609 74.5045 12.7059C74.3012 13.1483 74.0099 13.489 73.6308 13.728C73.2544 13.9643 72.8203 14.0824 72.3285 14.0824C71.8423 14.0824 71.4082 13.9643 71.0263 13.728C70.6471 13.489 70.3532 13.1497 70.1444 12.7101C69.9383 12.2705 69.8339 11.7636 69.8312 11.1894V10.8515C69.8312 10.2663 69.9342 9.74975 70.1402 9.30192C70.349 8.8541 70.6416 8.51205 71.018 8.27577C71.3972 8.03675 71.8313 7.91724 72.3203 7.91724C72.8093 7.91724 73.2421 8.03537 73.6184 8.27165C73.9976 8.50518 74.2902 8.84311 74.4962 9.28544C74.7023 9.72502 74.8067 10.2374 74.8094 10.8226V11.1564ZM73.7668 10.8432C73.7668 10.1783 73.6404 9.6687 73.3877 9.31429C73.1377 8.95987 72.7819 8.78267 72.3203 8.78267C71.8697 8.78267 71.5167 8.95987 71.2612 9.31429C71.0084 9.66595 70.8793 10.1646 70.8738 10.8102V11.1564C70.8738 11.8158 71.0016 12.3254 71.2571 12.6853C71.5153 13.0453 71.8725 13.2252 72.3285 13.2252C72.7901 13.2252 73.1445 13.0494 73.3918 12.6977C73.6418 12.346 73.7668 11.8323 73.7668 11.1564V10.8432Z\" fill=\"white\"/>\n<path d=\"M80.6922 14H79.6496L76.975 9.74288V14H75.9324V7.99966H76.975L79.6578 12.2732V7.99966H80.6922V14Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.2302 9.77295C31.5231 10.0658 31.998 10.0658 32.2909 9.77295L35.4729 6.59097C35.7658 6.29808 35.7658 5.8232 35.4729 5.53031L31.2302 9.77295Z\" fill=\"#8AB000\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.2302 9.77295C31.5231 10.0658 31.998 10.0658 32.2909 9.77295L35.4729 6.59097C35.7658 6.29808 35.7658 5.8232 35.4729 5.53031L31.2302 9.77295Z\" fill=\"#263238\" fill-opacity=\"0.2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.2303 9.77294C30.9374 9.48005 30.9374 9.00518 31.2303 8.71228L34.4123 5.5303C34.7052 5.23741 35.18 5.23741 35.4729 5.5303L31.2303 9.77294Z\" fill=\"#8AB000\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.2303 9.77294C30.9374 9.48005 30.9374 9.00518 31.2303 8.71228L34.4123 5.5303C34.7052 5.23741 35.18 5.23741 35.4729 5.5303L31.2303 9.77294Z\" fill=\"white\" fill-opacity=\"0.3\"/>\n<path d=\"M31.2303 9.77297C31.0546 9.59724 31.1495 9.21734 31.4424 8.92444L34.6244 5.74246C34.9173 5.44957 35.2972 5.35459 35.4729 5.53033C35.6487 5.70607 35.5537 6.08596 35.2608 6.37886L32.0788 9.56084C31.7859 9.85373 31.406 9.94871 31.2303 9.77297Z\" fill=\"#8AB000\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.53027 5.53033C7.23738 5.82323 7.23738 6.2981 7.53027 6.59099L10.7123 9.77298C11.0051 10.0659 11.48 10.0659 11.7729 9.77298L7.53027 5.53033Z\" fill=\"#8AB000\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.53027 5.53033C7.23738 5.82323 7.23738 6.2981 7.53027 6.59099L10.7123 9.77298C11.0051 10.0659 11.48 10.0659 11.7729 9.77298L7.53027 5.53033Z\" fill=\"#263238\" fill-opacity=\"0.2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.53022 5.53033C7.82311 5.23744 8.29798 5.23744 8.59088 5.53033L11.7729 8.71231C12.0658 9.0052 12.0658 9.48008 11.7729 9.77297L7.53022 5.53033Z\" fill=\"#8AB000\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.53022 5.53033C7.82311 5.23744 8.29798 5.23744 8.59088 5.53033L11.7729 8.71231C12.0658 9.0052 12.0658 9.48008 11.7729 9.77297L7.53022 5.53033Z\" fill=\"white\" fill-opacity=\"0.3\"/>\n<path d=\"M7.53043 5.53036C7.70617 5.35462 8.08607 5.4496 8.37896 5.74249L11.5609 8.92447C11.8538 9.21736 11.9488 9.59726 11.7731 9.773C11.5973 9.94873 11.2174 9.85376 10.9245 9.56087L7.74257 6.37888C7.44967 6.08599 7.3547 5.70609 7.53043 5.53036Z\" fill=\"#8AB000\"/>\n<g filter=\"url(#filter0_ii_7014_15160)\">\n<path d=\"M10 10C10 8.89543 10.8954 8 12 8H31C32.1046 8 33 8.89543 33 10V14C33 15.1046 32.1046 16 31 16H12C10.8954 16 10 15.1046 10 14V10Z\" fill=\"#AEEA00\"/>\n</g>\n<g filter=\"url(#filter1_ii_7014_15160)\">\n<path d=\"M10 19C10 17.8954 10.8954 17 12 17H31C32.1046 17 33 17.8954 33 19V31C33 32.1046 32.1046 33 31 33H12C10.8954 33 10 32.1046 10 31V19Z\" fill=\"#1976D2\"/>\n</g>\n<path d=\"M21.5017 28.5C23.4347 28.5 25.0017 26.933 25.0017 25C25.0017 23.067 23.4347 21.5 21.5017 21.5C19.9162 21.5 18.5769 22.5543 18.1466 24H19.7693C20.1151 23.4022 20.7614 23 21.5017 23C22.6063 23 23.5017 23.8954 23.5017 25C23.5017 26.1046 22.6063 27 21.5017 27C20.7614 27 20.1151 26.5978 19.7693 26H18.1466C18.5769 27.4457 19.9162 28.5 21.5017 28.5Z\" fill=\"#0D47A1\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.5017 25C27.5017 28.3137 24.8154 31 21.5017 31C18.188 31 15.5017 28.3137 15.5017 25C15.5017 21.6863 18.188 19 21.5017 19C24.8154 19 27.5017 21.6863 27.5017 25ZM26.5017 25C26.5017 27.7614 24.2631 30 21.5017 30C18.7403 30 16.5017 27.7614 16.5017 25C16.5017 22.2386 18.7403 20 21.5017 20C24.2631 20 26.5017 22.2386 26.5017 25Z\" fill=\"#0D47A1\"/>\n<g filter=\"url(#filter2_d_7014_15160)\">\n<path d=\"M15.5 14C16.6046 14 17.5 13.1046 17.5 12C17.5 10.8954 16.6046 10 15.5 10C14.3954 10 13.5 10.8954 13.5 12C13.5 13.1046 14.3954 14 15.5 14Z\" fill=\"white\"/>\n<path d=\"M27.5 14C28.6046 14 29.5 13.1046 29.5 12C29.5 10.8954 28.6046 10 27.5 10C26.3954 10 25.5 10.8954 25.5 12C25.5 13.1046 26.3954 14 27.5 14Z\" fill=\"white\"/>\n</g>\n<path d=\"M7.53022 5.53034C7.82311 5.23745 8.29798 5.23745 8.59088 5.53034L11.2188 8.15827C11.4588 8.05638 11.7227 8.00001 11.9999 8.00001H30.9999C31.2779 8.00001 31.5427 8.05674 31.7833 8.15926L34.4122 5.53034C34.7051 5.23745 35.18 5.23745 35.4729 5.53034C35.7657 5.82324 35.7657 6.29811 35.4729 6.591L32.8426 9.22125C32.9439 9.4606 32.9999 9.72376 32.9999 10V14C32.9999 15.1046 32.1045 16 30.9999 16H11.9999C10.8953 16 9.99988 15.1046 9.99988 14V10C9.99988 9.72287 10.0563 9.4589 10.1582 9.21893L7.53022 6.591C7.23732 6.29811 7.23732 5.82323 7.53022 5.53034Z\" fill=\"url(#paint0_radial_7014_15160)\"/>\n<path d=\"M11.9999 17C10.8953 17 9.99988 17.8954 9.99988 19V31C9.99988 32.1046 10.8953 33 11.9999 33H30.9999C32.1045 33 32.9999 32.1046 32.9999 31V19C32.9999 17.8954 32.1045 17 30.9999 17H11.9999Z\" fill=\"url(#paint1_radial_7014_15160)\"/>\n<defs>\n<filter id=\"filter0_ii_7014_15160\" x=\"10\" y=\"8\" width=\"23\" height=\"8\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"-1\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.2 0\"/>\n<feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow_7014_15160\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"1\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0\"/>\n<feBlend mode=\"normal\" in2=\"effect1_innerShadow_7014_15160\" result=\"effect2_innerShadow_7014_15160\"/>\n</filter>\n<filter id=\"filter1_ii_7014_15160\" x=\"10\" y=\"17\" width=\"23\" height=\"16\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"-1\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.2 0\"/>\n<feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow_7014_15160\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"1\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0\"/>\n<feBlend mode=\"normal\" in2=\"effect1_innerShadow_7014_15160\" result=\"effect2_innerShadow_7014_15160\"/>\n</filter>\n<filter id=\"filter2_d_7014_15160\" x=\"13.5\" y=\"9.5\" width=\"16\" height=\"4.5\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"-0.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.2 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_7014_15160\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_7014_15160\" result=\"shape\"/>\n</filter>\n<radialGradient id=\"paint0_radial_7014_15160\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(7.09516 5.09461) rotate(90) scale(27.9054 28.4139)\">\n<stop stop-color=\"white\" stop-opacity=\"0.1\"/>\n<stop offset=\"1\" stop-color=\"white\" stop-opacity=\"0\"/>\n</radialGradient>\n<radialGradient id=\"paint1_radial_7014_15160\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(7.09516 5.09461) rotate(90) scale(27.9054 28.4139)\">\n<stop stop-color=\"white\" stop-opacity=\"0.1\"/>\n<stop offset=\"1\" stop-color=\"white\" stop-opacity=\"0\"/>\n</radialGradient>\n</defs>\n</svg>";

var FDroidOutline = "<svg width=\"112\" height=\"40\" viewBox=\"0 0 112 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"111\" height=\"39\" rx=\"5.5\" fill=\"white\" stroke=\"black\"/>\n<path d=\"M42.5498 31V29.7172L43.8743 29.4673V20.4125L42.5498 20.1626V18.8714H51.9878V22.0202H50.3468L50.2135 20.4958H45.9735V24.1943H50.3051V25.8187H45.9735V29.4673L47.2979 29.7172V31H42.5498Z\" fill=\"black\"/>\n<path d=\"M53.6871 26.6517V25.0273H58.1187V26.6517H53.6871Z\" fill=\"black\"/>\n<path d=\"M59.7931 31V29.7172L61.1259 29.4589V20.4291L59.7931 20.1626V18.8714H64.8744C65.9518 18.8714 66.8986 19.1268 67.715 19.6378C68.5313 20.1487 69.1672 20.8512 69.6226 21.7453C70.0779 22.6394 70.3056 23.664 70.3056 24.8191V25.0606C70.3056 26.1991 70.0807 27.2181 69.6309 28.1178C69.1866 29.0119 68.5619 29.7172 67.7566 30.2336C66.9514 30.7445 66.0101 31 64.9327 31H59.7931ZM63.2251 29.384H64.8244C65.5353 29.384 66.1406 29.1951 66.6404 28.8175C67.1457 28.4343 67.5317 27.9179 67.7983 27.2681C68.0648 26.6128 68.1981 25.877 68.1981 25.0606V24.8107C68.1981 23.9777 68.0648 23.2364 67.7983 22.5866C67.5317 21.9369 67.1457 21.426 66.6404 21.0539C66.1406 20.6818 65.5353 20.4958 64.8244 20.4958H63.2251V29.384Z\" fill=\"black\"/>\n<path d=\"M71.5551 31V29.7172L72.7963 29.4673V23.5279L71.4802 23.278V21.9868H74.7289L74.8372 23.1197L74.8538 23.303C75.337 22.3145 76.0367 21.8202 76.953 21.8202C77.2973 21.8202 77.6055 21.8647 77.8777 21.9535L77.6361 23.8944L76.4616 23.8278C76.0784 23.8056 75.7618 23.8805 75.5119 24.0527C75.262 24.2249 75.0565 24.4637 74.8955 24.7691V29.4673L76.145 29.7172V31H71.5551Z\" fill=\"black\"/>\n<path d=\"M82.7674 31.1749C81.9011 31.1749 81.1569 30.9806 80.535 30.5918C79.913 30.1975 79.4354 29.6561 79.1022 28.9674C78.769 28.2788 78.6024 27.4847 78.6024 26.585V26.4101C78.6024 25.516 78.769 24.7247 79.1022 24.036C79.4354 23.3474 79.913 22.806 80.535 22.4117C81.1569 22.0174 81.8955 21.8202 82.7508 21.8202C83.6171 21.8202 84.3612 22.0174 84.9832 22.4117C85.6052 22.8004 86.0828 23.3419 86.416 24.036C86.7492 24.7247 86.9158 25.516 86.9158 26.4101V26.585C86.9158 27.4902 86.7492 28.2872 86.416 28.9758C86.0828 29.6644 85.6052 30.2031 84.9832 30.5918C84.3668 30.9806 83.6282 31.1749 82.7674 31.1749ZM82.7674 29.5589C83.4616 29.5589 83.9781 29.284 84.3168 28.7342C84.6556 28.1789 84.8249 27.4625 84.8249 26.585V26.4101C84.8249 25.5493 84.6528 24.8413 84.3085 24.2859C83.9697 23.7251 83.4505 23.4446 82.7508 23.4446C82.0566 23.4446 81.5401 23.7251 81.2014 24.2859C80.8682 24.8413 80.7016 25.5493 80.7016 26.4101V26.585C80.7016 27.4625 80.8682 28.1789 81.2014 28.7342C81.5401 29.284 82.0621 29.5589 82.7674 29.5589Z\" fill=\"black\"/>\n<path d=\"M88.0154 31V29.7172L89.2649 29.4673V23.5279L87.9404 23.278V21.9868H91.3641V29.4673L92.6052 29.7172V31H88.0154ZM89.1816 19.946V18.0051H91.3641V19.946H89.1816Z\" fill=\"black\"/>\n<path d=\"M97.0618 31.1749C96.3343 31.1749 95.7124 30.9917 95.1959 30.6251C94.6794 30.2586 94.2824 29.7477 94.0047 29.0924C93.7326 28.4315 93.5965 27.6624 93.5965 26.785V26.61C93.5965 25.6549 93.7326 24.8191 94.0047 24.1027C94.2824 23.3807 94.6794 22.8199 95.1959 22.42C95.7124 22.0202 96.3316 21.8202 97.0535 21.8202C97.57 21.8202 98.0198 21.9202 98.403 22.1201C98.7917 22.3145 99.1249 22.5949 99.4026 22.9615V19.5461L98.0781 19.2962V18.0051H101.502V29.4673L102.751 29.7172V31H99.6858L99.5192 29.9087C98.9361 30.7529 98.117 31.1749 97.0618 31.1749ZM97.6533 29.5172C98.0531 29.5172 98.3974 29.4284 98.6862 29.2507C98.975 29.073 99.2138 28.8203 99.4026 28.4926V24.5192C99.2193 24.1915 98.9805 23.9361 98.6862 23.7528C98.3974 23.5696 98.0587 23.4779 97.6699 23.4779C96.9869 23.4779 96.4871 23.7667 96.1705 24.3443C95.854 24.9218 95.6957 25.6771 95.6957 26.61V26.785C95.6957 27.618 95.8484 28.2816 96.1539 28.7759C96.4648 29.2701 96.9646 29.5172 97.6533 29.5172Z\" fill=\"black\"/>\n<path d=\"M47.209 13.2211C46.9919 13.5041 46.6911 13.7184 46.3065 13.864C45.9218 14.0096 45.485 14.0824 44.996 14.0824C44.4932 14.0824 44.0481 13.9684 43.6607 13.7404C43.2733 13.5123 42.9739 13.1868 42.7623 12.7637C42.5535 12.3378 42.445 11.8419 42.4368 11.276V10.8062C42.4368 9.89951 42.6538 9.19206 43.0879 8.68379C43.522 8.17277 44.1278 7.91727 44.9053 7.91727C45.5729 7.91727 46.1032 8.08211 46.496 8.4118C46.8889 8.74149 47.1252 9.21678 47.2049 9.8377H46.1828C46.0675 9.11513 45.6485 8.75385 44.9259 8.75385C44.4589 8.75385 44.1031 8.92281 43.8585 9.26074C43.6168 9.59593 43.4918 10.0891 43.4835 10.7402V11.2018C43.4835 11.8502 43.6195 12.3543 43.8915 12.7142C44.1663 13.0714 44.5468 13.25 45.0331 13.25C45.5661 13.25 45.9452 13.1291 46.1705 12.8873V11.7128H44.9342V10.9215H47.209V13.2211Z\" fill=\"black\"/>\n<path d=\"M51.9461 11.3213H49.4817V13.1675H52.3623V14H48.4391V7.99969H52.3335V8.84039H49.4817V10.4971H51.9461V11.3213Z\" fill=\"black\"/>\n<path d=\"M57.7135 8.84039H55.8425V14H54.8081V8.84039H52.9536V7.99969H57.7135V8.84039Z\" fill=\"black\"/>\n<path d=\"M61.6284 14H60.5899V7.99969H61.6284V14Z\" fill=\"black\"/>\n<path d=\"M67.2062 8.84039H65.3352V14H64.3008V8.84039H62.4463V7.99969H67.2062V8.84039Z\" fill=\"black\"/>\n<path d=\"M74.8094 11.1564C74.8094 11.7444 74.7078 12.2609 74.5045 12.706C74.3012 13.1483 74.0099 13.489 73.6308 13.728C73.2544 13.9643 72.8203 14.0824 72.3285 14.0824C71.8423 14.0824 71.4082 13.9643 71.0263 13.728C70.6471 13.489 70.3532 13.1497 70.1444 12.7101C69.9383 12.2705 69.8339 11.7636 69.8312 11.1894V10.8515C69.8312 10.2663 69.9342 9.74978 70.1402 9.30195C70.349 8.85413 70.6416 8.51208 71.018 8.2758C71.3972 8.03678 71.8313 7.91727 72.3203 7.91727C72.8093 7.91727 73.2421 8.0354 73.6184 8.27168C73.9976 8.50521 74.2902 8.84314 74.4962 9.28547C74.7023 9.72505 74.8067 10.2374 74.8094 10.8226V11.1564ZM73.7668 10.8432C73.7668 10.1784 73.6404 9.66873 73.3877 9.31432C73.1377 8.9599 72.7819 8.7827 72.3203 8.7827C71.8697 8.7827 71.5167 8.9599 71.2612 9.31432C71.0084 9.66598 70.8793 10.1646 70.8738 10.8103V11.1564C70.8738 11.8158 71.0016 12.3255 71.2571 12.6854C71.5153 13.0453 71.8725 13.2252 72.3285 13.2252C72.7901 13.2252 73.1445 13.0494 73.3918 12.6977C73.6418 12.3461 73.7668 11.8323 73.7668 11.1564V10.8432Z\" fill=\"black\"/>\n<path d=\"M80.6922 14H79.6496L76.975 9.74291V14H75.9324V7.99969H76.975L79.6578 12.2733V7.99969H80.6922V14Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.59088 5.53034C8.29799 5.23745 7.82311 5.23745 7.53022 5.53034C7.23733 5.82323 7.23732 6.29811 7.53021 6.591L10.1581 9.21893C10.0562 9.4589 9.99988 9.72287 9.99988 10V14C9.99988 15.1046 10.8953 16 11.9999 16H30.9999C32.1045 16 32.9999 15.1046 32.9999 14V10C32.9999 9.72376 32.9439 9.4606 32.8426 9.22125L35.4728 6.59101C35.7657 6.29812 35.7657 5.82324 35.4728 5.53035C35.1799 5.23746 34.7051 5.23745 34.4122 5.53034L31.7833 8.15926C31.5427 8.05674 31.2779 8.00001 30.9999 8.00001H11.9999C11.7227 8.00001 11.4588 8.05638 11.2188 8.15827L8.59088 5.53034ZM17.4999 12C17.4999 13.1046 16.6044 14 15.4999 14C14.3953 14 13.4999 13.1046 13.4999 12C13.4999 10.8954 14.3953 10 15.4999 10C16.6044 10 17.4999 10.8954 17.4999 12ZM29.4999 12C29.4999 13.1046 28.6045 14 27.4999 14C26.3953 14 25.4999 13.1046 25.4999 12C25.4999 10.8954 26.3953 10 27.4999 10C28.6045 10 29.4999 10.8954 29.4999 12Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.5015 25C26.5015 27.7614 24.2629 30 21.5015 30C18.7401 30 16.5015 27.7614 16.5015 25C16.5015 22.2386 18.7401 20 21.5015 20C24.2629 20 26.5015 22.2386 26.5015 25ZM21.5015 28.5C23.4345 28.5 25.0015 26.933 25.0015 25C25.0015 23.067 23.4345 21.5 21.5015 21.5C19.916 21.5 18.5767 22.5543 18.1465 24H19.7691C20.1149 23.4022 20.7612 23 21.5015 23C22.6061 23 23.5015 23.8954 23.5015 25C23.5015 26.1046 22.6061 27 21.5015 27C20.7612 27 20.1149 26.5978 19.7691 26H18.1465C18.5767 27.4457 19.916 28.5 21.5015 28.5Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.99988 31V19C9.99988 17.8954 10.8953 17 11.9999 17H30.9999C32.1045 17 32.9999 17.8954 32.9999 19V31C32.9999 32.1046 32.1045 33 30.9999 33H11.9999C10.8953 33 9.99988 32.1046 9.99988 31ZM27.5015 25C27.5015 28.3137 24.8152 31 21.5015 31C18.1878 31 15.5015 28.3137 15.5015 25C15.5015 21.6863 18.1878 19 21.5015 19C24.8152 19 27.5015 21.6863 27.5015 25Z\" fill=\"black\"/>\n</svg>";

var GalaxyStoreBlack = "<svg width=\"147\" height=\"40\" viewBox=\"0 0 147 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"146\" height=\"39\" rx=\"5.5\" fill=\"black\" stroke=\"#A6A6A6\"/>\n<path d=\"M64.7516 20.3987H66.7715V31.3885H64.7516V20.3987Z\" fill=\"white\"/>\n<path d=\"M42.5 25.9699C42.5 22.8811 44.8314 20.4009 48.039 20.4009C50.2816 20.4009 52.0489 21.5444 52.9695 23.1779L51.1875 24.2473C50.5193 23.0146 49.4799 22.3611 48.054 22.3611C46.0343 22.3611 44.5047 23.9946 44.5047 25.9699C44.5047 27.9745 46.0196 29.5786 48.1281 29.5786C49.7469 29.5786 50.8757 28.6578 51.2616 27.2322H47.8017V25.3017H53.4298V26.1037C53.4298 29.0289 51.3657 31.5392 48.1281 31.5392C44.7423 31.5392 42.5 28.9695 42.5 25.9699Z\" fill=\"white\"/>\n<path d=\"M54.3525 27.0543C54.3525 24.1732 56.4613 22.525 58.6592 22.525C59.8027 22.525 60.8274 22.9999 61.4512 23.7426V22.7032H63.4558V31.3907H61.4512V30.2616C60.8124 31.0636 59.773 31.5689 58.6295 31.5689C56.5354 31.5689 54.3525 29.8904 54.3525 27.0543ZM61.555 27.0246C61.555 25.5543 60.4412 24.3514 58.9562 24.3514C57.4713 24.3514 56.3278 25.5249 56.3278 27.0246C56.3278 28.539 57.4713 29.7272 58.9562 29.7272C60.4412 29.7272 61.555 28.5243 61.555 27.0246Z\" fill=\"white\"/>\n<path d=\"M67.7938 27.0543C67.7938 24.1732 69.9026 22.525 72.1005 22.525C73.244 22.525 74.2686 22.9999 74.8925 23.7426V22.7032H76.8971V31.3907H74.8925V30.2616C74.2539 31.0636 73.2146 31.5689 72.0707 31.5689C69.977 31.5689 67.7938 29.8904 67.7938 27.0543ZM74.9966 27.0246C74.9966 25.5543 73.8828 24.3514 72.3981 24.3514C70.9128 24.3514 69.7693 25.5249 69.7693 27.0246C69.7693 28.539 70.9128 29.7272 72.3981 29.7272C73.8825 29.7272 74.9966 28.5243 74.9966 27.0246Z\" fill=\"white\"/>\n<path d=\"M80.8048 26.9652L77.6566 22.7032H80.1072L82.0818 25.4652L84.0424 22.7032H86.4182L83.2994 26.9949L86.6261 31.3907H84.1759L82.0524 28.4949L79.988 31.3907H77.5375L80.8048 26.9652Z\" fill=\"white\"/>\n<path d=\"M90.3846 30.9598L86.8206 22.7029H88.9588L91.3796 28.554L93.6663 22.7029H95.7757L90.5926 35.4H88.5582L90.3846 30.9598Z\" fill=\"white\"/>\n<path d=\"M99.8907 29.5936L101.732 28.1384C102.282 29.074 103.128 29.6083 104.108 29.6083C105.178 29.6083 105.757 28.911 105.757 28.1531C105.757 27.2325 104.658 26.9505 103.499 26.594C102.044 26.1334 100.426 25.5693 100.426 23.5049C100.426 21.7676 101.94 20.4012 104.019 20.4012C105.772 20.4012 106.781 21.0697 107.658 21.9756L105.994 23.2376C105.534 22.5547 104.895 22.1982 104.034 22.1982C103.054 22.1982 102.519 22.7329 102.519 23.4305C102.519 24.292 103.559 24.5743 104.732 24.9605C106.203 25.4355 107.866 26.089 107.866 28.1681C107.866 29.8757 106.499 31.5395 104.123 31.5395C102.163 31.5392 100.871 30.7071 99.8907 29.5936Z\" fill=\"white\"/>\n<path d=\"M108.03 22.7029H109.515V21.3812L111.535 20V22.7029H113.302V24.4999H111.535V27.7519C111.535 29.2669 111.743 29.5045 113.302 29.5045V31.3904H113.02C110.332 31.3904 109.515 30.5292 109.515 27.7672V24.4999H108.03L108.03 22.7029Z\" fill=\"white\"/>\n<path d=\"M113.838 27.0543C113.838 24.5296 115.827 22.5247 118.337 22.5247C120.832 22.5247 122.837 24.5296 122.837 27.0543C122.837 29.5639 120.832 31.5689 118.337 31.5689C115.827 31.5689 113.838 29.5639 113.838 27.0543ZM120.862 27.0543C120.862 25.599 119.747 24.4108 118.337 24.4108C116.896 24.4108 115.812 25.599 115.812 27.0543C115.812 28.4949 116.896 29.6828 118.337 29.6828C119.747 29.6828 120.862 28.4949 120.862 27.0543Z\" fill=\"white\"/>\n<path d=\"M125.853 22.7029V23.9949C126.254 23.1335 126.981 22.7029 128.08 22.7029C128.704 22.7029 129.223 22.8514 129.61 23.0741L128.852 24.9749C128.555 24.782 128.214 24.6334 127.649 24.6334C126.491 24.6334 125.867 25.2573 125.867 26.7569V31.3904H123.862V22.7029H125.853Z\" fill=\"white\"/>\n<path d=\"M129.834 27.069C129.834 24.5296 131.808 22.5247 134.348 22.5247C136.932 22.5247 138.818 24.4255 138.818 26.9949V27.7519H131.749C132.017 28.9701 132.997 29.8016 134.423 29.8016C135.536 29.8016 136.413 29.1928 136.828 28.2719L138.477 29.2222C137.719 30.6186 136.353 31.5686 134.423 31.5686C131.69 31.5686 129.834 29.5786 129.834 27.069ZM131.853 26.074H136.784C136.487 24.9158 135.596 24.292 134.348 24.292C133.145 24.292 132.21 25.0196 131.853 26.074Z\" fill=\"white\"/>\n<path d=\"M46.6989 13.974H43.9021L43.3869 15.4H42.5037L44.8221 9.0244H45.7881L48.0973 15.4H47.2141L46.6989 13.974ZM46.4597 13.2932L45.3005 10.0548L44.1413 13.2932H46.4597Z\" fill=\"white\"/>\n<path d=\"M50.4325 14.6272L51.9965 10.3584H52.8889L50.9109 15.4H49.9357L47.9577 10.3584H48.8593L50.4325 14.6272Z\" fill=\"white\"/>\n<path d=\"M53.4919 12.8608C53.4919 12.3456 53.5962 11.8948 53.8047 11.5084C54.0132 11.1159 54.2984 10.8123 54.6603 10.5976C55.0283 10.3829 55.4362 10.2756 55.8839 10.2756C56.3255 10.2756 56.7088 10.3707 57.0339 10.5608C57.359 10.7509 57.6012 10.9901 57.7607 11.2784V10.3584H58.6071V15.4H57.7607V14.4616C57.5951 14.756 57.3467 15.0013 57.0155 15.1976C56.6904 15.3877 56.3102 15.4828 55.8747 15.4828C55.427 15.4828 55.0222 15.3724 54.6603 15.1516C54.2984 14.9308 54.0132 14.6211 53.8047 14.2224C53.5962 13.8237 53.4919 13.3699 53.4919 12.8608ZM57.7607 12.87C57.7607 12.4897 57.684 12.1585 57.5307 11.8764C57.3774 11.5943 57.1688 11.3796 56.9051 11.2324C56.6475 11.0791 56.3623 11.0024 56.0495 11.0024C55.7367 11.0024 55.4515 11.076 55.1939 11.2232C54.9363 11.3704 54.7308 11.5851 54.5775 11.8672C54.4242 12.1493 54.3475 12.4805 54.3475 12.8608C54.3475 13.2472 54.4242 13.5845 54.5775 13.8728C54.7308 14.1549 54.9363 14.3727 55.1939 14.526C55.4515 14.6732 55.7367 14.7468 56.0495 14.7468C56.3623 14.7468 56.6475 14.6732 56.9051 14.526C57.1688 14.3727 57.3774 14.1549 57.5307 13.8728C57.684 13.5845 57.7607 13.2503 57.7607 12.87Z\" fill=\"white\"/>\n<path d=\"M60.2703 9.5396C60.1108 9.5396 59.9759 9.4844 59.8655 9.374C59.7551 9.2636 59.6999 9.12867 59.6999 8.9692C59.6999 8.80974 59.7551 8.6748 59.8655 8.5644C59.9759 8.454 60.1108 8.3988 60.2703 8.3988C60.4236 8.3988 60.5524 8.454 60.6567 8.5644C60.7671 8.6748 60.8223 8.80974 60.8223 8.9692C60.8223 9.12867 60.7671 9.2636 60.6567 9.374C60.5524 9.4844 60.4236 9.5396 60.2703 9.5396ZM60.6751 10.3584V15.4H59.8379V10.3584H60.6751Z\" fill=\"white\"/>\n<path d=\"M62.7552 8.592V15.4H61.918V8.592H62.7552Z\" fill=\"white\"/>\n<path d=\"M63.8692 12.8608C63.8692 12.3456 63.9735 11.8948 64.182 11.5084C64.3906 11.1159 64.6758 10.8123 65.0376 10.5976C65.4056 10.3829 65.8135 10.2756 66.2612 10.2756C66.7028 10.2756 67.0862 10.3707 67.4112 10.5608C67.7363 10.7509 67.9786 10.9901 68.138 11.2784V10.3584H68.9844V15.4H68.138V14.4616C67.9724 14.756 67.724 15.0013 67.3928 15.1976C67.0678 15.3877 66.6875 15.4828 66.252 15.4828C65.8043 15.4828 65.3995 15.3724 65.0376 15.1516C64.6758 14.9308 64.3906 14.6211 64.182 14.2224C63.9735 13.8237 63.8692 13.3699 63.8692 12.8608ZM68.138 12.87C68.138 12.4897 68.0614 12.1585 67.908 11.8764C67.7547 11.5943 67.5462 11.3796 67.2824 11.2324C67.0248 11.0791 66.7396 11.0024 66.4268 11.0024C66.114 11.0024 65.8288 11.076 65.5712 11.2232C65.3136 11.3704 65.1082 11.5851 64.9548 11.8672C64.8015 12.1493 64.7248 12.4805 64.7248 12.8608C64.7248 13.2472 64.8015 13.5845 64.9548 13.8728C65.1082 14.1549 65.3136 14.3727 65.5712 14.526C65.8288 14.6732 66.114 14.7468 66.4268 14.7468C66.7396 14.7468 67.0248 14.6732 67.2824 14.526C67.5462 14.3727 67.7547 14.1549 67.908 13.8728C68.0614 13.5845 68.138 13.2503 68.138 12.87Z\" fill=\"white\"/>\n<path d=\"M71.3284 11.2968C71.5001 10.9963 71.7516 10.7509 72.0828 10.5608C72.414 10.3707 72.7912 10.2756 73.2144 10.2756C73.6683 10.2756 74.0761 10.3829 74.438 10.5976C74.7999 10.8123 75.0851 11.1159 75.2936 11.5084C75.5021 11.8948 75.6064 12.3456 75.6064 12.8608C75.6064 13.3699 75.5021 13.8237 75.2936 14.2224C75.0851 14.6211 74.7968 14.9308 74.4288 15.1516C74.0669 15.3724 73.6621 15.4828 73.2144 15.4828C72.7789 15.4828 72.3956 15.3877 72.0644 15.1976C71.7393 15.0075 71.494 14.7652 71.3284 14.4708V15.4H70.4912V8.592H71.3284V11.2968ZM74.7508 12.8608C74.7508 12.4805 74.6741 12.1493 74.5208 11.8672C74.3675 11.5851 74.1589 11.3704 73.8952 11.2232C73.6376 11.076 73.3524 11.0024 73.0396 11.0024C72.7329 11.0024 72.4477 11.0791 72.184 11.2324C71.9264 11.3796 71.7179 11.5973 71.5584 11.8856C71.4051 12.1677 71.3284 12.4959 71.3284 12.87C71.3284 13.2503 71.4051 13.5845 71.5584 13.8728C71.7179 14.1549 71.9264 14.3727 72.184 14.526C72.4477 14.6732 72.7329 14.7468 73.0396 14.7468C73.3524 14.7468 73.6376 14.6732 73.8952 14.526C74.1589 14.3727 74.3675 14.1549 74.5208 13.8728C74.6741 13.5845 74.7508 13.2472 74.7508 12.8608Z\" fill=\"white\"/>\n<path d=\"M77.5456 8.592V15.4H76.7084V8.592H77.5456Z\" fill=\"white\"/>\n<path d=\"M83.6645 12.686C83.6645 12.8455 83.6553 13.0141 83.6369 13.192H79.6073C79.6379 13.6888 79.8066 14.0783 80.1133 14.3604C80.4261 14.6364 80.8033 14.7744 81.2449 14.7744C81.6067 14.7744 81.9073 14.6916 82.1465 14.526C82.3918 14.3543 82.5635 14.1273 82.6617 13.8452H83.5633C83.4283 14.3297 83.1585 14.7253 82.7537 15.032C82.3489 15.3325 81.8459 15.4828 81.2449 15.4828C80.7665 15.4828 80.3371 15.3755 79.9569 15.1608C79.5827 14.9461 79.2883 14.6425 79.0737 14.25C78.859 13.8513 78.7517 13.3913 78.7517 12.87C78.7517 12.3487 78.8559 11.8917 79.0645 11.4992C79.273 11.1067 79.5643 10.8061 79.9385 10.5976C80.3187 10.3829 80.7542 10.2756 81.2449 10.2756C81.7233 10.2756 82.1465 10.3799 82.5145 10.5884C82.8825 10.7969 83.1646 11.0852 83.3609 11.4532C83.5633 11.8151 83.6645 12.226 83.6645 12.686ZM82.7997 12.5112C82.7997 12.1923 82.7291 11.9193 82.5881 11.6924C82.447 11.4593 82.2538 11.2845 82.0085 11.168C81.7693 11.0453 81.5025 10.984 81.2081 10.984C80.7849 10.984 80.423 11.1189 80.1225 11.3888C79.8281 11.6587 79.6594 12.0328 79.6165 12.5112H82.7997Z\" fill=\"white\"/>\n<path d=\"M89.6051 15.4828C89.1328 15.4828 88.7035 15.3755 88.3171 15.1608C87.9368 14.9461 87.6363 14.6425 87.4155 14.25C87.2008 13.8513 87.0935 13.3913 87.0935 12.87C87.0935 12.3548 87.2039 11.9009 87.4247 11.5084C87.6516 11.1097 87.9583 10.8061 88.3447 10.5976C88.7311 10.3829 89.1635 10.2756 89.6419 10.2756C90.1203 10.2756 90.5527 10.3829 90.9391 10.5976C91.3255 10.8061 91.6291 11.1067 91.8499 11.4992C92.0768 11.8917 92.1903 12.3487 92.1903 12.87C92.1903 13.3913 92.0737 13.8513 91.8407 14.25C91.6137 14.6425 91.304 14.9461 90.9115 15.1608C90.5189 15.3755 90.0835 15.4828 89.6051 15.4828ZM89.6051 14.7468C89.9056 14.7468 90.1877 14.6763 90.4515 14.5352C90.7152 14.3941 90.9268 14.1825 91.0863 13.9004C91.2519 13.6183 91.3347 13.2748 91.3347 12.87C91.3347 12.4652 91.2549 12.1217 91.0955 11.8396C90.936 11.5575 90.7275 11.3489 90.4699 11.214C90.2123 11.0729 89.9332 11.0024 89.6327 11.0024C89.326 11.0024 89.0439 11.0729 88.7863 11.214C88.5348 11.3489 88.3324 11.5575 88.1791 11.8396C88.0257 12.1217 87.9491 12.4652 87.9491 12.87C87.9491 13.2809 88.0227 13.6275 88.1699 13.9096C88.3232 14.1917 88.5256 14.4033 88.7771 14.5444C89.0285 14.6793 89.3045 14.7468 89.6051 14.7468Z\" fill=\"white\"/>\n<path d=\"M95.9314 10.2664C96.5448 10.2664 97.0416 10.4535 97.4218 10.8276C97.8021 11.1956 97.9922 11.7292 97.9922 12.4284V15.4H97.1642V12.548C97.1642 12.0451 97.0385 11.6617 96.787 11.398C96.5356 11.1281 96.1921 10.9932 95.7566 10.9932C95.315 10.9932 94.9624 11.1312 94.6986 11.4072C94.441 11.6832 94.3122 12.0849 94.3122 12.6124V15.4H93.475V10.3584H94.3122V11.076C94.4778 10.8184 94.7017 10.6191 94.9838 10.478C95.2721 10.3369 95.588 10.2664 95.9314 10.2664Z\" fill=\"white\"/>\n<rect x=\"9\" y=\"7\" width=\"26\" height=\"26\" rx=\"10\" fill=\"url(#paint0_angular_7014_15129)\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.7917 16.5695L25.7382 16.3341C25.7382 14.2733 24.0612 12.5968 21.9999 12.5968C19.9388 12.5968 18.2619 14.2733 18.2619 16.3341L18.2084 16.5695H15.1389L15.9663 24.2826C16.132 25.8515 17.4551 27.0421 19.0328 27.0421H24.9672C26.5448 27.0421 27.868 25.8515 28.0337 24.2828L28.8611 16.5695H25.7917ZM19.8334 16.5695L19.8936 16.3341C19.8936 15.1729 20.8386 14.2281 21.9999 14.2281C23.1616 14.2281 24.1065 15.1729 24.1065 16.3341L24.1667 16.5695H19.8334Z\" fill=\"white\"/>\n<defs>\n<radialGradient id=\"paint0_angular_7014_15129\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(22 20) rotate(88.8309) scale(13.0027)\">\n<stop offset=\"0.000415415\" stop-color=\"#F4605E\"/>\n<stop offset=\"0.0642377\" stop-color=\"#E94B80\"/>\n<stop offset=\"0.128396\" stop-color=\"#DE33A4\"/>\n<stop offset=\"0.186654\" stop-color=\"#D41AC8\"/>\n<stop offset=\"0.250949\" stop-color=\"#CB06E5\"/>\n<stop offset=\"0.281719\" stop-color=\"#C902EC\"/>\n<stop offset=\"0.316858\" stop-color=\"#CB04E5\"/>\n<stop offset=\"0.371347\" stop-color=\"#D108D3\"/>\n<stop offset=\"0.43351\" stop-color=\"#D80DBA\"/>\n<stop offset=\"0.504024\" stop-color=\"#E1139E\"/>\n<stop offset=\"0.59576\" stop-color=\"#EC1E7B\"/>\n<stop offset=\"0.673288\" stop-color=\"#F22A65\"/>\n<stop offset=\"0.713795\" stop-color=\"#F5355B\"/>\n<stop offset=\"0.754495\" stop-color=\"#F74452\"/>\n<stop offset=\"0.818581\" stop-color=\"#F75651\"/>\n<stop offset=\"0.878478\" stop-color=\"#F76051\"/>\n<stop offset=\"0.938046\" stop-color=\"#F76551\"/>\n</radialGradient>\n</defs>\n</svg>";

var GalaxyStoreOutline = "<svg width=\"147\" height=\"40\" viewBox=\"0 0 147 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"146\" height=\"39\" rx=\"5.5\" fill=\"white\" stroke=\"black\"/>\n<path d=\"M64.7516 20.3987H66.7715V31.3885H64.7516V20.3987Z\" fill=\"black\"/>\n<path d=\"M42.5 25.9699C42.5 22.8811 44.8314 20.4009 48.039 20.4009C50.2816 20.4009 52.0489 21.5444 52.9695 23.1779L51.1875 24.2473C50.5193 23.0146 49.4799 22.3611 48.054 22.3611C46.0343 22.3611 44.5047 23.9946 44.5047 25.9699C44.5047 27.9745 46.0196 29.5786 48.1281 29.5786C49.7469 29.5786 50.8757 28.6578 51.2616 27.2322H47.8017V25.3017H53.4298V26.1037C53.4298 29.0289 51.3657 31.5392 48.1281 31.5392C44.7423 31.5392 42.5 28.9695 42.5 25.9699Z\" fill=\"black\"/>\n<path d=\"M54.3525 27.0543C54.3525 24.1732 56.4613 22.525 58.6592 22.525C59.8027 22.525 60.8274 22.9999 61.4512 23.7426V22.7032H63.4558V31.3907H61.4512V30.2616C60.8124 31.0636 59.773 31.5689 58.6295 31.5689C56.5354 31.5689 54.3525 29.8904 54.3525 27.0543ZM61.555 27.0246C61.555 25.5543 60.4412 24.3514 58.9562 24.3514C57.4713 24.3514 56.3278 25.5249 56.3278 27.0246C56.3278 28.539 57.4713 29.7272 58.9562 29.7272C60.4412 29.7272 61.555 28.5243 61.555 27.0246Z\" fill=\"black\"/>\n<path d=\"M67.7938 27.0543C67.7938 24.1732 69.9026 22.525 72.1005 22.525C73.244 22.525 74.2686 22.9999 74.8925 23.7426V22.7032H76.8971V31.3907H74.8925V30.2616C74.2539 31.0636 73.2146 31.5689 72.0707 31.5689C69.977 31.5689 67.7938 29.8904 67.7938 27.0543ZM74.9966 27.0246C74.9966 25.5543 73.8828 24.3514 72.3981 24.3514C70.9128 24.3514 69.7693 25.5249 69.7693 27.0246C69.7693 28.539 70.9128 29.7272 72.3981 29.7272C73.8825 29.7272 74.9966 28.5243 74.9966 27.0246Z\" fill=\"black\"/>\n<path d=\"M80.8048 26.9652L77.6566 22.7032H80.1072L82.0818 25.4652L84.0424 22.7032H86.4182L83.2994 26.9949L86.6261 31.3907H84.1759L82.0524 28.4949L79.988 31.3907H77.5375L80.8048 26.9652Z\" fill=\"black\"/>\n<path d=\"M90.3846 30.9598L86.8206 22.7029H88.9588L91.3796 28.554L93.6663 22.7029H95.7757L90.5926 35.4H88.5582L90.3846 30.9598Z\" fill=\"black\"/>\n<path d=\"M99.8907 29.5936L101.732 28.1384C102.282 29.074 103.128 29.6083 104.108 29.6083C105.178 29.6083 105.757 28.911 105.757 28.1531C105.757 27.2325 104.658 26.9505 103.499 26.594C102.044 26.1334 100.426 25.5693 100.426 23.5049C100.426 21.7676 101.94 20.4012 104.019 20.4012C105.772 20.4012 106.781 21.0697 107.658 21.9756L105.994 23.2376C105.534 22.5547 104.895 22.1982 104.034 22.1982C103.054 22.1982 102.519 22.7329 102.519 23.4305C102.519 24.292 103.559 24.5743 104.732 24.9605C106.203 25.4355 107.866 26.089 107.866 28.1681C107.866 29.8757 106.499 31.5395 104.123 31.5395C102.163 31.5392 100.871 30.7071 99.8907 29.5936Z\" fill=\"black\"/>\n<path d=\"M108.03 22.7029H109.515V21.3812L111.535 20V22.7029H113.302V24.4999H111.535V27.7519C111.535 29.2669 111.743 29.5045 113.302 29.5045V31.3904H113.02C110.332 31.3904 109.515 30.5292 109.515 27.7672V24.4999H108.03L108.03 22.7029Z\" fill=\"black\"/>\n<path d=\"M113.838 27.0543C113.838 24.5296 115.827 22.5247 118.337 22.5247C120.832 22.5247 122.837 24.5296 122.837 27.0543C122.837 29.5639 120.832 31.5689 118.337 31.5689C115.827 31.5689 113.838 29.5639 113.838 27.0543ZM120.862 27.0543C120.862 25.599 119.747 24.4108 118.337 24.4108C116.896 24.4108 115.812 25.599 115.812 27.0543C115.812 28.4949 116.896 29.6828 118.337 29.6828C119.747 29.6828 120.862 28.4949 120.862 27.0543Z\" fill=\"black\"/>\n<path d=\"M125.853 22.7029V23.9949C126.254 23.1335 126.981 22.7029 128.08 22.7029C128.704 22.7029 129.223 22.8514 129.61 23.0741L128.852 24.9749C128.555 24.782 128.214 24.6334 127.649 24.6334C126.491 24.6334 125.867 25.2573 125.867 26.7569V31.3904H123.862V22.7029H125.853Z\" fill=\"black\"/>\n<path d=\"M129.834 27.069C129.834 24.5296 131.808 22.5247 134.348 22.5247C136.932 22.5247 138.818 24.4255 138.818 26.9949V27.7519H131.749C132.017 28.9701 132.997 29.8016 134.423 29.8016C135.536 29.8016 136.413 29.1928 136.828 28.2719L138.477 29.2222C137.719 30.6186 136.353 31.5686 134.423 31.5686C131.69 31.5686 129.834 29.5786 129.834 27.069ZM131.853 26.074H136.784C136.487 24.9158 135.596 24.292 134.348 24.292C133.145 24.292 132.21 25.0196 131.853 26.074Z\" fill=\"black\"/>\n<path d=\"M46.6989 13.974H43.9021L43.3869 15.4H42.5037L44.8221 9.0244H45.7881L48.0973 15.4H47.2141L46.6989 13.974ZM46.4597 13.2932L45.3005 10.0548L44.1413 13.2932H46.4597Z\" fill=\"black\"/>\n<path d=\"M50.4325 14.6272L51.9965 10.3584H52.8889L50.9109 15.4H49.9357L47.9577 10.3584H48.8593L50.4325 14.6272Z\" fill=\"black\"/>\n<path d=\"M53.4919 12.8608C53.4919 12.3456 53.5962 11.8948 53.8047 11.5084C54.0132 11.1159 54.2984 10.8123 54.6603 10.5976C55.0283 10.3829 55.4362 10.2756 55.8839 10.2756C56.3255 10.2756 56.7088 10.3707 57.0339 10.5608C57.359 10.7509 57.6012 10.9901 57.7607 11.2784V10.3584H58.6071V15.4H57.7607V14.4616C57.5951 14.756 57.3467 15.0013 57.0155 15.1976C56.6904 15.3877 56.3102 15.4828 55.8747 15.4828C55.427 15.4828 55.0222 15.3724 54.6603 15.1516C54.2984 14.9308 54.0132 14.6211 53.8047 14.2224C53.5962 13.8237 53.4919 13.3699 53.4919 12.8608ZM57.7607 12.87C57.7607 12.4897 57.684 12.1585 57.5307 11.8764C57.3774 11.5943 57.1688 11.3796 56.9051 11.2324C56.6475 11.0791 56.3623 11.0024 56.0495 11.0024C55.7367 11.0024 55.4515 11.076 55.1939 11.2232C54.9363 11.3704 54.7308 11.5851 54.5775 11.8672C54.4242 12.1493 54.3475 12.4805 54.3475 12.8608C54.3475 13.2472 54.4242 13.5845 54.5775 13.8728C54.7308 14.1549 54.9363 14.3727 55.1939 14.526C55.4515 14.6732 55.7367 14.7468 56.0495 14.7468C56.3623 14.7468 56.6475 14.6732 56.9051 14.526C57.1688 14.3727 57.3774 14.1549 57.5307 13.8728C57.684 13.5845 57.7607 13.2503 57.7607 12.87Z\" fill=\"black\"/>\n<path d=\"M60.2703 9.5396C60.1108 9.5396 59.9759 9.4844 59.8655 9.374C59.7551 9.2636 59.6999 9.12867 59.6999 8.9692C59.6999 8.80974 59.7551 8.6748 59.8655 8.5644C59.9759 8.454 60.1108 8.3988 60.2703 8.3988C60.4236 8.3988 60.5524 8.454 60.6567 8.5644C60.7671 8.6748 60.8223 8.80974 60.8223 8.9692C60.8223 9.12867 60.7671 9.2636 60.6567 9.374C60.5524 9.4844 60.4236 9.5396 60.2703 9.5396ZM60.6751 10.3584V15.4H59.8379V10.3584H60.6751Z\" fill=\"black\"/>\n<path d=\"M62.7552 8.592V15.4H61.918V8.592H62.7552Z\" fill=\"black\"/>\n<path d=\"M63.8692 12.8608C63.8692 12.3456 63.9735 11.8948 64.182 11.5084C64.3906 11.1159 64.6758 10.8123 65.0376 10.5976C65.4056 10.3829 65.8135 10.2756 66.2612 10.2756C66.7028 10.2756 67.0862 10.3707 67.4112 10.5608C67.7363 10.7509 67.9786 10.9901 68.138 11.2784V10.3584H68.9844V15.4H68.138V14.4616C67.9724 14.756 67.724 15.0013 67.3928 15.1976C67.0678 15.3877 66.6875 15.4828 66.252 15.4828C65.8043 15.4828 65.3995 15.3724 65.0376 15.1516C64.6758 14.9308 64.3906 14.6211 64.182 14.2224C63.9735 13.8237 63.8692 13.3699 63.8692 12.8608ZM68.138 12.87C68.138 12.4897 68.0614 12.1585 67.908 11.8764C67.7547 11.5943 67.5462 11.3796 67.2824 11.2324C67.0248 11.0791 66.7396 11.0024 66.4268 11.0024C66.114 11.0024 65.8288 11.076 65.5712 11.2232C65.3136 11.3704 65.1082 11.5851 64.9548 11.8672C64.8015 12.1493 64.7248 12.4805 64.7248 12.8608C64.7248 13.2472 64.8015 13.5845 64.9548 13.8728C65.1082 14.1549 65.3136 14.3727 65.5712 14.526C65.8288 14.6732 66.114 14.7468 66.4268 14.7468C66.7396 14.7468 67.0248 14.6732 67.2824 14.526C67.5462 14.3727 67.7547 14.1549 67.908 13.8728C68.0614 13.5845 68.138 13.2503 68.138 12.87Z\" fill=\"black\"/>\n<path d=\"M71.3284 11.2968C71.5001 10.9963 71.7516 10.7509 72.0828 10.5608C72.414 10.3707 72.7912 10.2756 73.2144 10.2756C73.6683 10.2756 74.0761 10.3829 74.438 10.5976C74.7999 10.8123 75.0851 11.1159 75.2936 11.5084C75.5021 11.8948 75.6064 12.3456 75.6064 12.8608C75.6064 13.3699 75.5021 13.8237 75.2936 14.2224C75.0851 14.6211 74.7968 14.9308 74.4288 15.1516C74.0669 15.3724 73.6621 15.4828 73.2144 15.4828C72.7789 15.4828 72.3956 15.3877 72.0644 15.1976C71.7393 15.0075 71.494 14.7652 71.3284 14.4708V15.4H70.4912V8.592H71.3284V11.2968ZM74.7508 12.8608C74.7508 12.4805 74.6741 12.1493 74.5208 11.8672C74.3675 11.5851 74.1589 11.3704 73.8952 11.2232C73.6376 11.076 73.3524 11.0024 73.0396 11.0024C72.7329 11.0024 72.4477 11.0791 72.184 11.2324C71.9264 11.3796 71.7179 11.5973 71.5584 11.8856C71.4051 12.1677 71.3284 12.4959 71.3284 12.87C71.3284 13.2503 71.4051 13.5845 71.5584 13.8728C71.7179 14.1549 71.9264 14.3727 72.184 14.526C72.4477 14.6732 72.7329 14.7468 73.0396 14.7468C73.3524 14.7468 73.6376 14.6732 73.8952 14.526C74.1589 14.3727 74.3675 14.1549 74.5208 13.8728C74.6741 13.5845 74.7508 13.2472 74.7508 12.8608Z\" fill=\"black\"/>\n<path d=\"M77.5456 8.592V15.4H76.7084V8.592H77.5456Z\" fill=\"black\"/>\n<path d=\"M83.6645 12.686C83.6645 12.8455 83.6553 13.0141 83.6369 13.192H79.6073C79.6379 13.6888 79.8066 14.0783 80.1133 14.3604C80.4261 14.6364 80.8033 14.7744 81.2449 14.7744C81.6067 14.7744 81.9073 14.6916 82.1465 14.526C82.3918 14.3543 82.5635 14.1273 82.6617 13.8452H83.5633C83.4283 14.3297 83.1585 14.7253 82.7537 15.032C82.3489 15.3325 81.8459 15.4828 81.2449 15.4828C80.7665 15.4828 80.3371 15.3755 79.9569 15.1608C79.5827 14.9461 79.2883 14.6425 79.0737 14.25C78.859 13.8513 78.7517 13.3913 78.7517 12.87C78.7517 12.3487 78.8559 11.8917 79.0645 11.4992C79.273 11.1067 79.5643 10.8061 79.9385 10.5976C80.3187 10.3829 80.7542 10.2756 81.2449 10.2756C81.7233 10.2756 82.1465 10.3799 82.5145 10.5884C82.8825 10.7969 83.1646 11.0852 83.3609 11.4532C83.5633 11.8151 83.6645 12.226 83.6645 12.686ZM82.7997 12.5112C82.7997 12.1923 82.7291 11.9193 82.5881 11.6924C82.447 11.4593 82.2538 11.2845 82.0085 11.168C81.7693 11.0453 81.5025 10.984 81.2081 10.984C80.7849 10.984 80.423 11.1189 80.1225 11.3888C79.8281 11.6587 79.6594 12.0328 79.6165 12.5112H82.7997Z\" fill=\"black\"/>\n<path d=\"M89.6051 15.4828C89.1328 15.4828 88.7035 15.3755 88.3171 15.1608C87.9368 14.9461 87.6363 14.6425 87.4155 14.25C87.2008 13.8513 87.0935 13.3913 87.0935 12.87C87.0935 12.3548 87.2039 11.9009 87.4247 11.5084C87.6516 11.1097 87.9583 10.8061 88.3447 10.5976C88.7311 10.3829 89.1635 10.2756 89.6419 10.2756C90.1203 10.2756 90.5527 10.3829 90.9391 10.5976C91.3255 10.8061 91.6291 11.1067 91.8499 11.4992C92.0768 11.8917 92.1903 12.3487 92.1903 12.87C92.1903 13.3913 92.0737 13.8513 91.8407 14.25C91.6137 14.6425 91.304 14.9461 90.9115 15.1608C90.5189 15.3755 90.0835 15.4828 89.6051 15.4828ZM89.6051 14.7468C89.9056 14.7468 90.1877 14.6763 90.4515 14.5352C90.7152 14.3941 90.9268 14.1825 91.0863 13.9004C91.2519 13.6183 91.3347 13.2748 91.3347 12.87C91.3347 12.4652 91.2549 12.1217 91.0955 11.8396C90.936 11.5575 90.7275 11.3489 90.4699 11.214C90.2123 11.0729 89.9332 11.0024 89.6327 11.0024C89.326 11.0024 89.0439 11.0729 88.7863 11.214C88.5348 11.3489 88.3324 11.5575 88.1791 11.8396C88.0257 12.1217 87.9491 12.4652 87.9491 12.87C87.9491 13.2809 88.0227 13.6275 88.1699 13.9096C88.3232 14.1917 88.5256 14.4033 88.7771 14.5444C89.0285 14.6793 89.3045 14.7468 89.6051 14.7468Z\" fill=\"black\"/>\n<path d=\"M95.9314 10.2664C96.5448 10.2664 97.0416 10.4535 97.4218 10.8276C97.8021 11.1956 97.9922 11.7292 97.9922 12.4284V15.4H97.1642V12.548C97.1642 12.0451 97.0385 11.6617 96.787 11.398C96.5356 11.1281 96.1921 10.9932 95.7566 10.9932C95.315 10.9932 94.9624 11.1312 94.6986 11.4072C94.441 11.6832 94.3122 12.0849 94.3122 12.6124V15.4H93.475V10.3584H94.3122V11.076C94.4778 10.8184 94.7017 10.6191 94.9838 10.478C95.2721 10.3369 95.588 10.2664 95.9314 10.2664Z\" fill=\"black\"/>\n<rect x=\"9\" y=\"7\" width=\"26\" height=\"26\" rx=\"10\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.7917 16.5695L25.7382 16.3341C25.7382 14.2733 24.0612 12.5968 21.9999 12.5968C19.9388 12.5968 18.2619 14.2733 18.2619 16.3341L18.2084 16.5695H15.1389L15.9663 24.2826C16.132 25.8515 17.4551 27.0421 19.0328 27.0421H24.9672C26.5448 27.0421 27.868 25.8515 28.0337 24.2828L28.8611 16.5695H25.7917ZM19.8334 16.5695L19.8936 16.3341C19.8936 15.1729 20.8386 14.2281 21.9999 14.2281C23.1616 14.2281 24.1065 15.1729 24.1065 16.3341L24.1667 16.5695H19.8334Z\" fill=\"white\"/>\n</svg>";

var GooglePlayBlack = "<svg width=\"135\" height=\"40\" viewBox=\"0 0 135 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"134\" height=\"39\" rx=\"5.5\" fill=\"black\" stroke=\"#A6A6A6\"/>\n<path d=\"M68.136 21.7511C65.784 21.7511 63.867 23.5401 63.867 26.0041C63.867 28.4531 65.784 30.2571 68.136 30.2571C70.489 30.2571 72.406 28.4531 72.406 26.0041C72.405 23.5401 70.488 21.7511 68.136 21.7511ZM68.136 28.5831C66.847 28.5831 65.736 27.5201 65.736 26.0051C65.736 24.4741 66.848 23.4271 68.136 23.4271C69.425 23.4271 70.536 24.4741 70.536 26.0051C70.536 27.5191 69.425 28.5831 68.136 28.5831ZM58.822 21.7511C56.47 21.7511 54.553 23.5401 54.553 26.0041C54.553 28.4531 56.47 30.2571 58.822 30.2571C61.175 30.2571 63.092 28.4531 63.092 26.0041C63.092 23.5401 61.175 21.7511 58.822 21.7511ZM58.822 28.5831C57.533 28.5831 56.422 27.5201 56.422 26.0051C56.422 24.4741 57.534 23.4271 58.822 23.4271C60.111 23.4271 61.222 24.4741 61.222 26.0051C61.223 27.5191 60.111 28.5831 58.822 28.5831ZM47.744 23.0571V24.8611H52.062C51.933 25.8761 51.595 26.6171 51.079 27.1321C50.451 27.7601 49.468 28.4531 47.744 28.4531C45.086 28.4531 43.008 26.3101 43.008 23.6521C43.008 20.9941 45.086 18.8511 47.744 18.8511C49.178 18.8511 50.225 19.4151 50.998 20.1401L52.271 18.8671C51.191 17.8361 49.758 17.0471 47.744 17.0471C44.103 17.0471 41.042 20.0111 41.042 23.6521C41.042 27.2931 44.103 30.2571 47.744 30.2571C49.709 30.2571 51.192 29.6121 52.351 28.4041C53.543 27.2121 53.914 25.5361 53.914 24.1831C53.914 23.7651 53.882 23.3781 53.817 23.0561H47.744V23.0571ZM93.052 24.4581C92.698 23.5081 91.618 21.7511 89.411 21.7511C87.22 21.7511 85.399 23.4751 85.399 26.0041C85.399 28.3881 87.204 30.2571 89.62 30.2571C91.569 30.2571 92.697 29.0651 93.165 28.3721L91.715 27.4051C91.232 28.1141 90.571 28.5811 89.62 28.5811C88.67 28.5811 87.993 28.1461 87.558 27.2921L93.245 24.9401L93.052 24.4581ZM87.252 25.8761C87.204 24.2321 88.525 23.3951 89.476 23.3951C90.217 23.3951 90.845 23.7661 91.055 24.2971L87.252 25.8761ZM82.629 30.0001H84.497V17.4991H82.629V30.0001ZM79.567 22.7021H79.503C79.084 22.2021 78.278 21.7511 77.264 21.7511C75.137 21.7511 73.188 23.6201 73.188 26.0211C73.188 28.4051 75.137 30.2581 77.264 30.2581C78.279 30.2581 79.084 29.8071 79.503 29.2921H79.567V29.9041C79.567 31.5311 78.697 32.4011 77.296 32.4011C76.152 32.4011 75.443 31.5801 75.153 30.8871L73.526 31.5641C73.993 32.6911 75.233 34.0771 77.296 34.0771C79.487 34.0771 81.34 32.7881 81.34 29.6461V22.0101H79.568V22.7021H79.567ZM77.425 28.5831C76.136 28.5831 75.057 27.5031 75.057 26.0211C75.057 24.5221 76.136 23.4271 77.425 23.4271C78.697 23.4271 79.696 24.5221 79.696 26.0211C79.696 27.5031 78.697 28.5831 77.425 28.5831ZM101.806 17.4991H97.335V30.0001H99.2V25.2641H101.805C103.873 25.2641 105.907 23.7671 105.907 21.3821C105.907 18.9971 103.874 17.4991 101.806 17.4991ZM101.854 23.5241H99.2V19.2391H101.854C103.249 19.2391 104.041 20.3941 104.041 21.3821C104.041 22.3501 103.249 23.5241 101.854 23.5241ZM113.386 21.7291C112.035 21.7291 110.636 22.3241 110.057 23.6431L111.713 24.3341C112.067 23.6431 112.727 23.4171 113.418 23.4171C114.383 23.4171 115.364 23.9961 115.38 25.0251V25.1541C115.042 24.9611 114.318 24.6721 113.434 24.6721C111.649 24.6721 109.831 25.6531 109.831 27.4861C109.831 29.1591 111.295 30.2361 112.935 30.2361C114.189 30.2361 114.881 29.6731 115.315 29.0131H115.379V29.9781H117.181V25.1851C117.182 22.9671 115.524 21.7291 113.386 21.7291ZM113.16 28.5801C112.55 28.5801 111.697 28.2741 111.697 27.5181C111.697 26.5531 112.759 26.1831 113.676 26.1831C114.495 26.1831 114.882 26.3601 115.38 26.6011C115.235 27.7601 114.238 28.5801 113.16 28.5801ZM123.743 22.0021L121.604 27.4221H121.54L119.32 22.0021H117.31L120.639 29.5771L118.741 33.7911H120.687L125.818 22.0021H123.743ZM106.937 30.0001H108.802V17.4991H106.937V30.0001Z\" fill=\"white\"/>\n<path d=\"M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z\" fill=\"white\"/>\n<path d=\"M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z\" fill=\"white\"/>\n<path d=\"M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z\" fill=\"white\"/>\n<path d=\"M59.938 13V7H60.709V13H59.938Z\" fill=\"white\"/>\n<path d=\"M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z\" fill=\"white\"/>\n<path d=\"M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z\" fill=\"white\"/>\n<path d=\"M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z\" fill=\"white\"/>\n<path d=\"M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M59.938 13V7H60.709V13H59.938Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z\" stroke=\"white\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<g filter=\"url(#filter0_ii_7014_15115)\">\n<path d=\"M10.4361 7.53803C10.1451 7.84603 9.97314 8.32403 9.97314 8.94303V31.059C9.97314 31.679 10.1451 32.156 10.4361 32.464L10.5101 32.536L22.8991 20.147V20.001V19.855L10.5101 7.46503L10.4361 7.53803Z\" fill=\"url(#paint0_linear_7014_15115)\"/>\n<path d=\"M27.0282 24.278L22.8992 20.147V20.001V19.855L27.0292 15.725L27.1222 15.778L32.0152 18.558C33.4122 19.352 33.4122 20.651 32.0152 21.446L27.1222 24.226L27.0282 24.278Z\" fill=\"url(#paint1_linear_7014_15115)\"/>\n<g filter=\"url(#filter1_i_7014_15115)\">\n<path d=\"M27.122 24.225L22.898 20.001L10.436 32.464C10.896 32.952 11.657 33.012 12.514 32.526L27.122 24.225Z\" fill=\"url(#paint2_linear_7014_15115)\"/>\n</g>\n<path d=\"M27.122 15.777L12.514 7.47701C11.657 6.99001 10.896 7.05101 10.436 7.53901L22.899 20.002L27.122 15.777Z\" fill=\"url(#paint3_linear_7014_15115)\"/>\n</g>\n<defs>\n<filter id=\"filter0_ii_7014_15115\" x=\"9.97314\" y=\"7.14093\" width=\"23.0898\" height=\"25.7207\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"-0.15\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n<feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow_7014_15115\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"0.15\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0\"/>\n<feBlend mode=\"normal\" in2=\"effect1_innerShadow_7014_15115\" result=\"effect2_innerShadow_7014_15115\"/>\n</filter>\n<filter id=\"filter1_i_7014_15115\" x=\"10.436\" y=\"20.001\" width=\"16.686\" height=\"12.8607\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"-0.15\"/>\n<feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0\"/>\n<feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow_7014_15115\"/>\n</filter>\n<linearGradient id=\"paint0_linear_7014_15115\" x1=\"21.8009\" y1=\"8.70903\" x2=\"5.01895\" y2=\"25.491\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#00A0FF\"/>\n<stop offset=\"0.0066\" stop-color=\"#00A1FF\"/>\n<stop offset=\"0.2601\" stop-color=\"#00BEFF\"/>\n<stop offset=\"0.5122\" stop-color=\"#00D2FF\"/>\n<stop offset=\"0.7604\" stop-color=\"#00DFFF\"/>\n<stop offset=\"1\" stop-color=\"#00E3FF\"/>\n</linearGradient>\n<linearGradient id=\"paint1_linear_7014_15115\" x1=\"33.8337\" y1=\"20.001\" x2=\"9.63777\" y2=\"20.001\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FFE000\"/>\n<stop offset=\"0.4087\" stop-color=\"#FFBD00\"/>\n<stop offset=\"0.7754\" stop-color=\"#FFA500\"/>\n<stop offset=\"1\" stop-color=\"#FF9C00\"/>\n</linearGradient>\n<linearGradient id=\"paint2_linear_7014_15115\" x1=\"24.8281\" y1=\"22.2949\" x2=\"2.06964\" y2=\"45.0534\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FF3A44\"/>\n<stop offset=\"1\" stop-color=\"#C31162\"/>\n</linearGradient>\n<linearGradient id=\"paint3_linear_7014_15115\" x1=\"7.29743\" y1=\"0.176806\" x2=\"17.4597\" y2=\"10.3391\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#32A071\"/>\n<stop offset=\"0.0685\" stop-color=\"#2DA771\"/>\n<stop offset=\"0.4762\" stop-color=\"#15CF74\"/>\n<stop offset=\"0.8009\" stop-color=\"#06E775\"/>\n<stop offset=\"1\" stop-color=\"#00F076\"/>\n</linearGradient>\n</defs>\n</svg>";

var GooglePlayOutline = "<svg width=\"135\" height=\"40\" viewBox=\"0 0 135 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"134\" height=\"39\" rx=\"5.5\" stroke=\"black\"/>\n<path d=\"M68.136 21.7511C65.784 21.7511 63.867 23.5401 63.867 26.0041C63.867 28.4531 65.784 30.2571 68.136 30.2571C70.489 30.2571 72.406 28.4531 72.406 26.0041C72.405 23.5401 70.488 21.7511 68.136 21.7511ZM68.136 28.5831C66.847 28.5831 65.736 27.5201 65.736 26.0051C65.736 24.4741 66.848 23.4271 68.136 23.4271C69.425 23.4271 70.536 24.4741 70.536 26.0051C70.536 27.5191 69.425 28.5831 68.136 28.5831ZM58.822 21.7511C56.47 21.7511 54.553 23.5401 54.553 26.0041C54.553 28.4531 56.47 30.2571 58.822 30.2571C61.175 30.2571 63.092 28.4531 63.092 26.0041C63.092 23.5401 61.175 21.7511 58.822 21.7511ZM58.822 28.5831C57.533 28.5831 56.422 27.5201 56.422 26.0051C56.422 24.4741 57.534 23.4271 58.822 23.4271C60.111 23.4271 61.222 24.4741 61.222 26.0051C61.223 27.5191 60.111 28.5831 58.822 28.5831ZM47.744 23.0571V24.8611H52.062C51.933 25.8761 51.595 26.6171 51.079 27.1321C50.451 27.7601 49.468 28.4531 47.744 28.4531C45.086 28.4531 43.008 26.3101 43.008 23.6521C43.008 20.9941 45.086 18.8511 47.744 18.8511C49.178 18.8511 50.225 19.4151 50.998 20.1401L52.271 18.8671C51.191 17.8361 49.758 17.0471 47.744 17.0471C44.103 17.0471 41.042 20.0111 41.042 23.6521C41.042 27.2931 44.103 30.2571 47.744 30.2571C49.709 30.2571 51.192 29.6121 52.351 28.4041C53.543 27.2121 53.914 25.5361 53.914 24.1831C53.914 23.7651 53.882 23.3781 53.817 23.0561H47.744V23.0571ZM93.052 24.4581C92.698 23.5081 91.618 21.7511 89.411 21.7511C87.22 21.7511 85.399 23.4751 85.399 26.0041C85.399 28.3881 87.204 30.2571 89.62 30.2571C91.569 30.2571 92.697 29.0651 93.165 28.3721L91.715 27.4051C91.232 28.1141 90.571 28.5811 89.62 28.5811C88.67 28.5811 87.993 28.1461 87.558 27.2921L93.245 24.9401L93.052 24.4581ZM87.252 25.8761C87.204 24.2321 88.525 23.3951 89.476 23.3951C90.217 23.3951 90.845 23.7661 91.055 24.2971L87.252 25.8761ZM82.629 30.0001H84.497V17.4991H82.629V30.0001ZM79.567 22.7021H79.503C79.084 22.2021 78.278 21.7511 77.264 21.7511C75.137 21.7511 73.188 23.6201 73.188 26.0211C73.188 28.4051 75.137 30.2581 77.264 30.2581C78.279 30.2581 79.084 29.8071 79.503 29.2921H79.567V29.9041C79.567 31.5311 78.697 32.4011 77.296 32.4011C76.152 32.4011 75.443 31.5801 75.153 30.8871L73.526 31.5641C73.993 32.6911 75.233 34.0771 77.296 34.0771C79.487 34.0771 81.34 32.7881 81.34 29.6461V22.0101H79.568V22.7021H79.567ZM77.425 28.5831C76.136 28.5831 75.057 27.5031 75.057 26.0211C75.057 24.5221 76.136 23.4271 77.425 23.4271C78.697 23.4271 79.696 24.5221 79.696 26.0211C79.696 27.5031 78.697 28.5831 77.425 28.5831ZM101.806 17.4991H97.335V30.0001H99.2V25.2641H101.805C103.873 25.2641 105.907 23.7671 105.907 21.3821C105.907 18.9971 103.874 17.4991 101.806 17.4991ZM101.854 23.5241H99.2V19.2391H101.854C103.249 19.2391 104.041 20.3941 104.041 21.3821C104.041 22.3501 103.249 23.5241 101.854 23.5241ZM113.386 21.7291C112.035 21.7291 110.636 22.3241 110.057 23.6431L111.713 24.3341C112.067 23.6431 112.727 23.4171 113.418 23.4171C114.383 23.4171 115.364 23.9961 115.38 25.0251V25.1541C115.042 24.9611 114.318 24.6721 113.434 24.6721C111.649 24.6721 109.831 25.6531 109.831 27.4861C109.831 29.1591 111.295 30.2361 112.935 30.2361C114.189 30.2361 114.881 29.6731 115.315 29.0131H115.379V29.9781H117.181V25.1851C117.182 22.9671 115.524 21.7291 113.386 21.7291ZM113.16 28.5801C112.55 28.5801 111.697 28.2741 111.697 27.5181C111.697 26.5531 112.759 26.1831 113.676 26.1831C114.495 26.1831 114.882 26.3601 115.38 26.6011C115.235 27.7601 114.238 28.5801 113.16 28.5801ZM123.743 22.0021L121.604 27.4221H121.54L119.32 22.0021H117.31L120.639 29.5771L118.741 33.7911H120.687L125.818 22.0021H123.743ZM106.937 30.0001H108.802V17.4991H106.937V30.0001Z\" fill=\"black\"/>\n<path d=\"M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z\" fill=\"black\"/>\n<path d=\"M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z\" fill=\"black\"/>\n<path d=\"M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z\" fill=\"black\"/>\n<path d=\"M59.938 13V7H60.709V13H59.938Z\" fill=\"black\"/>\n<path d=\"M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z\" fill=\"black\"/>\n<path d=\"M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z\" fill=\"black\"/>\n<path d=\"M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z\" fill=\"black\"/>\n<path d=\"M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M59.938 13V7H60.709V13H59.938Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path d=\"M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z\" stroke=\"black\" stroke-width=\"0.2\" stroke-miterlimit=\"10\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1565 7.96648C10.0384 8.23398 9.97314 8.56174 9.97314 8.943V31.059C9.97314 31.4411 10.0385 31.7689 10.1567 32.0363L22.1907 20.0006L10.1565 7.96648ZM10.8517 32.7555C11.2978 32.9464 11.8797 32.8858 12.5141 32.526L26.6712 24.4812L22.8978 20.7077L10.8517 32.7555ZM27.5737 23.9695L32.0151 21.446C33.4121 20.651 33.4121 19.352 32.0151 18.558L27.5717 16.0331L23.6048 20.0006L27.5737 23.9695ZM26.6699 15.5207L12.5141 7.47701C11.8796 7.11643 11.2977 7.05626 10.8516 7.2474L22.8977 19.2935L26.6699 15.5207Z\" fill=\"black\"/>\n</svg>";

var svg_OrkaLogo = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.7096 15.6743C17.463 13.9209 17.463 11.0781 15.7096 9.32469C13.9562 7.57128 11.1134 7.57128 9.35994 9.32469C7.60654 11.0781 7.60654 13.9209 9.35994 15.6743C11.1134 17.4277 13.9562 17.4277 15.7096 15.6743Z\" fill=\"#050505\"/>\n<path d=\"M0 0V40H40V0H0ZM12.5354 20C8.3927 20 5.03499 16.6423 5.03499 12.4996C5.03499 8.35692 8.3927 4.99921 12.5354 4.99921C16.6781 4.99921 20.0358 8.35692 20.0358 12.4996C20.0358 16.6423 16.677 20 12.5354 20Z\" fill=\"#050505\"/>\n</svg>";

var svg_OrkaOneLogo = "<svg width=\"147\" height=\"24\" viewBox=\"0 0 147 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M28.1367 23.7029L33.7277 23.7029V14.1714C33.7277 12.08 35.2141 10.6743 37.215 10.6743C37.8781 10.6743 38.8728 10.7886 39.4102 10.9714V6.11431C38.9414 5.98859 38.3583 5.90859 37.8438 5.90859C35.923 5.90859 34.3909 7.02859 33.7506 9.34859H33.5677V6.14859H28.1367V23.7029Z\" fill=\"#1A1A1A\"/>\n<path d=\"M41.6883 23.7029H47.2793V18.4343L48.4112 17.0629L52.5959 23.7029H59.0558L52.573 13.7943L58.8043 6.14859H52.4701L47.5308 12.4343H47.2793V0.29717H41.6883V23.7029Z\" fill=\"#1A1A1A\"/>\n<path d=\"M65.7559 24C68.2026 24 69.8948 23.0514 70.8552 21.2571H70.9924V23.7029H76.2518V11.7714C76.2518 8.05716 72.9475 5.92002 68.477 5.92002C63.755 5.92002 61.0796 8.29716 60.6336 11.4972L65.7902 11.68C66.0303 10.56 66.9564 9.8743 68.4313 9.8743C69.8033 9.8743 70.6723 10.5372 70.6723 11.7143V11.7714C70.6723 12.8457 69.5061 13.0743 66.5105 13.3372C62.9546 13.6343 59.9819 14.9486 59.9819 18.8343C59.9819 22.3086 62.3944 24 65.7559 24ZM67.4823 20.3429C66.1903 20.3429 65.2756 19.7257 65.2756 18.56C65.2756 17.4286 66.1675 16.7429 67.7567 16.5029C68.7972 16.3543 70.0777 16.1257 70.7066 15.7943V17.4629C70.7066 19.1772 69.2659 20.3429 67.4823 20.3429Z\" fill=\"#1A1A1A\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.6713 18.339C17.1536 18.339 19.9765 15.5173 19.9765 12.0366C19.9765 8.55582 17.1536 5.73411 13.6713 5.73411C10.1891 5.73411 7.36613 8.55582 7.36613 12.0366C7.36613 15.5173 10.1891 18.339 13.6713 18.339ZM13.6713 23.7029C20.1172 23.7029 25.3427 18.4797 25.3427 12.0366C25.3427 5.59347 20.1172 0.370307 13.6713 0.370307C7.22543 0.370307 2 5.59347 2 12.0366C2 18.4797 7.22543 23.7029 13.6713 23.7029Z\" fill=\"#1A1A1A\"/>\n<path d=\"M114.688 13.5423C114.699 11.5783 115.844 10.4112 117.584 10.4112C119.324 10.4112 120.357 11.5559 120.346 13.4638V23.3736H125.835V12.3864C125.846 8.50325 123.478 5.91075 119.852 5.91075C117.304 5.91075 115.373 7.20139 114.61 9.30008H114.419V6.13521H109.199V23.3736H114.688V13.5423Z\" fill=\"#1A1A1A\"/>\n<path d=\"M137.294 23.6991C141.818 23.6991 144.793 21.5106 145.421 18.1213L140.381 17.9754C139.954 19.1201 138.832 19.7374 137.395 19.7374C135.284 19.7374 133.982 18.3345 133.982 16.2246V16.0787H145.477V14.7095C145.477 9.03073 142.02 5.91075 137.125 5.91075C131.917 5.91075 128.571 9.47964 128.571 14.8218C128.571 20.3434 131.872 23.6991 137.294 23.6991ZM133.982 12.8914C134.061 11.1743 135.419 9.87245 137.238 9.87245C139.045 9.87245 140.347 11.1294 140.37 12.8914H133.982Z\" fill=\"#1A1A1A\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M94.6063 18.2539C98.1431 18.2539 101.01 15.3874 101.01 11.8514C101.01 8.31542 98.1431 5.44893 94.6063 5.44893C91.0694 5.44893 88.2022 8.31542 88.2022 11.8514C88.2022 15.3874 91.0694 18.2539 94.6063 18.2539ZM94.6063 23.7028C101.153 23.7028 106.461 18.3968 106.461 11.8514C106.461 5.30606 101.153 0 94.6063 0C88.0593 0 82.752 5.30606 82.752 11.8514C82.752 18.3968 88.0593 23.7028 94.6063 23.7028Z\" fill=\"#1A1A1A\"/>\n</svg>";

var svg_lloyd_logo = "<svg width=\"133\" height=\"65\" viewBox=\"0 0 133 65\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.99\" d=\"M43.4009 16.0154L50.3149 16C49.1217 24.1567 47.9273 32.312 46.7315 40.4661L48.1722 40.4333V43.3262L39.2544 43.3899V40.497L40.346 40.4777C40.4058 40.4777 40.5581 40.4777 40.7626 40.4777C40.9931 40.4825 41.2234 40.4611 41.4491 40.414C41.6732 40.3365 41.867 40.19 42.0026 39.9955C42.0698 39.8381 42.1221 39.6748 42.1589 39.5076C42.1859 39.3765 42.1878 39.3147 42.2283 39.0332L42.3074 38.5491C42.3074 38.5125 44.9167 20.8658 45.1347 19.3847L43.4529 19.35L43.4009 16.0154Z\" fill=\"#1779C4\"/>\n<path d=\"M31.2143 19.4564H21.957C22.0175 18.3198 22.0779 17.1845 22.1383 16.0505H31.5576C31.4418 17.182 31.3274 18.3173 31.2143 19.4564Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M18.108 40.4009C18.072 41.3807 18.036 42.361 18 43.342H36.0998C36.3274 40.84 36.5556 38.3373 36.7845 35.834L33.5425 35.8765L32.9929 39.7529L25.562 39.7703L28.4318 19.3504L31.234 19.3639C31.3394 18.2594 31.4461 17.155 31.5541 16.0505H22.1349C22.0745 17.1434 22.0153 18.2363 21.9575 19.3291L23.7298 19.3774C23.6893 19.6782 21.0298 38.7539 21.0298 38.7674C21.0298 38.7809 20.889 39.7761 20.889 39.7761C20.8329 39.88 20.7607 39.9744 20.675 40.0557C20.4355 40.2611 20.126 40.3661 19.8109 40.3489\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M36.1536 43.3418L32.875 39.7623C33.0794 38.3763 33.2845 36.9903 33.4902 35.6042H37.2298C36.8736 38.1847 36.5149 40.7639 36.1536 43.3418Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M68.774 27.2885C71.3872 31.3868 70.124 39.1532 64.9573 42.4029C62.4019 44.0113 57.9738 45.0913 54.8727 42.7732C52.1167 40.7115 51.9508 37.1128 51.893 36.0424C51.6191 30.2894 56.026 24.6367 60.7529 23.7631C62.187 23.4761 63.6728 23.5991 65.0402 24.1179C66.5627 24.7955 67.8586 25.8959 68.774 27.2885ZM65.7152 30.9779C65.6766 29.5758 65.2832 28.8179 64.8782 28.328C64.4482 27.8188 63.8823 27.4423 63.2466 27.2422C61.8252 26.7948 60.5639 27.4216 60.1609 27.6279C58.0973 28.6694 57.4126 30.9066 57.0751 32.0348C56.9382 32.4822 55.2372 38.1677 58.0143 40.0732C59.3643 41.0008 61.0692 40.5514 61.2177 40.5109C65.1231 39.4174 65.775 33.0666 65.7152 30.9779Z\" fill=\"#1779C4\"/>\n<g opacity=\"0.99\">\n<path opacity=\"0.99\" d=\"M78.7732 27.5568L72.4224 27.5915C72.5998 26.5436 72.7759 25.4977 72.9508 24.4537L79.2573 24.4884C79.0979 25.5054 78.9365 26.5282 78.7732 27.5568Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M79.7646 39.6795L75.6239 42.3931C74.947 42.1134 73.8612 41.5329 73.2672 40.395C72.6114 39.1337 72.8949 37.83 73.0415 37.1319C73.5699 34.6247 74.1157 31.4059 74.7772 27.3597L78.8061 27.3925C78.6132 28.5091 78.3972 29.8533 78.16 31.3769C77.3616 36.4838 77.2304 38.1077 78.2256 39.0296C78.6553 39.4062 79.195 39.6341 79.7646 39.6795Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M90.3466 27.5447L83.7258 27.4617C83.8955 26.4589 84.0646 25.456 84.233 24.4531L90.7246 24.5226C90.5986 25.5293 90.4726 26.5366 90.3466 27.5447Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M85.7008 39.0197C84.376 40.7642 82.492 42.0007 80.3643 42.522C78.7964 42.8839 77.1621 42.8394 75.6161 42.3928L78.212 39.0293C78.4631 39.2303 78.7487 39.3838 79.0548 39.4825C80.7288 40.0129 82.8407 38.7111 83.9592 37.1682C84.8599 35.9223 84.9235 34.796 85.1916 34.823C85.4288 34.8443 85.6641 35.6446 85.7008 39.0197Z\" fill=\"#1779C4\"/>\n<path opacity=\"0.99\" d=\"M88.9138 39.5136L84.0923 38.9254C84.5128 37.1183 84.9081 35.2128 85.263 33.2129C85.6487 31.0625 85.9419 28.9989 86.1752 27.0414L90.3487 27.08C90.2021 28.6035 90.0433 30.1426 89.8723 31.697C89.583 34.3469 89.2635 36.9524 88.9138 39.5136Z\" fill=\"#1779C4\"/>\n</g>\n<path opacity=\"0.99\" d=\"M80.4031 51.6005C80.2179 50.7262 80.0321 49.8538 79.8457 48.9834C81.6393 48.507 82.5303 47.6102 82.9314 47.103C83.1937 46.7751 83.8495 45.8725 84.3297 41.9864C84.5225 40.3645 84.6016 39.0125 84.6305 38.0791L88.9641 38.812C88.9641 38.8756 88.9525 38.9663 88.9429 39.0723C88.9429 39.0723 88.9197 39.352 88.8927 39.6316C88.8599 39.9788 88.7211 41.2188 88.6304 41.8514C88.2987 44.1657 88.1309 45.4502 87.4598 46.8311C87.0143 47.7471 86.2737 49.2186 84.6228 50.3276C83.371 51.1554 81.9039 51.5979 80.4031 51.6005Z\" fill=\"#1779C4\"/>\n<path d=\"M77.6934 48.9635L71.1362 50.57L71.5219 45.3628L75.1863 45.3262C75.1573 45.5499 75.1168 45.8642 75.0821 46.2423C74.9761 47.3878 74.924 47.9606 75.0821 48.2576C75.5488 49.1448 77.408 48.9944 77.6934 48.9635Z\" fill=\"#1779C4\"/>\n<path d=\"M81.2825 51.5462C78.3143 52.0066 75.2815 51.8171 72.3937 50.9908C71.9578 50.8622 71.5387 50.724 71.1362 50.5761L74.9008 48.7131C76.3086 48.9968 77.75 49.076 79.1804 48.9484C79.6992 48.9041 80.1447 48.8385 80.4668 48.7826C80.7419 49.7044 81.0138 50.6257 81.2825 51.5462Z\" fill=\"#1779C4\"/>\n<path d=\"M109.818 42.744L105.361 42.6341L108.639 18.3782L113.432 18.4032L109.818 42.744Z\" fill=\"#1D76C2\"/>\n<path d=\"M113.303 19.3291L106.086 19.2828L106.555 16.2491L113.83 16.2163L113.303 19.3291Z\" fill=\"#1D76C2\"/>\n<path d=\"M102.428 36.478C102.453 36.478 102.474 36.1853 102.474 35.8242C102.474 35.4631 102.453 35.1704 102.428 35.1704C102.402 35.1704 102.381 35.4631 102.381 35.8242C102.381 36.1853 102.402 36.478 102.428 36.478Z\" fill=\"white\"/>\n<path d=\"M103.122 43.201C102.827 43.338 98.8425 45.0506 96.0229 43.2705C92.5032 41.0507 92.9371 35.0894 94.2331 31.6237C94.262 31.5446 94.3083 31.4309 94.3681 31.2727C94.4915 30.968 96.6149 25.9691 101.809 24.2758C102.756 23.9609 103.744 23.7842 104.742 23.7512C106.026 23.7242 108.005 23.9441 108.948 24.6287C112.154 26.9604 110.466 39.8009 103.122 43.201ZM107.425 27.0009C106.502 26.7745 105.549 26.6957 104.601 26.7675C103.764 26.816 102.94 27.001 102.162 27.3152C100.522 28.0057 99.6177 29.1975 99.1549 29.8224C98.4572 30.7863 97.9599 31.8803 97.6922 33.0396C97.4246 34.199 97.392 35.4003 97.5966 36.5725C97.8473 38.0016 98.368 38.6939 98.5397 38.9041C99.1532 39.6948 100.035 40.234 101.018 40.42C102.966 40.7363 104.447 39.3362 104.819 38.9851C105.185 38.6377 105.499 38.2388 105.751 37.801\" fill=\"#1D76C2\"/>\n<path d=\"M111.089 43.6486L105.046 43.664C105.223 42.6071 105.399 41.5503 105.575 40.4934L111.486 40.5166C111.355 41.5606 111.222 42.6046 111.089 43.6486Z\" fill=\"#1D76C2\"/>\n</svg>";

var svg_orka_logotype = "<svg width=\"68\" height=\"18\" viewBox=\"0 0 68 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M43.2213 8.90625L50.3401 0.584778H46.5325L40.153 7.53524V0.584778H37.2479V17.2798H40.153V12.0144L40.9131 10.8204H41.2394L46.7772 17.2798H50.5778L43.2213 8.90625Z\" fill=\"#050505\"/>\n<path d=\"M33.9905 5.91954C33.9905 2.97275 31.6025 0.584778 28.6557 0.584778H23.2672H20.3082V17.2798H23.2672V11.2543H27.6787L30.6793 17.2798H33.9922L30.6654 10.8638C32.6143 10.069 33.9905 8.1548 33.9905 5.91954ZM28.5603 8.2676H23.2984V3.57148H28.5603C29.8567 3.57148 30.9083 4.62316 30.9083 5.91954C30.9083 7.21592 29.8567 8.2676 28.5603 8.2676Z\" fill=\"black\"/>\n<path d=\"M61.7021 0.584778H57.5752L51.3918 17.2798H54.6596L55.8727 13.7672H63.2987L64.4701 17.2798H68L61.7021 0.584778ZM56.8203 11.0287L59.4217 3.49859H59.8018L62.3667 11.0287H56.8203Z\" fill=\"black\"/>\n<path d=\"M8.57831 0.421631C3.84054 0.421631 0 4.26218 0 8.99995C0 13.7377 3.84054 17.5783 8.57831 17.5783C13.3161 17.5783 17.1566 13.7377 17.1566 8.99995C17.1584 4.26218 13.3161 0.421631 8.57831 0.421631ZM8.57831 14.6471C5.45972 14.6471 2.93117 12.1185 2.93117 8.99995C2.93117 5.88135 5.45972 3.3528 8.57831 3.3528C11.6969 3.3528 14.2255 5.88135 14.2255 8.99995C14.2255 12.1185 11.6969 14.6471 8.57831 14.6471Z\" fill=\"#050505\"/>\n</svg>";

var svg_orka_two = "<svg width=\"150\" height=\"20\" viewBox=\"0 0 150 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_11599_25956)\">\n<path d=\"M59.1892 19.6808H54.7428L48.2614 12.1479H47.8796L46.9903 13.539V19.6781H43.5907V0.220757H46.9903V8.32023L54.4677 0.220757H58.9221L50.5901 9.91885L59.1892 19.6808ZM35.8863 12.2011L39.7772 19.6808H35.9023L32.3906 12.6559H27.2285V19.6808H23.7568V0.220757H33.5255C34.3453 0.220407 35.1572 0.380937 35.9147 0.693177C36.6722 1.00542 37.3605 1.46324 37.9403 2.04051C38.5201 2.61778 38.9801 3.30317 39.2939 4.05754C39.6077 4.8119 39.7692 5.62045 39.7692 6.43701C39.7699 7.67324 39.4009 8.88167 38.7093 9.90823C38.0178 10.9348 37.035 11.733 35.8863 12.2011ZM36.172 6.43701C36.172 5.71109 35.8825 5.01491 35.3672 4.50161C34.8518 3.98831 34.1529 3.69994 33.4241 3.69994H27.2659V9.17674H33.4241C34.1531 9.17603 34.8521 8.88707 35.3673 8.37335C35.8826 7.85963 36.172 7.16317 36.172 6.43701ZM79.5785 19.6808H75.4499L74.0773 15.5845H65.3874L63.9667 19.6808H60.1425L67.3796 0.220757H72.2079L79.5785 19.6808ZM72.985 12.3926L69.9834 3.61483H69.5401L66.4957 12.3926H72.985ZM20.0795 9.99865C20.08 11.9774 19.4913 13.9119 18.3876 15.5572C17.284 17.2026 15.7152 18.4848 13.8797 19.2418C12.0442 19.9988 10.0245 20.1965 8.07618 19.8098C6.12786 19.4231 4.33846 18.4695 2.93445 17.0696C1.53044 15.6696 0.574914 13.8863 0.188767 11.9453C-0.197379 10.0043 0.00320853 7.99278 0.765167 6.16536C1.52713 4.33793 2.8162 2.77671 4.46926 1.67923C6.12233 0.581751 8.06511 -0.00265293 10.0517 -2.16712e-05C12.7122 0.0027982 15.2628 1.05747 17.1431 2.93228C19.0233 4.80709 20.0795 7.34868 20.0795 9.99865ZM16.6479 9.99865C16.6479 8.69602 16.2599 7.42268 15.5331 6.33978C14.8062 5.25687 13.7732 4.41307 12.5646 3.91519C11.3561 3.41731 10.0265 3.28772 8.74401 3.54282C7.46152 3.79792 6.28384 4.42624 5.36002 5.34826C4.43619 6.27029 3.80776 7.44457 3.55424 8.72249C3.30072 10.0004 3.43352 11.3245 3.93583 12.5272C4.43814 13.7299 5.28736 14.7572 6.37605 15.479C7.46473 16.2007 8.74393 16.5846 10.0517 16.582C11.8026 16.5791 13.4807 15.8842 14.7175 14.6498C15.9543 13.4155 16.6486 11.7426 16.6479 9.99865ZM150 9.99865C150 11.9769 149.412 13.911 148.309 15.5561C147.206 17.2012 145.638 18.4835 143.803 19.2408C141.968 19.9981 139.949 20.1964 138.001 19.8106C136.053 19.4248 134.263 18.4722 132.859 17.0733C131.454 15.6744 130.498 13.8921 130.111 11.9518C129.723 10.0115 129.922 8.00035 130.683 6.17273C131.443 4.34512 132.73 2.78316 134.382 1.6844C136.034 0.585641 137.975 -0.000547746 139.961 -2.16712e-05C142.624 -2.16712e-05 145.177 1.05341 147.06 2.92852C148.942 4.80364 150 7.34683 150 9.99865ZM146.568 9.99865C146.568 8.69648 146.181 7.42356 145.454 6.34088C144.728 5.2582 143.695 4.4144 142.488 3.9162C141.28 3.41801 139.951 3.28779 138.668 3.54202C137.386 3.79626 136.208 4.42352 135.284 5.34448C134.36 6.26544 133.731 7.43873 133.476 8.71594C133.221 9.99316 133.352 11.3169 133.853 12.5198C134.354 13.7227 135.201 14.7507 136.289 15.4738C137.376 16.1968 138.654 16.5825 139.961 16.582C140.829 16.582 141.689 16.4117 142.49 16.0808C143.292 15.7499 144.021 15.265 144.634 14.6536C145.248 14.0422 145.734 13.3165 146.066 12.5178C146.398 11.7191 146.569 10.8631 146.568 9.99865ZM94.2103 3.6627V19.6808H97.9116V3.6627H103.982V0.178197H88.1455V3.6627H94.2103ZM113.347 19.6808L117.262 8.19256H117.422L121.327 19.6808H125.017L128.473 0.178197H125.001L122.63 12.9991H122.411L118.838 2.27156H115.804L112.394 12.9884H112.167L109.801 0.178197H106.19L109.662 19.6781L113.347 19.6808Z\" fill=\"#1A1A1A\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_11599_25956\">\n<rect width=\"150\" height=\"20\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var svg_orka_text = "<svg width=\"155\" height=\"40\" viewBox=\"0 0 155 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_11889_16943)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 40V0H40V40H0ZM5.03497 12.4996C5.03497 16.6423 8.39268 20 12.5354 20C16.677 20 20.0358 16.6423 20.0358 12.4996C20.0358 8.35692 16.6781 4.99921 12.5354 4.99921C8.39268 4.99921 5.03497 8.35692 5.03497 12.4996ZM15.7096 15.6743C17.463 13.9209 17.463 11.0781 15.7096 9.32469C13.9562 7.57128 11.1133 7.57128 9.35994 9.32469C7.60654 11.0781 7.60654 13.9209 9.35994 15.6743C11.1133 17.4277 13.9562 17.4277 15.7096 15.6743Z\" fill=\"#1A1A1A\"/>\n<path d=\"M117.665 19.9779L128.172 7.68719H122.555L113.128 17.9515V7.68719H108.833V32.3788H113.128V24.5815L114.251 22.8194H114.736L122.907 32.3788H128.524L117.665 19.9779Z\" fill=\"#1A1A1A\"/>\n<path d=\"M104.031 15.5727C104.031 13.4813 103.2 11.4756 101.721 9.9968C100.242 8.51799 98.2368 7.68719 96.1454 7.68719H83.7886V32.3568H88.1939V23.5462H94.8018L99.2071 32.3568H104.031L99.0969 22.8634C100.553 22.279 101.801 21.2724 102.68 19.9732C103.559 18.674 104.03 17.1414 104.031 15.5727ZM95.9912 19.0308H88.2159V12.0925H95.9912C96.4482 12.0925 96.9008 12.1825 97.323 12.3574C97.7453 12.5323 98.1289 12.7886 98.4521 13.1118C98.7752 13.435 99.0316 13.8186 99.2065 14.2409C99.3814 14.6631 99.4714 15.1156 99.4714 15.5727C99.4714 16.0287 99.3812 16.4801 99.2061 16.9012C99.0309 17.3222 98.7742 17.7044 98.4507 18.0258C98.1273 18.3472 97.7435 18.6014 97.3214 18.7739C96.8992 18.9464 96.4472 19.0337 95.9912 19.0308Z\" fill=\"#1A1A1A\"/>\n<path d=\"M144.978 7.68719H138.877L129.736 32.3568H134.582L136.366 27.1586H147.379L149.097 32.3568H154.317L144.978 7.68719ZM137.775 23.1057L141.608 11.9603H142.137L145.925 23.1057H137.775Z\" fill=\"#1A1A1A\"/>\n<path d=\"M67.5992 7.4449C65.9341 7.44201 64.2848 7.76747 62.7456 8.40266C61.2065 9.03785 59.8077 9.9703 58.6293 11.1467C57.4508 12.323 56.516 13.7202 55.8781 15.2583C55.2402 16.7963 54.9119 18.445 54.9119 20.1101C54.9119 23.475 56.2486 26.702 58.6279 29.0813C61.0072 31.4606 64.2343 32.7973 67.5992 32.7973C69.2642 32.7973 70.9129 32.469 72.451 31.8311C73.989 31.1933 75.3862 30.2584 76.5626 29.08C77.7389 27.9016 78.6714 26.5028 79.3066 24.9636C79.9418 23.4245 80.2673 21.7752 80.2644 20.1101C80.2673 18.4461 79.9416 16.7978 79.3062 15.2599C78.6707 13.722 77.7379 12.3246 76.5613 11.148C75.3846 9.97133 73.9873 9.03854 72.4493 8.40308C70.9114 7.76762 69.2632 7.442 67.5992 7.4449ZM67.5992 28.4581C66.5021 28.461 65.4152 28.2471 64.4011 27.8286C63.3869 27.4101 62.4655 26.7953 61.6897 26.0195C60.914 25.2438 60.2992 24.3223 59.8807 23.3082C59.4622 22.2941 59.2482 21.2072 59.2511 20.1101C59.2511 19.0138 59.4671 17.9283 59.8866 16.9155C60.3061 15.9026 60.921 14.9824 61.6962 14.2072C62.4714 13.432 63.3917 12.8171 64.4045 12.3975C65.4173 11.978 66.5029 11.7621 67.5992 11.7621C68.7047 11.7475 69.8021 11.9527 70.8276 12.3657C71.8532 12.7787 72.7865 13.3912 73.5734 14.1679C74.3603 14.9445 74.9851 15.8697 75.4115 16.8898C75.8379 17.9099 76.0574 19.0045 76.0573 20.1101C76.0574 21.2157 75.8379 22.3103 75.4115 23.3304C74.9851 24.3505 74.3603 25.2757 73.5734 26.0523C72.7865 26.829 71.8532 27.4416 70.8276 27.8546C69.8021 28.2676 68.7047 28.4727 67.5992 28.4581Z\" fill=\"#1A1A1A\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_11889_16943\">\n<rect width=\"154.295\" height=\"40\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var OrkaLogo = function OrkaLogo(props) {
  var color = props.color,
      mobile = props.mobile;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_OrkaLogo,
    height: mobile ? '32px' : '40px',
    width: mobile ? '32px' : '40px',
    forceFill: color
  });
};

var OrkaOneLogo = function OrkaOneLogo(props) {
  var color = props.color;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_OrkaOneLogo,
    forceFill: color
  });
};

var OrkaTwoLogo = function OrkaTwoLogo(props) {
  var color = props.color;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_orka_two,
    forceFill: color
  });
};

var OrkaTextLogo = function OrkaTextLogo(props) {
  var color = props.color;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_orka_text,
    forceFill: color
  });
};

var OrkaLogoType = function OrkaLogoType(props) {
  var color = props.color;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_orka_logotype,
    forceFill: color
  });
};

var LloydLogo = function LloydLogo(props) {
  var color = props.color;
  return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
    svg: svg_lloyd_logo,
    forceFill: color
  });
};

var DownloadLogo = function DownloadLogo(props) {
  var outline = props.outline,
      black = props.black;
  var allowedBrands = ['appgallery', 'appstore', 'fdroid', 'galaxystore', 'googleplay'];
  var brand = props.brand ? props.brand.toLowerCase() : '';
  var usePC = material.useMediaQuery(theme.breakpoints.up('md'));
  var height = usePC ? 56 : 40;
  var paddingRight = usePC ? '24px' : '16px';
  var type = 'black'; // Security check
  // outline or black

  if (outline && black) {
    // cannot have both properties
    console.error("Cannot have 'outline' and 'black' properties at the same time.");
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  } else {
    if (outline) type = 'outline';else if (black) type = 'black';
  } // brand name


  if (allowedBrands.indexOf(brand.toLowerCase()) === -1) {
    console.error("brand '".concat(brand, "' not legal. Accepted name: ").concat(allowedBrands));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  }

  switch (brand) {
    case 'appgallery':
      switch (type) {
        case 'black':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: AppGalleryBlack
          });

        case 'outline':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: AppStoreOutline
          });
      }

    case 'appstore':
      switch (type) {
        case 'black':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: AppStoreBlack
          });

        case 'outline':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: AppGalleryOutline
          });
      }

    case 'fdroid':
      switch (type) {
        case 'black':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: FDroidBlack
          });

        case 'outline':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: FDroidOutline
          });
      }

    case 'galaxystore':
      switch (type) {
        case 'black':
          console.warn('[Orkaui deprecation warning] Galaxy Store black logo does not suppport SVG due to its angular gradient style. Please use external png/jpg.');
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: GalaxyStoreBlack
          });

        case 'outline':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: GalaxyStoreOutline
          });
      }

    case 'googleplay':
      switch (type) {
        case 'black':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: GooglePlayBlack
          });

        case 'outline':
          return /*#__PURE__*/React__default["default"].createElement(SvgParser, {
            sx: {
              paddingRight: paddingRight
            },
            height: height,
            svg: GooglePlayOutline
          });
      }

  }

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
};

var PageLabel = function PageLabel(props) {
  var color = props.color,
      mobile = props.mobile;
  if (!color) color = theme.palette.grey[800];

  if (!mobile) {
    return /*#__PURE__*/React__default["default"].createElement("div", _extends({}, props, {
      style: _objectSpread2({
        padding: '4px 16px 4px 12px',
        border: "1.5px solid ".concat(color),
        borderRadius: '8px 4px 24px 0px',
        display: 'inline-block'
      }, props.style)
    }), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
      variant: "subh1",
      sx: {
        color: color
      }
    }, props.children));
  } else {
    return /*#__PURE__*/React__default["default"].createElement("div", _extends({}, props, {
      style: _objectSpread2({
        padding: '4px 12px 4px 8px',
        border: "1.5px solid ".concat(color),
        borderRadius: '8px 4px 24px 0px',
        display: 'inline-block',
        color: color
      }, props.style)
    }), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
      variant: "subh2",
      sx: {
        color: color
      }
    }, props.children));
  }
};

var FloatItem = function FloatItem(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", props);
};

function ScrollFloat(props) {
  var direction = props.direction,
      pc_direction = props.pc_direction,
      mobile_direction = props.mobile_direction,
      distance = props.distance,
      pc_distance = props.pc_distance,
      mobile_distance = props.mobile_distance,
      duration = props.duration,
      pc_duration = props.pc_duration,
      mobile_duration = props.mobile_duration,
      delay = props.delay,
      threshold = props.threshold;
  var usePC = material.useMediaQuery(theme.breakpoints.up('md'));
  var animContainerRef = React__default["default"].useRef(); // Assign parent attributes

  {
    if (!pc_direction) {
      if (!direction) pc_direction = 'left';else pc_direction = direction;
    }

    if (!mobile_direction) {
      if (!direction) mobile_direction = 'bottom';else mobile_direction = direction;
    }

    if (!pc_distance) {
      if (!distance) pc_distance = '30px';else pc_distance = distance;
    }

    if (!mobile_distance) {
      if (!distance) mobile_distance = '30px';else mobile_distance = distance;
    }

    if (!pc_duration) {
      if (!duration) pc_duration = '0.3s';else pc_duration = duration;
    }

    if (!mobile_duration) {
      if (!duration) mobile_duration = '0.3s';else mobile_duration = duration;
    }

    if (!delay) {
      delay = 100;
    } else {
      delay = +delay;
    }

    if (threshold === undefined) {
      threshold = 0.5;
    } else {
      threshold = +threshold;
    }
  } // For each children, if it is a FloatItem node, record its ref into useRef - floatChildren

  var floatChildren = []; // store FloatItemRef

  floatChildren = [];
  var curIdx; // counter of iterateNode

  var iterateNode = function iterateNode(node) {
    if (node.type === 'root') {
      curIdx = 0;
      node.type = React__default["default"].Fragment;
    }

    if (!node.props.children) {
      return node;
    }

    return /*#__PURE__*/React__default["default"].createElement(node.type, _objectSpread2({}, node.props), React__default["default"].Children.map(node.props.children, function (child, idx) {
      if (child && child.type == FloatItem) {
        // FloatItem node
        // Assign child attributes
        var childTransitionProps = {};
        {
          if (!child.props.pc_direction && !child.props.direction) {
            childTransitionProps.pc_direction = pc_direction;
          } else {
            childTransitionProps.pc_direction = child.props.pc_direction ? child.props.pc_direction : child.props.direction;
          }

          if (!child.props.mobile_direction && !child.props.direction) {
            childTransitionProps.mobile_direction = mobile_direction;
          } else {
            childTransitionProps.mobile_direction = child.props.mobile_direction ? child.props.mobile_direction : child.props.direction;
          }

          if (!child.props.pc_distance && !child.props.distance) {
            childTransitionProps.pc_distance = pc_distance;
          } else {
            childTransitionProps.pc_distance = child.props.pc_distance ? child.props.pc_distance : child.props.distance;
          }

          if (!child.props.mobile_distance && !child.props.distance) {
            childTransitionProps.mobile_distance = mobile_distance;
          } else {
            childTransitionProps.mobile_distance = child.props.mobile_distance ? child.props.mobile_distance : child.props.distance;
          }

          if (!child.props.pc_duration && !child.props.duration) {
            childTransitionProps.pc_duration = pc_duration;
          } else {
            childTransitionProps.pc_duration = child.props.pc_duration ? child.props.pc_duration : child.props.duration;
          }

          if (!child.props.mobile_duration && !child.props.duration) {
            childTransitionProps.mobile_duration = mobile_duration;
          } else {
            childTransitionProps.mobile_duration = child.props.mobile_duration ? child.props.mobile_duration : child.props.duration;
          }
        }
        var normalStyle = {
          transform: "translate(0, 0)",
          transition: usePC ? childTransitionProps.pc_duration : childTransitionProps.mobile_duration,
          opacity: 1
        };
        var beforeTransitionStyle = {
          transition: usePC ? childTransitionProps.pc_duration : childTransitionProps.mobile_duration,
          opacity: 0
        };

        switch (usePC) {
          case true:
            switch (childTransitionProps.pc_direction) {
              case 'left':
                beforeTransitionStyle.transform = "translate(-".concat(childTransitionProps.pc_distance, ", 0)");
                break;

              case 'right':
                beforeTransitionStyle.transform = "translate(".concat(childTransitionProps.pc_distance, ", 0)");
                break;

              case 'top':
                beforeTransitionStyle.transform = "translate(0, -".concat(childTransitionProps.pc_distance, ")");
                break;

              case 'bottom':
                beforeTransitionStyle.transform = "translate(0, ".concat(childTransitionProps.pc_distance, ")");
                break;
            }

            break;

          case false:
            switch (childTransitionProps.mobile_direction) {
              case 'left':
                beforeTransitionStyle.transform = "translate(-".concat(childTransitionProps.mobile_distance, ", 0)");
                break;

              case 'right':
                beforeTransitionStyle.transform = "translate(".concat(childTransitionProps.mobile_distance, ", 0)");
                break;

              case 'top':
                beforeTransitionStyle.transform = "translate(0, -".concat(childTransitionProps.mobile_distance, ")");
                break;

              case 'bottom':
                beforeTransitionStyle.transform = "translate(0, ".concat(childTransitionProps.mobile_distance, ")");
                break;
            }

            break;
        }

        floatChildren.push({
          order: child.props.order
        });
        return /*#__PURE__*/React__default["default"].cloneElement(child, {
          style: showList && showList[curIdx++] ? normalStyle : beforeTransitionStyle
        });
      } else if (!child.type) {
        // pure text
        return child;
      } else {
        return iterateNode(child);
      }
    }));
  };

  var rootNode = {
    type: 'root',
    props: {
      children: React__default["default"].Children.toArray(props.children)
    }
  };
  iterateNode(rootNode); // Iterate the first time to count the number of nodes

  var _React$useState = React__default["default"].useState(floatChildren.map(function () {
    return false;
  })),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showList = _React$useState2[0],
      setShowList = _React$useState2[1]; // For each children, read its order attribute and assign orders 1 to n


  var rawOrders = floatChildren.map(function (d, i) {
    return d.order ? d.order : 0.0001 * i;
  });
  var sorted = rawOrders.slice().sort();
  var processedOrders = rawOrders.map(function (d) {
    return sorted.indexOf(d);
  });
  floatChildren = [];
  var refNode = iterateNode(rootNode); // Iterate the second time to get node

  var onIntoView = function onIntoView(entry) {
    if (entry[0].intersectionRatio >= threshold) {
      var _loop = function _loop(i) {
        setTimeout(function () {
          if (!showList[i]) {
            showList[i] = true;
            setShowList(_toConsumableArray(showList));
          }
        }, delay * processedOrders[i]);
      };

      for (var i = 0; i < showList.length; i++) {
        _loop(i);
      }
    }
  };

  React__default["default"].useEffect(function () {
    var observeOptions = {
      root: document,
      rootMargin: '0px',
      threshold: threshold
    };
    var observer = new IntersectionObserver(function (entry) {
      onIntoView(entry);
    }, observeOptions);
    observer.observe(animContainerRef.current);
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: animContainerRef
  }, refNode.props.children);
}

var _excluded$3 = ["children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Div = material.styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius = 12px;\n  padding: ", ";\n  background-color: ", ";\n"])), theme.breakpoints.up('md') ? '40px 80px' : '32px 24px', theme.palette.white.main);
var CardDiv = material.styled('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 326px;\n  height: 488px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n"])));
var TextBox = material.styled(material.Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 24px 16px;\n  border-radius: 12px 12px 0 0;\n  background-color: ", ";\n  min-height: 284px;\n"])), theme.palette.white.main);
var ButtonDiv = material.styled(material.Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  width: fit-content;\n"])));
var ImgBox = material.styled(material.Box)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n  width: 100%;\n  transition: height 1s ease-in;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  flex-grow: 1;\n  cursor: pointer;\n"])), function (props) {
  return "url(".concat(props.img, ")");
});

var Card = function Card(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React__default["default"].createElement(Div, props, children);
};

var TipCard = function TipCard(_ref2) {
  var title = _ref2.title,
      content = _ref2.content,
      img = _ref2.img,
      sx = _ref2.sx,
      imgSx = _ref2.imgSx;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  React.useEffect(function () {
    var height = document.getElementById(title).getBoundingClientRect().height;
    console.log(height);

    if (height > 250) {
      setClicked(false);
    }
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(CardDiv, {
    sx: sx
  }, /*#__PURE__*/React__default["default"].createElement(TextBox, null, /*#__PURE__*/React__default["default"].createElement(material.Box, {
    id: title,
    sx: {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      WebkitLineClamp: clicked ? '' : '9'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "h4",
    style: {
      marginBottom: '8px'
    }
  }, title), /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    id: "tipcard-content",
    variant: "body1"
  }, content)), /*#__PURE__*/React__default["default"].createElement(ButtonDiv, {
    sx: {
      visibility: clicked ? 'hidden' : 'visible'
    },
    id: "tipcard-viewmore",
    onClick: function onClick() {
      setClicked(true);
    }
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "link1",
    style: {
      margin: '16px 0 0 4px'
    }
  }, "View More"))), /*#__PURE__*/React__default["default"].createElement(ImgBox, {
    img: img,
    onClick: function onClick() {
      setClicked(false);
    },
    sx: imgSx
  }));
};

var _excluded$2 = ["cancelButtonProps", "cancelText", "cancelType", "closable", "content", "icon", "maskClosable", "okButtonProps", "okText", "okType", "onCancel", "onOk", "open", "title", "disableButtons"];

var ModalContent = function ModalContent(_ref) {
  var cancelButtonProps = _ref.cancelButtonProps,
      cancelText = _ref.cancelText;
      _ref.cancelType;
      var closable = _ref.closable,
      content = _ref.content,
      icon = _ref.icon,
      maskClosable = _ref.maskClosable,
      okButtonProps = _ref.okButtonProps,
      okText = _ref.okText;
      _ref.okType;
      var onCancel = _ref.onCancel,
      onOk = _ref.onOk,
      open = _ref.open,
      title = _ref.title,
      disableButtons = _ref.disableButtons;
      _objectWithoutProperties(_ref, _excluded$2);

  if (icon === true) icon = /*#__PURE__*/React__default["default"].createElement(Letter64__default["default"], null);
  if (maskClosable === undefined) maskClosable = true;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-root ".concat(open ? 'orkaui-modal-root-open' : 'orkaui-modal-root-close'),
    onClick: function onClick(e) {
      maskClosable && e.target === e.currentTarget && onCancel();
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-content ".concat(open ? 'orkaui-modal-content-open' : 'orkaui-modal-content-close')
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-content-main"
  }, closable && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-close-button",
    onClick: onCancel
  }, /*#__PURE__*/React__default["default"].createElement(OUIIconButton, null, /*#__PURE__*/React__default["default"].createElement(Close24__default["default"], null))), icon && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-icon"
  }, icon), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-title"
  }, /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "h4",
    textAlign: icon ? 'center' : 'auto'
  }, title)), content && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-text"
  }, typeof content === 'string' ? /*#__PURE__*/React__default["default"].createElement(OUITypography, {
    variant: "body2",
    textAlign: icon ? 'center' : 'auto'
  }, content) : content)), !disableButtons && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-buttons"
  }, (cancelText || cancelText === undefined) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-button"
  }, /*#__PURE__*/React__default["default"].createElement(OUIButton, _extends({
    variant: "secondary",
    size: "large",
    block: true
  }, cancelButtonProps, {
    handleClick: onCancel
  }), cancelText ? cancelText : 'Cancel')), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-modal-button"
  }, /*#__PURE__*/React__default["default"].createElement(OUIButton, _extends({
    variant: "primary",
    size: "large",
    block: true
  }, okButtonProps, {
    handleClick: onOk
  }), okText ? okText : 'Confirm')))));
};

function Modal(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'absolute'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ModalContent, props));
}

var _excluded$1 = ["children", "disableMobSizeAdjustment"];
function Drawer(_ref) {
  var children = _ref.children,
      disableMobSizeAdjustment = _ref.disableMobSizeAdjustment,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var useMobile = material.useMediaQuery(theme.breakpoints.down('sm'));
  material.useMediaQuery(theme.breakpoints.up('md'));
  var anchor;
  if (useMobile) anchor = 'bottom';else anchor = 'right';
  var containerRef = React.useRef(null); // automatically set header

  React.useEffect(function () {
    setTimeout(function () {
      if (containerRef.current && document.getElementsByTagName('header')[0] && !disableMobSizeAdjustment) {
        containerRef.current.style.height = window.innerHeight - document.getElementsByTagName('header')[0].offsetHeight + 'px';
      }
    }, 100);
  });
  return /*#__PURE__*/React__default["default"].createElement(MUIDrawer__default["default"], _extends({
    anchor: anchor
  }, props), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "orkaui-drawer-container",
    ref: containerRef
  }, /*#__PURE__*/React__default["default"].createElement(OUIIconButton, {
    className: "orkaui-drawer-close-icon",
    onClick: function onClick() {
      return props.onClose();
    }
  }, /*#__PURE__*/React__default["default"].createElement(Close24__default["default"], null)), children));
}

var _excluded = ["children"];
var Base = material.styled(material.Container)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    padding: '40px 16px'
  }, _defineProperty(_ref2, theme.breakpoints.up('sm'), {
    padding: '40px 80px'
  }), _defineProperty(_ref2, theme.breakpoints.up('dl'), {
    padding: '64px 108px'
  }), _ref2;
});

var Container = function Container(_ref3) {
  var children = _ref3.children,
      restProps = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Base, _extends({
    maxWidth: "lg"
  }, restProps), children);
};

Object.defineProperty(exports, 'Grid', {
  enumerable: true,
  get: function () { return material.Grid; }
});
exports.Button = OUIButton;
exports.Card = Card;
exports.Checkbox = OUICheckbox;
exports.Container = Container;
exports.Coupon = Coupon;
exports.Datepicker = DatePicker;
exports.DownloadLogo = DownloadLogo;
exports.Drawer = Drawer;
exports.Dropdown = OUIDropdown;
exports.FloatItem = FloatItem;
exports.GridBreak = GridBreak;
exports.IconButton = OUIIconButton;
exports.Input = OUIInput;
exports.InteractiveButton = InteractiveButton;
exports.LinearProgress = OUILinearProgress;
exports.LloydLogo = LloydLogo;
exports.Modal = Modal;
exports.OrkaLogo = OrkaLogo;
exports.OrkaLogoType = OrkaLogoType;
exports.OrkaOneLogo = OrkaOneLogo;
exports.OrkaTextLogo = OrkaTextLogo;
exports.OrkaTwoLogo = OrkaTwoLogo;
exports.PageLabel = PageLabel;
exports.Pagination = OUIPagination;
exports.ProgressiveReading = ProgressiveReading;
exports.Radio = OUIRadio;
exports.ScrollFloat = ScrollFloat;
exports.Section = Section;
exports.Selectbar = OUISelectbar;
exports.StepCircle = StepCircle;
exports.Switch = OUISwitch;
exports.SwitchPageLeft = SwitchPageLeft;
exports.SwitchPageRight = SwitchPageRight;
exports.Timeslot = TimeSlot;
exports.TipCard = TipCard;
exports.Tooltip = BootstrapTooltip;
exports.Typography = OUITypography;
